(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.a9.ak === region.bB.ak)
	{
		return 'on line ' + region.a9.ak;
	}
	return 'on lines ' + region.a9.ak + ' through ' + region.bB.ak;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList === 'function' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dE,
		impl.ey,
		impl.er,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		F: func(record.F),
		bb: record.bb,
		a6: record.a6
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.F;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.bb;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.a6) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dE,
		impl.ey,
		impl.er,
		function(sendToApp, initialModel) {
			var view = impl.eB;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.dE,
		impl.ey,
		impl.er,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.a7 && impl.a7(sendToApp)
			var view = impl.eB;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.c7);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.ev) && (_VirtualDom_doc.title = title = doc.ev);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.dY;
	var onUrlRequest = impl.dZ;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		a7: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.d6 === next.d6
							&& curr.dz === next.dz
							&& curr.d3.a === next.d3.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		dE: function(flags)
		{
			return A3(impl.dE, flags, _Browser_getUrl(), key);
		},
		eB: impl.eB,
		ey: impl.ey,
		er: impl.er
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { dy: 'hidden', db: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { dy: 'mozHidden', db: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { dy: 'msHidden', db: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { dy: 'webkitHidden', db: 'webkitvisibilitychange' }
		: { dy: 'hidden', db: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		cH: _Browser_getScene(),
		c1: {
			aP: _Browser_window.pageXOffset,
			aQ: _Browser_window.pageYOffset,
			aa: _Browser_doc.documentElement.clientWidth,
			R: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		aa: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		R: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			cH: {
				aa: node.scrollWidth,
				R: node.scrollHeight
			},
			c1: {
				aP: node.scrollLeft,
				aQ: node.scrollTop,
				aa: node.clientWidth,
				R: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			cH: _Browser_getScene(),
			c1: {
				aP: x,
				aQ: y,
				aa: _Browser_doc.documentElement.clientWidth,
				R: _Browser_doc.documentElement.clientHeight
			},
			di: {
				aP: x + rect.left,
				aQ: y + rect.top,
				aa: rect.width,
				R: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.dU) { flags += 'm'; }
	if (options.c9) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.by))
		{
			lang = options.by.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.dx.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.es,
		breaks: gfm && gfm.c8,
		sanitize: options.eh,
		smartypants: options.en
	};
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Main$OnUrlChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$OnUrlRequest = function (a) {
	return {$: 5, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.e) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.g),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.g);
		} else {
			var treeLen = builder.e * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.j) : builder.j;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.e);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.g) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.g);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{j: nodeList, e: (len / $elm$core$Array$branchFactor) | 0, g: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ds: fragment, dz: host, a5: path, d3: port_, d6: protocol, cu: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Datamine$RawDatamine = function (revision) {
	return function (loot) {
		return function (uniqueLoot) {
			return function (skills) {
				return function (skillASTs) {
					return function (affixes) {
						return function (cosmeticTransferTemplates) {
							return function (cosmeticWeaponDescriptors) {
								return function (gems) {
									return function (passives) {
										return function (passiveTrees) {
											return function (reagents) {
												return function (gemFamilies) {
													return function (cityProjects) {
														return function (cityProjectScaling) {
															return function (cityRewards) {
																return function (cityBuildings) {
																	return function (cityCategories) {
																		return function (cityLevels) {
																			return function (ailments) {
																				return {x: affixes, ab: ailments, ad: cityBuildings, ae: cityCategories, aA: cityLevels, af: cityProjectScaling, ag: cityProjects, ah: cityRewards, aB: cosmeticTransferTemplates, aC: cosmeticWeaponDescriptors, J: gemFamilies, aj: gems, al: loot, S: passiveTrees, ap: passives, ar: reagents, aM: revision, W: skillASTs, M: skills, Y: uniqueLoot};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm_community$result_extra$Result$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Datamine$Util$filteredJsons = function (pred) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filter(
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, pred)),
		$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Datamine$Util$resultDecoder = $elm$json$Json$Decode$andThen(
	function (r) {
		if (r.$ === 1) {
			var err = r.a;
			return $elm$json$Json$Decode$fail(err);
		} else {
			var val = r.a;
			return $elm$json$Json$Decode$succeed(val);
		}
	});
var $author$project$Datamine$Skill$SkillAST = F4(
	function (source, name, variants, modifiers) {
		return {cf: modifiers, q: name, cS: source, c0: variants};
	});
var $author$project$Datamine$Skill$SkillASTVariant = F4(
	function (source, uid, level, cost) {
		return {dd: cost, dL: level, cS: source, be: uid};
	});
var $author$project$Datamine$Skill$SkillModifier = F6(
	function (xp, level, effect, param1, param2, uiDesc) {
		return {bA: effect, dL: level, aK: param1, aL: param2, cZ: uiDesc, eD: xp};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$Datamine$Source$Source = F2(
	function (file, node) {
		return {dq: file, dW: node};
	});
var $author$project$Datamine$Source$DecodingAttrs = function (a) {
	return {$: 1, a: a};
};
var $author$project$Datamine$Source$DecodingEmptyNode = function (a) {
	return {$: 2, a: a};
};
var $author$project$Datamine$Source$DecodingSourceNode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Datamine$Source$SourceNode = F3(
	function (attrs, children, tag) {
		return {aR: attrs, aS: children, N: tag};
	});
var $author$project$Datamine$Source$SourceNodeChildren = $elm$core$Basics$identity;
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Datamine$Util$single_ = function (vals) {
	if (vals.b && (!vals.b.b)) {
		var val = vals.a;
		return $elm$json$Json$Decode$succeed(val);
	} else {
		return $elm$json$Json$Decode$fail(
			'`single` expected 1 item, got ' + $elm$core$String$fromInt(
				$elm$core$List$length(vals)));
	}
};
var $author$project$Datamine$Util$single = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$list,
	$elm$json$Json$Decode$andThen($author$project$Datamine$Util$single_));
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
function $author$project$Datamine$Source$cyclic$sourceNodeDecoder() {
	return A3(
		$elm$json$Json$Decode$map2,
		$author$project$Datamine$Source$SourceNode,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'$',
					$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string)))),
		$author$project$Datamine$Util$resultDecoder(
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(
						function (_v1) {
							var k = _v1.a;
							var v = _v1.b;
							return k !== '$';
						}),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							function (_v2) {
								var k = _v2.a;
								var mv = _v2.b;
								_v3$2:
								while (true) {
									switch (mv.$) {
										case 0:
											var nodes = mv.a;
											return $elm$core$Result$Ok(
												A2(
													$elm$core$List$map,
													function (n) {
														return n(k);
													},
													nodes));
										case 2:
											if (mv.a === '') {
												return $elm$core$Result$Ok(_List_Nil);
											} else {
												break _v3$2;
											}
										default:
											break _v3$2;
									}
								}
								return $elm$core$Result$Err('decodeSourceNode fail');
							}),
						A2(
							$elm$core$Basics$composeR,
							$elm_community$result_extra$Result$Extra$combine,
							$elm$core$Result$map(
								A2($elm$core$Basics$composeR, $elm$core$List$concat, $elm$core$Basics$identity))))),
				$elm$json$Json$Decode$keyValuePairs(
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return $elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$json$Json$Decode$map,
										$author$project$Datamine$Source$DecodingSourceNode,
										$elm$json$Json$Decode$list(
											$author$project$Datamine$Source$cyclic$sourceNodeDecoder())),
										A2(
										$elm$json$Json$Decode$map,
										$author$project$Datamine$Source$DecodingEmptyNode,
										$author$project$Datamine$Util$single($elm$json$Json$Decode$string)),
										A2(
										$elm$json$Json$Decode$map,
										$author$project$Datamine$Source$DecodingAttrs,
										$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$string))
									]));
						})))));
}
var $author$project$Datamine$Source$sourceNodeDecoder = $author$project$Datamine$Source$cyclic$sourceNodeDecoder();
$author$project$Datamine$Source$cyclic$sourceNodeDecoder = function () {
	return $author$project$Datamine$Source$sourceNodeDecoder;
};
var $author$project$Datamine$Source$decoder = F2(
	function (file, tag) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Datamine$Source$Source(file),
			A2(
				$elm$json$Json$Decode$map,
				function (n) {
					return n(tag);
				},
				$author$project$Datamine$Source$sourceNodeDecoder));
	});
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Datamine$Util$floatString = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $elm$core$String$toFloat(s);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('expected a float, got: ' + s);
		} else {
			var i = _v0.a;
			return $elm$json$Json$Decode$succeed(i);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Datamine$Util$intString = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		var _v0 = $elm$core$String$toInt(s);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('expected an int, got: ' + s);
		} else {
			var i = _v0.a;
			return $elm$json$Json$Decode$succeed(i);
		}
	},
	$elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Datamine$Skill$skillASTDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['MetaData', 'AST']),
		$author$project$Datamine$Util$single(
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['SkillModifier']),
					$elm$json$Json$Decode$list(
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'UIDesc']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'Param2']),
								$author$project$Datamine$Util$floatString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'Param1']),
									$author$project$Datamine$Util$floatString,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['$', 'Effect']),
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['$', 'Level']),
											$author$project$Datamine$Util$intString,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
												_List_fromArray(
													['$', 'XP']),
												$author$project$Datamine$Util$intString,
												$elm$json$Json$Decode$succeed($author$project$Datamine$Skill$SkillModifier))))))))),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['SkillVariant']),
						$elm$json$Json$Decode$list(
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'Cost']),
								$author$project$Datamine$Util$intString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'Level']),
									$author$project$Datamine$Util$intString,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['$', 'UID']),
										$elm$json$Json$Decode$string,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A2($author$project$Datamine$Source$decoder, file, 'SkillVariant'),
											$elm$json$Json$Decode$succeed($author$project$Datamine$Skill$SkillASTVariant))))))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'Name']),
						$elm$json$Json$Decode$string,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($author$project$Datamine$Source$decoder, file, 'AST'),
							$elm$json$Json$Decode$succeed($author$project$Datamine$Skill$SkillAST)))))));
};
var $author$project$Datamine$Skill$astsDecoder = $author$project$Datamine$Util$resultDecoder(
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$result_extra$Result$Extra$combine,
			$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$map(
				function (_v0) {
					var f = _v0.a;
					var d = _v0.b;
					return A2(
						$elm$json$Json$Decode$decodeValue,
						$author$project$Datamine$Skill$skillASTDecoder(f),
						d);
				}),
			$author$project$Datamine$Util$filteredJsons(
				$elm$core$String$contains('/Skills/Trees/ActiveSkills/')))));
var $author$project$Datamine$City$Building = F7(
	function (source, name, baseProduction, uiName, uiLore, projects, rolledProjects) {
		return {c6: baseProduction, q: name, ct: projects, cE: rolledProjects, cS: source, aO: uiLore, av: uiName};
	});
var $author$project$Datamine$City$BuildingRolledProject = F3(
	function (projectName, weight, difficulty) {
		return {aU: difficulty, cs: projectName, _: weight};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Datamine$City$buildingsDecoder = function () {
	var file = 'Game/Umbra/CityBuilding/Buildings/buildings.json';
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'Building']),
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['RolledProjects', '0', 'RolledProjectParams']),
				$elm$json$Json$Decode$list(
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'Difficulty']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'Weight']),
							$author$project$Datamine$Util$intString,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'ProjectName']),
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Datamine$City$BuildingRolledProject))))),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['ProjectList', '0', 'ProjectParams']),
					$elm$json$Json$Decode$list(
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['$', 'ProjectName']),
							$elm$json$Json$Decode$string)),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['UIParams', '0', '$', 'UILore']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['UIParams', '0', '$', 'UIName']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'BaseProduction']),
								$author$project$Datamine$Util$intString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'Name']),
									$elm$json$Json$Decode$string,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A2($author$project$Datamine$Source$decoder, file, 'Building'),
										$elm$json$Json$Decode$succeed($author$project$Datamine$City$Building))))))))));
}();
var $author$project$Datamine$City$Category = F4(
	function (source, name, uiName, order) {
		return {q: name, d0: order, cS: source, av: uiName};
	});
var $author$project$Datamine$City$categoriesDecoder = function () {
	var file = 'Game/Umbra/CityBuilding/Categories/categories.json';
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'Category']),
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['$', 'Order']),
				$author$project$Datamine$Util$intString,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'UIName']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'Name']),
						$elm$json$Json$Decode$string,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($author$project$Datamine$Source$decoder, file, 'Category'),
							$elm$json$Json$Decode$succeed($author$project$Datamine$City$Category)))))));
}();
var $author$project$Datamine$Affix$Affixes = F2(
	function (magic, nonmagic) {
		return {aH: magic, ch: nonmagic};
	});
var $author$project$Datamine$Affix$MagicAffix = F8(
	function (source, affixId, _class, type_, tier, effects, drop, enslaved) {
		return {ax: affixId, bt: _class, bz: drop, aW: effects, dj: enslaved, cS: source, et: tier, ex: type_};
	});
var $author$project$Datamine$Affix$DropParams = F8(
	function (frequency, craftOnly, sarisel, itemLevel, mandatoryKeywords, optionalKeywords, rarity, hunt) {
		return {de: craftOnly, dt: frequency, dA: hunt, dH: itemLevel, dO: mandatoryKeywords, d$: optionalKeywords, d8: rarity, ei: sarisel};
	});
var $author$project$Datamine$Util$Range = F2(
	function (min, max) {
		return {dQ: max, dS: min};
	});
var $author$project$Datamine$Util$boolString = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return $elm$json$Json$Decode$succeed((s !== '0') && (s !== ''));
	},
	$elm$json$Json$Decode$string);
var $elm$core$String$trim = _String_trim;
var $author$project$Datamine$Util$csStrings = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$split(','),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($elm$core$String$trim),
			$elm$core$List$filter(
				$elm$core$Basics$neq('')))),
	$elm$json$Json$Decode$string);
var $author$project$Datamine$Affix$Rarity = F4(
	function (magic, rare, set, legendary) {
		return {dK: legendary, aH: magic, d7: rare, el: set};
	});
var $author$project$Datamine$Affix$rarityDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['$', 'Legendary']),
	$author$project$Datamine$Util$boolString,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['$', 'Set']),
		$author$project$Datamine$Util$boolString,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['$', 'Rare']),
			$author$project$Datamine$Util$boolString,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['$', 'Magic']),
				$author$project$Datamine$Util$boolString,
				false,
				$elm$json$Json$Decode$succeed($author$project$Datamine$Affix$Rarity)))));
var $author$project$Datamine$Affix$dropParamsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['$', 'Hunt']),
	$author$project$Datamine$Util$boolString,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['ItemRarity', '0']),
		$author$project$Datamine$Affix$rarityDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['Keywords', '0', '$', 'OptionalKeywords']),
			$author$project$Datamine$Util$csStrings,
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['Keywords', '0', '$', 'MandatoryKeywords']),
				$author$project$Datamine$Util$csStrings,
				_List_Nil,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					A3(
						$elm$json$Json$Decode$map2,
						$author$project$Datamine$Util$Range,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['ItemLevel', '0', '$', 'LevelMin']),
							$author$project$Datamine$Util$intString),
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['ItemLevel', '0', '$', 'LevelMax']),
							$author$project$Datamine$Util$intString)),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['$', 'Sarisel']),
						$author$project$Datamine$Util$boolString,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['$', 'CraftOnly']),
							$author$project$Datamine$Util$boolString,
							false,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'Frequency']),
								$author$project$Datamine$Util$intString,
								$elm$json$Json$Decode$succeed($author$project$Datamine$Affix$DropParams)))))))));
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Datamine$Affix$enslavedDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['$', 'EnslavedClass']),
				$elm$json$Json$Decode$string))));
var $author$project$Datamine$Affix$MagicEffect = F2(
	function (effectId, stats) {
		return {ai: effectId, ba: stats};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Datamine$Affix$magicEffectStatsDecoder = $author$project$Datamine$Util$resultDecoder(
	A2(
		$elm$json$Json$Decode$map,
		function (_v0) {
			var mins = _v0.a;
			var maxs = _v0.b;
			var maxd = $elm$core$Dict$fromList(maxs);
			return (!_Utils_eq(
				A2($elm$core$List$map, $elm$core$Tuple$first, maxs),
				A2($elm$core$List$map, $elm$core$Tuple$first, mins))) ? $elm$core$Result$Err(
				'magicEffectStats have different lo/hi keys: ' + A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$map, $elm$core$Tuple$first, mins))) : $elm_community$result_extra$Result$Extra$combine(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var min = _v1.b;
						return A2(
							$elm$core$Result$fromMaybe,
							'magicEffectStats missing max key: ' + key,
							A2(
								$elm$core$Maybe$map,
								function (max) {
									return _Utils_Tuple2(
										key,
										{dQ: max, dS: min});
								},
								A2($elm$core$Dict$get, key, maxd)));
					},
					mins));
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['LoRoll', '0', '$']),
				$elm$json$Json$Decode$keyValuePairs($author$project$Datamine$Util$floatString)),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['HiRoll', '0', '$']),
				$elm$json$Json$Decode$keyValuePairs($author$project$Datamine$Util$floatString)))));
var $author$project$Datamine$Affix$magicEffectDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Datamine$Affix$magicEffectStatsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['$', 'EffectId']),
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Datamine$Affix$MagicEffect)));
var $author$project$Datamine$Affix$magicAffixesDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['MetaData', 'Affix']),
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['Enslaved']),
				$author$project$Datamine$Affix$enslavedDecoder,
				_List_Nil,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['DropParams']),
						$author$project$Datamine$Util$single($author$project$Datamine$Affix$dropParamsDecoder)),
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['MagicEffect']),
							$elm$json$Json$Decode$list($author$project$Datamine$Affix$magicEffectDecoder)),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'Tier']),
							$author$project$Datamine$Util$intString,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'AffixType']),
								$elm$json$Json$Decode$string,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['$', 'Class']),
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['$', 'AffixId']),
										$elm$json$Json$Decode$string,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A2($author$project$Datamine$Source$decoder, file, 'Affix'),
											$elm$json$Json$Decode$succeed($author$project$Datamine$Affix$MagicAffix)))))))))));
};
var $author$project$Datamine$Affix$NonmagicAffix = F3(
	function (source, affixId, effects) {
		return {ax: affixId, aW: effects, cS: source};
	});
var $author$project$Datamine$Affix$nonmagicAffixesDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['MetaData', 'Affix']),
		$elm$json$Json$Decode$list(
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['MagicEffect']),
					$elm$json$Json$Decode$list($author$project$Datamine$Affix$magicEffectDecoder)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'AffixId']),
					$elm$json$Json$Decode$string,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($author$project$Datamine$Source$decoder, file, 'Affix'),
						$elm$json$Json$Decode$succeed($author$project$Datamine$Affix$NonmagicAffix))))));
};
var $author$project$Datamine$Affix$decoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Datamine$Affix$Affixes,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$concat,
		$author$project$Datamine$Util$resultDecoder(
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm_community$result_extra$Result$Extra$combine,
					$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$List$map(
						function (_v0) {
							var filename = _v0.a;
							var json = _v0.b;
							return A2(
								$elm$json$Json$Decode$decodeValue,
								$author$project$Datamine$Affix$magicAffixesDecoder(filename),
								json);
						}),
					$author$project$Datamine$Util$filteredJsons(
						function (f) {
							return A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesArmors', f) || (A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesWeapons', f) || (A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesAccessories', f) || (A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesMasterSlavesAccessories', f) || (A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesMasterSlavesArmors', f) || (A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesMasterSlavesShield', f) || (A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesMastersSlavesMagicWeapons', f) || A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesMastersSlavesPhysicalWeapons', f)))))));
						}))))),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$concat,
		$author$project$Datamine$Util$resultDecoder(
			A2(
				$elm$json$Json$Decode$map,
				A2(
					$elm$core$Basics$composeR,
					$elm_community$result_extra$Result$Extra$combine,
					$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$List$map(
						function (_v1) {
							var filename = _v1.a;
							var json = _v1.b;
							return A2(
								$elm$json$Json$Decode$decodeValue,
								$author$project$Datamine$Affix$nonmagicAffixesDecoder(filename),
								json);
						}),
					$author$project$Datamine$Util$filteredJsons(
						function (f) {
							return A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesImplicit', f) || (A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesUniques', f) || A2($elm$core$String$contains, '/Loot/MagicEffects/Affixes/Armors_Weapons/AffixesGems', f));
						}))))));
var $author$project$Datamine$Ailment$Ailment = F3(
	function (name, source, params) {
		return {q: name, d1: params, cS: source};
	});
var $author$project$Datamine$Ailment$AilmentParam = F2(
	function (level, values) {
		return {dL: level, eA: values};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Datamine$Ailment$ailmentDecoder = F2(
	function (file, name) {
		return A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				[file, 'MetaData']),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'Params',
				$elm$json$Json$Decode$list(
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$']),
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$List$filter(
								function (_v0) {
									var k = _v0.a;
									var v = _v0.b;
									return k !== 'Level';
								}),
							$elm$json$Json$Decode$keyValuePairs($author$project$Datamine$Util$floatString)),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'Level']),
							$author$project$Datamine$Util$intString,
							$elm$json$Json$Decode$succeed($author$project$Datamine$Ailment$AilmentParam)))),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					A2($author$project$Datamine$Source$decoder, file, 'MetaData'),
					$elm$json$Json$Decode$succeed(
						$author$project$Datamine$Ailment$Ailment(name)))));
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Datamine$Ailment$oldRevisions = $elm$core$Set$fromList(
	_List_fromArray(
		['1.0.6.0_ER', '1.0.4.3_ER']));
var $author$project$Datamine$Ailment$decoder = function (buildRevision) {
	return A2($elm$core$Set$member, buildRevision, $author$project$Datamine$Ailment$oldRevisions) ? $elm$json$Json$Decode$succeed(_List_Nil) : A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$reverse,
		A3(
			$elm$core$List$foldl,
			function (d) {
				return A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$map(
						F2(
							function (ails, ail) {
								return A2($elm$core$List$cons, ail, ails);
							})),
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom(d));
			},
			$elm$json$Json$Decode$succeed(_List_Nil),
			_List_fromArray(
				[
					A2($author$project$Datamine$Ailment$ailmentDecoder, 'Game/Umbra/Gameplay/Curve_StatusAilments/Bleed.json', 'Bleed'),
					A2($author$project$Datamine$Ailment$ailmentDecoder, 'Game/Umbra/Gameplay/Curve_StatusAilments/Burn.json', 'Burn'),
					A2($author$project$Datamine$Ailment$ailmentDecoder, 'Game/Umbra/Gameplay/Curve_StatusAilments/Poison.json', 'Poison'),
					A2($author$project$Datamine$Ailment$ailmentDecoder, 'Game/Umbra/Gameplay/Curve_StatusAilments/Shock.json', 'Shock')
				])));
};
var $author$project$Datamine$Gem$Gem = F9(
	function (source, name, uiName, hudPicture, levelPrereq, gemTier, dropLevel, keywords, effects) {
		return {dh: dropLevel, aW: effects, dv: gemTier, b2: hudPicture, dI: keywords, dM: levelPrereq, q: name, cS: source, av: uiName};
	});
var $author$project$Datamine$Gem$Defensive = function (a) {
	return {$: 1, a: a};
};
var $author$project$Datamine$Gem$Offensive = function (a) {
	return {$: 0, a: a};
};
var $author$project$Datamine$Gem$Support = function (a) {
	return {$: 2, a: a};
};
var $author$project$Datamine$Gem$gemEffectsDecoder = $author$project$Datamine$Util$single(
	$author$project$Datamine$Util$resultDecoder(
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function (_v0) {
						var key = _v0.a;
						var id = _v0.b;
						var _v1 = A2($elm$core$String$split, '_', key);
						if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
							var type_ = _v1.a;
							var _v2 = _v1.b;
							var index_ = _v2.a;
							var _v3 = _Utils_Tuple2(
								type_,
								$elm$core$String$toInt(index_));
							_v3$3:
							while (true) {
								if (!_v3.b.$) {
									switch (_v3.a) {
										case 'Offensive':
											var i = _v3.b.a;
											return $elm$core$Result$Ok(
												_Utils_Tuple2(
													$author$project$Datamine$Gem$Offensive(i),
													id));
										case 'Defensive':
											var i = _v3.b.a;
											return $elm$core$Result$Ok(
												_Utils_Tuple2(
													$author$project$Datamine$Gem$Defensive(i),
													id));
										case 'Support':
											var i = _v3.b.a;
											return $elm$core$Result$Ok(
												_Utils_Tuple2(
													$author$project$Datamine$Gem$Support(i),
													id));
										default:
											break _v3$3;
									}
								} else {
									break _v3$3;
								}
							}
							return $elm$core$Result$Err('unknown gem-effect key: ' + key);
						} else {
							return $elm$core$Result$Err('unknown gem-effect key: ' + key);
						}
					}),
				$elm_community$result_extra$Result$Extra$combine),
			$elm$json$Json$Decode$keyValuePairs(
				$author$project$Datamine$Util$single(
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['$', 'Id']),
						$elm$json$Json$Decode$string))))));
var $author$project$Datamine$Gem$decoder = function () {
	var file = 'Game/Umbra/Loot/Gems/gems.json';
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'Gems', 'Gem']),
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['SupportedMagicEffects']),
				$author$project$Datamine$Gem$gemEffectsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'Keywords']),
					$author$project$Datamine$Util$csStrings,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'MaxDropLevel']),
							$author$project$Datamine$Util$intString,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'MinDropLevel']),
								$author$project$Datamine$Util$intString,
								$elm$json$Json$Decode$succeed($author$project$Datamine$Util$Range))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'GemTier']),
							$author$project$Datamine$Util$intString,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'LevelPrereq']),
								$author$project$Datamine$Util$intString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'HUDPicture']),
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['$', 'UIName']),
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
											_List_fromArray(
												['$', 'Name']),
											$elm$json$Json$Decode$string,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												A2($author$project$Datamine$Source$decoder, file, 'Gem'),
												$elm$json$Json$Decode$succeed($author$project$Datamine$Gem$Gem))))))))))));
}();
var $author$project$Datamine$GemFamily$GemFamily = F4(
	function (source, gemFamilyId, relatedGems, craftRelatedAffixes) {
		return {df: craftRelatedAffixes, bU: gemFamilyId, ec: relatedGems, cS: source};
	});
var $author$project$Datamine$GemFamily$RelatedGem = F2(
	function (tier, gemId) {
		return {du: gemId, et: tier};
	});
var $author$project$Datamine$GemFamily$decoder = function () {
	var file = 'Game/Umbra/Loot/MagicEffects/Affixes/Craft/GemFamiliesAndCoveredEffectIDs.json';
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'GemFamily']),
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['CraftRelatedAffixes', '0', 'Entry']),
				$elm$json$Json$Decode$list(
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['$', 'EffectId']),
						$elm$json$Json$Decode$string)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['RelatedGems', '0', 'Gem']),
					$elm$json$Json$Decode$list(
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'GemId']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'Tier']),
								$author$project$Datamine$Util$intString,
								$elm$json$Json$Decode$succeed($author$project$Datamine$GemFamily$RelatedGem)))),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'GemFamilyId']),
						$elm$json$Json$Decode$string,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($author$project$Datamine$Source$decoder, file, 'GemFamily'),
							$elm$json$Json$Decode$succeed($author$project$Datamine$GemFamily$GemFamily)))))));
}();
var $author$project$Datamine$NormalItem$Accessory = F7(
	function (source, name, uiName, levelPrereq, keywords, implicitAffixes, hudPicture) {
		return {b2: hudPicture, D: implicitAffixes, dI: keywords, dM: levelPrereq, q: name, cS: source, av: uiName};
	});
var $author$project$Datamine$NormalItem$Armor = function (source) {
	return function (name) {
		return function (uiName) {
			return function (levelPrereq) {
				return function (keywords) {
					return function (implicitAffixes) {
						return function (attachmentName) {
							return function (healthBonus) {
								return function (forceShield) {
									return function (allResistance) {
										return {bh: allResistance, bi: attachmentName, bO: forceShield, b_: healthBonus, D: implicitAffixes, dI: keywords, dM: levelPrereq, q: name, cS: source, av: uiName};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Datamine$NormalItem$NAccessory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Datamine$NormalItem$NArmor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Datamine$NormalItem$commonLootDecoder = A2(
	$elm$core$Basics$composeR,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['$', 'Name']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$core$Basics$composeR,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['$', 'UIName']),
			$elm$json$Json$Decode$string),
		A2(
			$elm$core$Basics$composeR,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['$', 'LevelPrereq']),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Datamine$Util$intString),
				$elm$core$Maybe$Nothing),
			A2(
				$elm$core$Basics$composeR,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'Keywords']),
					$author$project$Datamine$Util$csStrings),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['$', 'ImplicitAffixes']),
					$author$project$Datamine$Util$csStrings,
					_List_Nil)))));
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Datamine$NormalItem$normalArmorsDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'Armors']),
		$author$project$Datamine$Util$single(
			A2(
				$elm$json$Json$Decode$field,
				'Item',
				$elm$json$Json$Decode$list(
					A2(
						$elm$json$Json$Decode$andThen,
						function (kws) {
							return A2($elm$core$Set$member, 'accessory', kws) ? A2(
								$elm$json$Json$Decode$map,
								$author$project$Datamine$NormalItem$NAccessory,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'HUDPicture']),
									$elm$json$Json$Decode$string,
									$author$project$Datamine$NormalItem$commonLootDecoder(
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A2($author$project$Datamine$Source$decoder, file, 'Item'),
											$elm$json$Json$Decode$succeed($author$project$Datamine$NormalItem$Accessory))))) : A2(
								$elm$json$Json$Decode$map,
								$author$project$Datamine$NormalItem$NArmor,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'AllResistanceMin']),
												$author$project$Datamine$Util$intString)),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'AllResistanceMax']),
												$author$project$Datamine$Util$intString))),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A3(
											$elm$json$Json$Decode$map2,
											$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'ForceShieldMin']),
													$author$project$Datamine$Util$intString)),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'ForceShieldMax']),
													$author$project$Datamine$Util$intString))),
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A3(
												$elm$json$Json$Decode$map2,
												$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['$', 'HealthBonusMin']),
														$author$project$Datamine$Util$intString)),
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['$', 'HealthBonusMax']),
														$author$project$Datamine$Util$intString))),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
												_List_fromArray(
													['$', 'AttachmentName']),
												$elm$json$Json$Decode$string,
												$author$project$Datamine$NormalItem$commonLootDecoder(
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
														A2($author$project$Datamine$Source$decoder, file, 'Item'),
														$elm$json$Json$Decode$succeed($author$project$Datamine$NormalItem$Armor))))))));
						},
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Set$fromList,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['$', 'Keywords']),
								$author$project$Datamine$Util$csStrings)))))));
};
var $author$project$Datamine$NormalItem$NShield = function (a) {
	return {$: 1, a: a};
};
var $author$project$Datamine$NormalItem$NWeapon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Datamine$NormalItem$Shield = F9(
	function (source, name, uiName, levelPrereq, keywords, implicitAffixes, shieldResistance, shieldBlockChance, shieldBlockEfficiency) {
		return {D: implicitAffixes, dI: keywords, dM: levelPrereq, q: name, cK: shieldBlockChance, cL: shieldBlockEfficiency, cM: shieldResistance, cS: source, av: uiName};
	});
var $author$project$Datamine$NormalItem$Weapon = F8(
	function (source, name, uiName, levelPrereq, keywords, implicitAffixes, damage, resourceGain) {
		return {bw: damage, D: implicitAffixes, dI: keywords, dM: levelPrereq, q: name, cB: resourceGain, cS: source, av: uiName};
	});
var $author$project$Datamine$NormalItem$normalWeaponsDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'Weapons']),
		$author$project$Datamine$Util$single(
			A2(
				$elm$json$Json$Decode$field,
				'Item',
				$elm$json$Json$Decode$list(
					A2(
						$elm$json$Json$Decode$andThen,
						function (kws) {
							return A2($elm$core$Set$member, 'shield', kws) ? A2(
								$elm$json$Json$Decode$map,
								$author$project$Datamine$NormalItem$NShield,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'ShieldBlockEfficiencyMin']),
												$author$project$Datamine$Util$intString)),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'ShieldBlockEfficiencyMax']),
												$author$project$Datamine$Util$intString))),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A3(
											$elm$json$Json$Decode$map2,
											$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'ShieldBlockChanceMin']),
													$author$project$Datamine$Util$intString)),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'ShieldBlockChanceMax']),
													$author$project$Datamine$Util$intString))),
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A3(
												$elm$json$Json$Decode$map2,
												$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['$', 'ShieldResistanceMin']),
														$author$project$Datamine$Util$intString)),
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['$', 'ShieldResistanceMax']),
														$author$project$Datamine$Util$intString))),
											$author$project$Datamine$NormalItem$commonLootDecoder(
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
													A2($author$project$Datamine$Source$decoder, file, 'Item'),
													$elm$json$Json$Decode$succeed($author$project$Datamine$NormalItem$Shield))))))) : A2(
								$elm$json$Json$Decode$map,
								$author$project$Datamine$NormalItem$NWeapon,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'ResourceGain_Min']),
												$author$project$Datamine$Util$intString)),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'ResourceGain_Max']),
												$author$project$Datamine$Util$intString))),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A3(
											$elm$json$Json$Decode$map2,
											$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'LowDamage_Max']),
													$author$project$Datamine$Util$intString)),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'HighDamage_Max']),
													$author$project$Datamine$Util$intString))),
										$author$project$Datamine$NormalItem$commonLootDecoder(
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												A2($author$project$Datamine$Source$decoder, file, 'Item'),
												$elm$json$Json$Decode$succeed($author$project$Datamine$NormalItem$Weapon))))));
						},
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Set$fromList,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['$', 'Keywords']),
								$author$project$Datamine$Util$csStrings)))))));
};
var $author$project$Datamine$NormalItem$decoder = A3(
	$elm$core$List$foldl,
	function (di) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$map($elm$core$Basics$append),
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom(di));
	},
	$elm$json$Json$Decode$succeed(_List_Nil),
	_List_fromArray(
		[
			$author$project$Datamine$NormalItem$normalWeaponsDecoder('Game/Umbra/Loot/Weapons/Weapons.json'),
			$author$project$Datamine$NormalItem$normalWeaponsDecoder('Game/Umbra/Loot/Weapons/Shields.json'),
			$author$project$Datamine$NormalItem$normalArmorsDecoder('Game/Umbra/Loot/Armors/Armors.json'),
			$author$project$Datamine$NormalItem$normalArmorsDecoder('Game/Umbra/Loot/Armors/Accessories.json')
		]));
var $author$project$Datamine$Passive$Passive = F6(
	function (source, name, uiName, hudLoreDesc, gameplayDesc, effects) {
		return {aW: effects, bP: gameplayDesc, b1: hudLoreDesc, q: name, cS: source, av: uiName};
	});
var $author$project$Datamine$Util$nonemptyString = A2(
	$elm$json$Json$Decode$map,
	function (s) {
		return (s === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
	},
	$elm$json$Json$Decode$string);
var $author$project$Datamine$Passive$PassiveEffect = F3(
	function (name, hudDesc, semantics) {
		return {b0: hudDesc, q: name, cI: semantics};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Datamine$Passive$passiveEffectsDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['MagicEffects']),
	$author$project$Datamine$Util$single(
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['EIM']),
			$elm$json$Json$Decode$list(
				A4(
					$elm$json$Json$Decode$map3,
					$author$project$Datamine$Passive$PassiveEffect,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['$', 'Name']),
						$elm$json$Json$Decode$string),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['$', 'HUDDesc']),
						$author$project$Datamine$Util$nonemptyString),
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['Semantics', '0', '$']),
						$elm$json$Json$Decode$keyValuePairs($author$project$Datamine$Util$floatString)))))));
var $author$project$Datamine$Passive$passivesDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['MetaData', 'Spell']),
		$elm$json$Json$Decode$list(
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Datamine$Passive$passiveEffectsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'GameplayDesc']),
					$author$project$Datamine$Util$nonemptyString,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'HUDLoreDesc']),
						$author$project$Datamine$Util$nonemptyString,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'UIName']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'Name']),
								$elm$json$Json$Decode$string,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A2($author$project$Datamine$Source$decoder, file, 'Spell'),
									$elm$json$Json$Decode$succeed($author$project$Datamine$Passive$Passive)))))))));
};
var $author$project$Datamine$Passive$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$concat,
	$author$project$Datamine$Util$resultDecoder(
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$result_extra$Result$Extra$combine,
				$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$map(
					function (_v0) {
						var filename = _v0.a;
						var json = _v0.b;
						return A2(
							$elm$json$Json$Decode$decodeValue,
							$author$project$Datamine$Passive$passivesDecoder(filename),
							json);
					}),
				$author$project$Datamine$Util$filteredJsons(
					$elm$core$String$contains('Skills/Passive/PST'))))));
var $author$project$Datamine$Reagent$Reagent = F7(
	function (source, name, uiName, gameplayDesc, lore, hudPicture, reagentType) {
		return {bP: gameplayDesc, b2: hudPicture, cb: lore, q: name, d9: reagentType, cS: source, av: uiName};
	});
var $author$project$Datamine$Reagent$decoder = function () {
	var file = 'Game/Umbra/Loot/Reagents/Reagents.json';
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'Reagents', 'Reagent']),
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['$', 'ReagentType']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'HUDPicture']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'Lore']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'GameplayDesc']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'UIName']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'Name']),
									$elm$json$Json$Decode$string,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A2($author$project$Datamine$Source$decoder, file, 'Reagent'),
										$elm$json$Json$Decode$succeed($author$project$Datamine$Reagent$Reagent))))))))));
}();
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Datamine$Skill$ignoredSkills = _List_fromArray(
	['ActiveDodge', 'AutoDash', 'DeathMark_Explosion', 'FrostLance_Explosion', 'FrostNova_Zone_Shadow', 'FrostNova_Zone', 'UsePotion', 'Introduction_LightningAttack']);
var $elm$core$Basics$not = _Basics_not;
var $author$project$Datamine$Skill$SkillDecoder = F7(
	function (source, uid, uiName, hudPicture, hudPictureVariant, lore, keywords) {
		return {b2: hudPicture, b3: hudPictureVariant, dI: keywords, cb: lore, cS: source, av: uiName, be: uid};
	});
var $author$project$Datamine$Skill$skillDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (els) {
			if (els.b) {
				var s = els.a;
				var vs = els.b;
				var _v1 = _Utils_Tuple2(s.av, s.b2);
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var uiName = _v1.a.a;
						var hudPicture = _v1.b.a;
						return $elm$json$Json$Decode$succeed(
							{
								b2: hudPicture,
								dI: A2($elm$core$Maybe$withDefault, _List_Nil, s.dI),
								cb: s.cb,
								cS: s.cS,
								av: uiName,
								be: s.be,
								c0: A2(
									$elm$core$List$filterMap,
									function (v) {
										return A3(
											$elm$core$Maybe$map2,
											F2(
												function (vUiName, vHudPicture) {
													return {b2: vHudPicture, cb: v.cb, cS: v.cS, av: vUiName, be: v.be};
												}),
											v.av,
											v.b3);
									},
									vs)
							});
					} else {
						var _v3 = _v1.b;
						return $elm$json$Json$Decode$fail('no skill.hudPicture for skill: ' + s.be);
					}
				} else {
					var _v2 = _v1.a;
					return $elm$json$Json$Decode$fail('no skill.uiname for skill: ' + s.be);
				}
			} else {
				return $elm$json$Json$Decode$fail('skill has no instances');
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['MetaData', 'Skill']),
			$elm$json$Json$Decode$list(
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['HUD', '0', '$', 'Keywords']),
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Datamine$Util$csStrings),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
						_List_fromArray(
							['HUD', '0', '$', 'Lore']),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
							_List_fromArray(
								['HUD', '0', '$', 'HUDPictureVariant_Normal']),
							A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
								_List_fromArray(
									['HUD', '0', '$', 'HUDPicture']),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
									_List_fromArray(
										['HUD', '0', '$', 'UIName']),
									A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['$', 'UID']),
										$elm$json$Json$Decode$string,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A2($author$project$Datamine$Source$decoder, file, 'Skill'),
											$elm$json$Json$Decode$succeed($author$project$Datamine$Skill$SkillDecoder)))))))))));
};
var $author$project$Datamine$Skill$decoder = $author$project$Datamine$Util$resultDecoder(
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$result_extra$Result$Extra$combine,
			$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$map(
				function (_v0) {
					var f = _v0.a;
					var d = _v0.b;
					return A2(
						$elm$json$Json$Decode$decodeValue,
						$author$project$Datamine$Skill$skillDecoder(f),
						d);
				}),
			$author$project$Datamine$Util$filteredJsons(
				function (s) {
					return A2($elm$core$String$contains, '/Skills/NewSkills/', s) && (!A2(
						$elm$core$List$any,
						function (c) {
							return A2($elm$core$String$contains, c, s);
						},
						$author$project$Datamine$Skill$ignoredSkills));
				}))));
var $author$project$Datamine$UniqueItem$UAccessory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Datamine$UniqueItem$UArmor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Datamine$UniqueItem$UniqueAccessory = F9(
	function (source, name, uiName, levelPrereq, keywords, implicitAffixes, defaultAffixes, lore, hudPicture) {
		return {C: defaultAffixes, b2: hudPicture, D: implicitAffixes, dI: keywords, dM: levelPrereq, cb: lore, q: name, cS: source, av: uiName};
	});
var $author$project$Datamine$UniqueItem$UniqueArmor = function (source) {
	return function (name) {
		return function (uiName) {
			return function (levelPrereq) {
				return function (keywords) {
					return function (implicitAffixes) {
						return function (defaultAffixes) {
							return function (lore) {
								return function (attachmentName) {
									return function (healthBonus) {
										return function (forceShield) {
											return function (allResistance) {
												return {bh: allResistance, bi: attachmentName, C: defaultAffixes, bO: forceShield, b_: healthBonus, D: implicitAffixes, dI: keywords, dM: levelPrereq, cb: lore, q: name, cS: source, av: uiName};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Datamine$UniqueItem$uniqueLootDecoder = A2(
	$elm$core$Basics$composeR,
	$author$project$Datamine$NormalItem$commonLootDecoder,
	A2(
		$elm$core$Basics$composeR,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['$', 'DefaultAffixes']),
			$author$project$Datamine$Util$csStrings,
			_List_Nil),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['$', 'Lore']),
			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing)));
var $author$project$Datamine$UniqueItem$uniqueArmorsDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'Armors']),
		$author$project$Datamine$Util$single(
			A2(
				$elm$json$Json$Decode$field,
				'Item',
				$elm$json$Json$Decode$list(
					A2(
						$elm$json$Json$Decode$andThen,
						function (kws) {
							return A2($elm$core$Set$member, 'accessory', kws) ? A2(
								$elm$json$Json$Decode$map,
								$author$project$Datamine$UniqueItem$UAccessory,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'HUDPicture']),
									$elm$json$Json$Decode$string,
									$author$project$Datamine$UniqueItem$uniqueLootDecoder(
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A2($author$project$Datamine$Source$decoder, file, 'Item'),
											$elm$json$Json$Decode$succeed($author$project$Datamine$UniqueItem$UniqueAccessory))))) : A2(
								$elm$json$Json$Decode$map,
								$author$project$Datamine$UniqueItem$UArmor,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'AllResistanceMin']),
												$author$project$Datamine$Util$intString)),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'AllResistanceMax']),
												$author$project$Datamine$Util$intString))),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A3(
											$elm$json$Json$Decode$map2,
											$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'ForceShieldMin']),
													$author$project$Datamine$Util$intString)),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'ForceShieldMax']),
													$author$project$Datamine$Util$intString))),
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A3(
												$elm$json$Json$Decode$map2,
												$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['$', 'HealthBonusMin']),
														$author$project$Datamine$Util$intString)),
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['$', 'HealthBonusMax']),
														$author$project$Datamine$Util$intString))),
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
												_List_fromArray(
													['$', 'AttachmentName']),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
												$elm$core$Maybe$Nothing,
												$author$project$Datamine$UniqueItem$uniqueLootDecoder(
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
														A2($author$project$Datamine$Source$decoder, file, 'Item'),
														$elm$json$Json$Decode$succeed($author$project$Datamine$UniqueItem$UniqueArmor))))))));
						},
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Set$fromList,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['$', 'Keywords']),
								$author$project$Datamine$Util$csStrings)))))));
};
var $author$project$Datamine$UniqueItem$UShield = function (a) {
	return {$: 1, a: a};
};
var $author$project$Datamine$UniqueItem$UWeapon = function (a) {
	return {$: 0, a: a};
};
var $author$project$Datamine$UniqueItem$UniqueShield = function (source) {
	return function (name) {
		return function (uiName) {
			return function (levelPrereq) {
				return function (keywords) {
					return function (implicitAffixes) {
						return function (defaultAffixes) {
							return function (lore) {
								return function (shieldResistance) {
									return function (shieldBlockChance) {
										return function (shieldBlockEfficiency) {
											return {C: defaultAffixes, D: implicitAffixes, dI: keywords, dM: levelPrereq, cb: lore, q: name, cK: shieldBlockChance, cL: shieldBlockEfficiency, cM: shieldResistance, cS: source, av: uiName};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Datamine$UniqueItem$UniqueWeapon = function (source) {
	return function (name) {
		return function (uiName) {
			return function (levelPrereq) {
				return function (keywords) {
					return function (implicitAffixes) {
						return function (defaultAffixes) {
							return function (lore) {
								return function (damage) {
									return function (resourceGain) {
										return {bw: damage, C: defaultAffixes, D: implicitAffixes, dI: keywords, dM: levelPrereq, cb: lore, q: name, cB: resourceGain, cS: source, av: uiName};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Datamine$UniqueItem$uniqueWeaponsDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'Weapons']),
		$author$project$Datamine$Util$single(
			A2(
				$elm$json$Json$Decode$field,
				'Item',
				$elm$json$Json$Decode$list(
					A2(
						$elm$json$Json$Decode$andThen,
						function (kws) {
							return A2($elm$core$Set$member, 'shield', kws) ? A2(
								$elm$json$Json$Decode$map,
								$author$project$Datamine$UniqueItem$UShield,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'ShieldBlockEfficiencyMin']),
												$author$project$Datamine$Util$intString)),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'ShieldBlockEfficiencyMax']),
												$author$project$Datamine$Util$intString))),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A3(
											$elm$json$Json$Decode$map2,
											$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'ShieldBlockChanceMin']),
													$author$project$Datamine$Util$intString)),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'ShieldBlockChanceMax']),
													$author$project$Datamine$Util$intString))),
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A3(
												$elm$json$Json$Decode$map2,
												$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['$', 'ShieldResistanceMin']),
														$author$project$Datamine$Util$intString)),
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['$', 'ShieldResistanceMax']),
														$author$project$Datamine$Util$intString))),
											$author$project$Datamine$UniqueItem$uniqueLootDecoder(
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
													A2($author$project$Datamine$Source$decoder, file, 'Item'),
													$elm$json$Json$Decode$succeed($author$project$Datamine$UniqueItem$UniqueShield))))))) : A2(
								$elm$json$Json$Decode$map,
								$author$project$Datamine$UniqueItem$UWeapon,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									A3(
										$elm$json$Json$Decode$map2,
										$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'ResourceGain_Min']),
												$author$project$Datamine$Util$intString)),
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['$', 'ResourceGain_Max']),
												$author$project$Datamine$Util$intString))),
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A3(
											$elm$json$Json$Decode$map2,
											$elm$core$Maybe$map2($author$project$Datamine$Util$Range),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'LowDamage_Max']),
													$author$project$Datamine$Util$intString)),
											$elm$json$Json$Decode$maybe(
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['$', 'HighDamage_Max']),
													$author$project$Datamine$Util$intString))),
										$author$project$Datamine$UniqueItem$uniqueLootDecoder(
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												A2($author$project$Datamine$Source$decoder, file, 'Item'),
												$elm$json$Json$Decode$succeed($author$project$Datamine$UniqueItem$UniqueWeapon))))));
						},
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Set$fromList,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['$', 'Keywords']),
								$author$project$Datamine$Util$csStrings)))))));
};
var $author$project$Datamine$UniqueItem$decoder = A3(
	$elm$core$List$foldl,
	function (di) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$json$Json$Decode$map($elm$core$Basics$append),
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom(di));
	},
	$elm$json$Json$Decode$succeed(_List_Nil),
	_List_fromArray(
		[
			$author$project$Datamine$UniqueItem$uniqueWeaponsDecoder('Game/Umbra/Loot/Weapons/UniqueWeapons.json'),
			$author$project$Datamine$UniqueItem$uniqueWeaponsDecoder('Game/Umbra/Loot/Weapons/UniqueWeaponsMax.json'),
			$author$project$Datamine$UniqueItem$uniqueWeaponsDecoder('Game/Umbra/Loot/Weapons/UniqueWeaponsMaxMax.json'),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$json$Json$Decode$maybe(
				$author$project$Datamine$UniqueItem$uniqueWeaponsDecoder('Game/Umbra/Loot/Weapons/UniqueWeaponsUltimate.json'))),
			$author$project$Datamine$UniqueItem$uniqueWeaponsDecoder('Game/Umbra/Loot/Weapons/UniqueShields.json'),
			$author$project$Datamine$UniqueItem$uniqueArmorsDecoder('Game/Umbra/Loot/Armors/Armors_uniques.json'),
			$author$project$Datamine$UniqueItem$uniqueArmorsDecoder('Game/Umbra/Loot/Armors/UniqueArmorsMax.json'),
			$author$project$Datamine$UniqueItem$uniqueArmorsDecoder('Game/Umbra/Loot/Armors/UniqueArmorsMaxMax.json'),
			$author$project$Datamine$UniqueItem$uniqueArmorsDecoder('Game/Umbra/Loot/Armors/UniquesAccessories.json')
		]));
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Datamine$Skill$apocForms = _List_fromArray(
	['mage', 'rogue', 'tank', 'warrior']);
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm$core$String$toLower = _String_toLower;
var $author$project$Datamine$Skill$apocForm = function (s) {
	var uid = $elm$core$String$toLower(s.be);
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (f) {
			return A2($elm$core$String$startsWith, 'apo_' + f, uid) || A2($elm$core$String$startsWith, 'apo' + f, uid);
		},
		$author$project$Datamine$Skill$apocForms);
};
var $author$project$Datamine$Skill$apocFormNone = 'player';
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$Datamine$Affix$effectIds = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.aW;
	},
	$elm$core$List$map(
		function ($) {
			return $.ai;
		}));
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm_community$dict_extra$Dict$Extra$filterMap = F2(
	function (f, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					var _v0 = A2(f, k, v);
					if (!_v0.$) {
						var newVal = _v0.a;
						return A3($elm$core$Dict$insert, k, newVal, acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm_community$dict_extra$Dict$Extra$fromListBy = F2(
	function (keyfn, xs) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$insert,
						keyfn(x),
						x,
						acc);
				}),
			$elm$core$Dict$empty,
			xs);
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm_community$dict_extra$Dict$Extra$groupBy = F2(
	function (keyfn, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A3(
						$elm$core$Dict$update,
						keyfn(x),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$elm$core$List$cons(x)),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(
									_List_fromArray(
										[x])),
								$elm$core$Maybe$Just)),
						acc);
				}),
			$elm$core$Dict$empty,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Datamine$UniqueItem$levelPrereq = function (n) {
	switch (n.$) {
		case 0:
			var i = n.a;
			return i.dM;
		case 1:
			var i = n.a;
			return i.dM;
		case 2:
			var i = n.a;
			return i.dM;
		default:
			var i = n.a;
			return i.dM;
	}
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Datamine$NormalItem$name = function (n) {
	switch (n.$) {
		case 0:
			var i = n.a;
			return i.q;
		case 1:
			var i = n.a;
			return i.q;
		case 2:
			var i = n.a;
			return i.q;
		default:
			var i = n.a;
			return i.q;
	}
};
var $author$project$Datamine$UniqueItem$name = function (n) {
	switch (n.$) {
		case 0:
			var i = n.a;
			return i.q;
		case 1:
			var i = n.a;
			return i.q;
		case 2:
			var i = n.a;
			return i.q;
		default:
			var i = n.a;
			return i.q;
	}
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Datamine$UniqueItem$nonmaxName = A2(
	$elm$core$Basics$composeR,
	$author$project$Datamine$UniqueItem$name,
	A2(
		$elm$core$Basics$composeR,
		A2($elm$core$String$replace, '_max', ''),
		A2($elm$core$String$replace, '_ultimate', '')));
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$Datamine$index = function (raw) {
	var skillVariants = A2(
		$elm$core$List$concatMap,
		function (s) {
			return A2(
				$elm$core$List$map,
				function (v) {
					return _Utils_Tuple2(v, s);
				},
				s.c0);
		},
		raw.M);
	var passivesByName = A2(
		$elm_community$dict_extra$Dict$Extra$fromListBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.q;
			},
			$elm$core$String$toLower),
		raw.ap);
	var passiveTreeEntries = A2(
		$elm$core$List$concatMap,
		function (t) {
			return A2(
				$elm$core$List$filterMap,
				function (e) {
					return A2(
						$elm$core$Maybe$map,
						function (p) {
							return _Utils_Tuple3(e, p, t);
						},
						A2(
							$elm$core$Dict$get,
							$elm$core$String$toLower(e.q),
							passivesByName));
				},
				t.dk);
		},
		raw.S);
	var gemFamiliesByEffectId = A2(
		$elm$core$Dict$map,
		$elm$core$Basics$always(
			$elm$core$List$map($elm$core$Tuple$second)),
		A2(
			$elm_community$dict_extra$Dict$Extra$groupBy,
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$String$toLower),
			A2(
				$elm$core$List$concatMap,
				function (fam) {
					return A2(
						$elm$core$List$map,
						function (eff) {
							return _Utils_Tuple2(eff, fam);
						},
						fam.df);
				},
				raw.J)));
	return {
		x: raw.x,
		ab: raw.ab,
		bg: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.ab),
		ad: raw.ad,
		bn: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.ad),
		ae: raw.ae,
		bo: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.ae),
		aA: raw.aA,
		af: raw.af,
		bq: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.af),
		ag: raw.ag,
		br: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.ag),
		ah: raw.ah,
		bs: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.ah),
		aB: raw.aB,
		aC: raw.aC,
		J: raw.J,
		bQ: $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Tuple$mapBoth,
					$elm$core$String$toLower,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filterMap(
							function (effectId) {
								return A2(
									$elm$core$Dict$get,
									$elm$core$String$toLower(effectId),
									gemFamiliesByEffectId);
							}),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$concat,
							$elm_community$list_extra$List$Extra$uniqueBy(
								function ($) {
									return $.bU;
								})))),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (a) {
							return _Utils_Tuple2(
								a.ax,
								$author$project$Datamine$Affix$effectIds(a));
						},
						raw.x.aH),
					A2(
						$elm$core$List$map,
						function (a) {
							return _Utils_Tuple2(
								a.ax,
								$author$project$Datamine$Affix$effectIds(a));
						},
						raw.x.ch)))),
		bR: gemFamiliesByEffectId,
		bS: $elm$core$Dict$fromList(
			A2(
				$elm$core$List$concatMap,
				function (fam) {
					return A2(
						$elm$core$List$map,
						function (r) {
							return _Utils_Tuple2(
								$elm$core$String$toLower(r.du),
								fam);
						},
						fam.ec);
				},
				raw.J)),
		bT: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bU;
				},
				$elm$core$String$toLower),
			raw.J),
		aj: raw.aj,
		bV: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.aj),
		al: raw.al,
		ca: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2($elm$core$Basics$composeR, $author$project$Datamine$NormalItem$name, $elm$core$String$toLower),
			raw.al),
		cc: A2(
			$elm_community$dict_extra$Dict$Extra$groupBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bt;
				},
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$withDefault(''),
					$elm$core$String$toLower)),
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bt;
					},
					$elm_community$maybe_extra$Maybe$Extra$isJust),
				raw.x.aH)),
		cd: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ax;
				},
				$elm$core$String$toLower),
			raw.x.aH),
		ce: $elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$concatMap,
				function (a) {
					return _Utils_ap(a.bz.dO, a.bz.d$);
				},
				raw.x.aH)),
		ci: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ax;
				},
				$elm$core$String$toLower),
			raw.x.ch),
		ck: passiveTreeEntries,
		cl: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			function (_v0) {
				var e = _v0.a;
				var p = _v0.b;
				var t = _v0.c;
				return $elm$core$String$toLower(e.q);
			},
			passiveTreeEntries),
		S: raw.S,
		cm: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.S),
		ap: raw.ap,
		cn: passivesByName,
		ar: raw.ar,
		cv: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.ar),
		aM: raw.aM,
		cN: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.be;
				},
				$elm$core$String$toLower),
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.c0;
				},
				raw.W)),
		W: raw.W,
		cO: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.q;
				},
				$elm$core$String$toLower),
			raw.W),
		cP: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.be;
					},
					$elm$core$String$toLower)),
			skillVariants),
		M: raw.M,
		cQ: A2(
			$elm_community$dict_extra$Dict$Extra$groupBy,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Datamine$Skill$apocForm,
				$elm$core$Maybe$withDefault($author$project$Datamine$Skill$apocFormNone)),
			raw.M),
		cR: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.be;
				},
				$elm$core$String$toLower),
			raw.M),
		Y: raw.Y,
		c_: A2(
			$elm_community$dict_extra$Dict$Extra$fromListBy,
			A2($elm$core$Basics$composeR, $author$project$Datamine$UniqueItem$name, $elm$core$String$toLower),
			raw.Y),
		c$: A2(
			$elm_community$dict_extra$Dict$Extra$filterMap,
			F2(
				function (_v2, l) {
					return A2(
						$elm$core$Maybe$map,
						function (h) {
							return _Utils_Tuple2(h, l);
						},
						$elm$core$List$head(l));
				}),
			A2(
				$elm$core$Dict$map,
				function (_v1) {
					return $elm$core$List$sortBy(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Datamine$UniqueItem$levelPrereq,
							$elm$core$Maybe$withDefault(0)));
				},
				A2(
					$elm_community$dict_extra$Dict$Extra$groupBy,
					A2($elm$core$Basics$composeR, $author$project$Datamine$UniqueItem$nonmaxName, $elm$core$String$toLower),
					raw.Y)))
	};
};
var $author$project$Datamine$City$Level = F3(
	function (source, level, pptThreshold) {
		return {dL: level, d4: pptThreshold, cS: source};
	});
var $author$project$Datamine$City$levelsDecoder = function () {
	var file = 'Game/Umbra/CityBuilding/City/city.json';
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'City', '0', 'Levels', '0', 'Level']),
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['$', 'PPTThreshold']),
				$author$project$Datamine$Util$intString,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'Level']),
					$author$project$Datamine$Util$intString,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($author$project$Datamine$Source$decoder, file, 'Level'),
						$elm$json$Json$Decode$succeed($author$project$Datamine$City$Level))))));
}();
var $author$project$Datamine$City$ProjectScaling = F3(
	function (source, name, factor) {
		return {$7: factor, q: name, cS: source};
	});
var $elm$json$Json$Decode$array = _Json_decodeArray;
var $author$project$Datamine$City$projectScalingDecoder = function () {
	var file = 'Game/Umbra/CityBuilding/ScalingTables/project_tables.json';
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			[file, 'MetaData', 'Table']),
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['Factor']),
				$elm$json$Json$Decode$array(
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['$', 'Factor']),
						$author$project$Datamine$Util$intString)),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'Name']),
					$elm$json$Json$Decode$string,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						A2($author$project$Datamine$Source$decoder, file, 'Table'),
						$elm$json$Json$Decode$succeed($author$project$Datamine$City$ProjectScaling))))));
}();
var $author$project$Datamine$City$Project = F8(
	function (source, name, categoryName, repeatable, uiName, uiLore, iconType, rewards) {
		return {da: categoryName, dB: iconType, q: name, ed: repeatable, cD: rewards, cS: source, aO: uiLore, av: uiName};
	});
var $author$project$Datamine$City$ProjectReward = F2(
	function (rewardName, weight) {
		return {cC: rewardName, _: weight};
	});
var $author$project$Datamine$City$projectsDecoder_ = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['MetaData', 'Project']),
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['RewardList', '0', 'Reward']),
				$elm$json$Json$Decode$list(
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'Weight']),
						$author$project$Datamine$Util$intString,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'RewardName']),
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Datamine$City$ProjectReward)))),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
					_List_fromArray(
						['UIParams', '0', '$', 'IconType']),
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['UIParams', '0', '$', 'UILore']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['UIParams', '0', '$', 'UIName']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'Repeatable']),
								$author$project$Datamine$Util$boolString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'CategoryName']),
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['$', 'Name']),
										$elm$json$Json$Decode$string,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											A2($author$project$Datamine$Source$decoder, file, 'Project'),
											$elm$json$Json$Decode$succeed($author$project$Datamine$City$Project)))))))))));
};
var $author$project$Datamine$City$projectsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$concat,
	$author$project$Datamine$Util$resultDecoder(
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$result_extra$Result$Extra$combine,
				$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$map(
					function (_v0) {
						var f = _v0.a;
						var d = _v0.b;
						return A2(
							$elm$json$Json$Decode$decodeValue,
							$author$project$Datamine$City$projectsDecoder_(f),
							d);
					}),
				$author$project$Datamine$Util$filteredJsons(
					$elm$core$String$contains('/CityBuilding/Projects/'))))));
var $author$project$Datamine$Revision = F2(
	function (buildRevision, date) {
		return {bk: buildRevision, dg: date};
	});
var $author$project$Datamine$revisionDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Datamine$Revision,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['revision.json', 'build-revision']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['revision.json', 'date']),
		$elm$json$Json$Decode$string));
var $author$project$Datamine$City$Reward = F7(
	function (source, name, uiName, uiLore, gold, pa, fixedItems) {
		return {aZ: fixedItems, a_: gold, q: name, a4: pa, cS: source, aO: uiLore, av: uiName};
	});
var $author$project$Datamine$City$RewardCurrency = F3(
	function (min, max, perPlayerLevel) {
		return {dQ: max, dS: min, T: perPlayerLevel};
	});
var $author$project$Datamine$City$RewardFixedItems = F3(
	function (name, min, max) {
		return {dQ: max, dS: min, q: name};
	});
var $author$project$Datamine$City$rewardsDecoder_ = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['MetaData', 'Reward']),
		$elm$json$Json$Decode$list(
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['FixedItems']),
				$elm$json$Json$Decode$list(
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'MaxItemNumber']),
						$author$project$Datamine$Util$intString,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'MinItemNumber']),
							$author$project$Datamine$Util$intString,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'Name']),
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Datamine$City$RewardFixedItems))))),
				_List_Nil,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$elm$json$Json$Decode$maybe(
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['Currency', '0', '$', 'PA_PerPlayerLevel']),
							$author$project$Datamine$Util$floatString,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['Currency', '0', '$', 'PA_Max']),
								$author$project$Datamine$Util$intString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['Currency', '0', '$', 'PA_Min']),
									$author$project$Datamine$Util$intString,
									$elm$json$Json$Decode$succeed($author$project$Datamine$City$RewardCurrency))))),
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$elm$json$Json$Decode$maybe(
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['Currency', '0', '$', 'Gold_PerPlayerLevel']),
								$author$project$Datamine$Util$floatString,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['Currency', '0', '$', 'Gold_Max']),
									$author$project$Datamine$Util$intString,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['Currency', '0', '$', 'Gold_Min']),
										$author$project$Datamine$Util$intString,
										$elm$json$Json$Decode$succeed($author$project$Datamine$City$RewardCurrency))))),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'UILore']),
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['$', 'UITitle']),
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['$', 'Name']),
									$elm$json$Json$Decode$string,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										A2($author$project$Datamine$Source$decoder, file, 'Reward'),
										$elm$json$Json$Decode$succeed($author$project$Datamine$City$Reward))))))))));
};
var $author$project$Datamine$City$rewardsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$concat,
	$author$project$Datamine$Util$resultDecoder(
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$result_extra$Result$Extra$combine,
				$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$map(
					function (_v0) {
						var f = _v0.a;
						var d = _v0.b;
						return A2(
							$elm$json$Json$Decode$decodeValue,
							$author$project$Datamine$City$rewardsDecoder_(f),
							d);
					}),
				$author$project$Datamine$Util$filteredJsons(
					$elm$core$String$contains('/CityBuilding/Rewards/'))))));
var $author$project$Datamine$Cosmetic$CCosmeticTransferTemplate = F2(
	function (name, hudPicture) {
		return {b2: hudPicture, q: name};
	});
var $author$project$Datamine$Cosmetic$transferTemplateDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm_community$dict_extra$Dict$Extra$fromListBy(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.q;
			},
			$elm$core$String$toLower)),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['Game/Umbra/SkinParams/TransferTemplate/TransferTemplateBank.json', 'CCosmeticTransferTemplateBank', 'CCosmeticTransferTemplate']),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$maybe(
					A3(
						$elm$json$Json$Decode$map2,
						$author$project$Datamine$Cosmetic$CCosmeticTransferTemplate,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['$', 'name']),
							$elm$json$Json$Decode$string),
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['$', 'hud_picture']),
							$elm$json$Json$Decode$string)))))));
var $author$project$Datamine$Passive$PassiveTree = F5(
	function (source, name, uiName, category, entries) {
		return {bl: category, dk: entries, q: name, cS: source, av: uiName};
	});
var $author$project$Datamine$Passive$PassiveTreeEntry = F4(
	function (source, name, rarity, category) {
		return {bl: category, q: name, d8: rarity, cS: source};
	});
var $author$project$Datamine$Passive$passiveTreeEntriesDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['Skill']),
		$elm$json$Json$Decode$list(
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['$', 'Category']),
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'Rarity']),
					$author$project$Datamine$Util$intString,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'Name']),
						$elm$json$Json$Decode$string,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							A2($author$project$Datamine$Source$decoder, file, 'Skill'),
							$elm$json$Json$Decode$succeed($author$project$Datamine$Passive$PassiveTreeEntry)))))));
};
var $author$project$Datamine$Passive$passiveTreesDecoder = function (file) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['MetaData', 'Tree']),
		$author$project$Datamine$Util$single(
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Datamine$Passive$passiveTreeEntriesDecoder(file),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['$', 'Category']),
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['$', 'UIName']),
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['$', 'Name']),
							$elm$json$Json$Decode$string,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								A2($author$project$Datamine$Source$decoder, file, 'Tree'),
								$elm$json$Json$Decode$succeed($author$project$Datamine$Passive$PassiveTree))))))));
};
var $author$project$Datamine$Passive$treesDecoder = $author$project$Datamine$Util$resultDecoder(
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm_community$result_extra$Result$Extra$combine,
			$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$map(
				function (_v0) {
					var filename = _v0.a;
					var json = _v0.b;
					return A2(
						$elm$json$Json$Decode$decodeValue,
						$author$project$Datamine$Passive$passiveTreesDecoder(filename),
						json);
				}),
			$author$project$Datamine$Util$filteredJsons(
				$elm$core$String$contains('Skills/Trees/PassiveSkills')))));
var $author$project$Datamine$Cosmetic$CCosmeticWeaponDescriptor = F2(
	function (name, hudPicture) {
		return {b2: hudPicture, q: name};
	});
var $author$project$Datamine$Cosmetic$weaponDescriptorDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm_community$dict_extra$Dict$Extra$fromListBy(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.q;
			},
			$elm$core$String$toLower)),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['Game/Umbra/SkinParams/WeaponSkins/CosmeticWeaponDescriptorBankGameplay.json', 'CCosmeticWeaponDescriptorBank', 'CCosmeticWeaponDescriptor']),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Datamine$Cosmetic$CCosmeticWeaponDescriptor,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['$', 'name']),
					$elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['$', 'hud_picture']),
					$elm$json$Json$Decode$string)))));
var $author$project$Datamine$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (revision) {
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Datamine$index,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Datamine$Ailment$decoder(revision.bk),
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Datamine$City$levelsDecoder,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$Datamine$City$categoriesDecoder,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							$author$project$Datamine$City$buildingsDecoder,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$author$project$Datamine$City$rewardsDecoder,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
									$author$project$Datamine$City$projectScalingDecoder,
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
										$author$project$Datamine$City$projectsDecoder,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
											$author$project$Datamine$GemFamily$decoder,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												$author$project$Datamine$Reagent$decoder,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
													$author$project$Datamine$Passive$treesDecoder,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
														$author$project$Datamine$Passive$decoder,
														A2(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
															$author$project$Datamine$Gem$decoder,
															A2(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																$author$project$Datamine$Cosmetic$weaponDescriptorDecoder,
																A2(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																	$author$project$Datamine$Cosmetic$transferTemplateDecoder,
																	A2(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																		$author$project$Datamine$Affix$decoder,
																		A2(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																			$author$project$Datamine$Skill$astsDecoder,
																			A2(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																				$author$project$Datamine$Skill$decoder,
																				A2(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																					$author$project$Datamine$UniqueItem$decoder,
																					A2(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																						$author$project$Datamine$NormalItem$decoder,
																						$elm$json$Json$Decode$succeed(
																							$author$project$Datamine$RawDatamine(revision))))))))))))))))))))));
	},
	$author$project$Datamine$revisionDecoder);
var $author$project$Datamine$decode = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$decodeValue($author$project$Datamine$decoder),
	$elm$core$Result$mapError($elm$json$Json$Decode$errorToString));
var $author$project$Search$config = {
	dp: _List_fromArray(
		[
			_Utils_Tuple2(
			function ($) {
				return $.ev;
			},
			5.0),
			_Utils_Tuple2(
			function ($) {
				return $.u;
			},
			3.0),
			_Utils_Tuple2(
			function ($) {
				return $.E;
			},
			3.0),
			_Utils_Tuple2(
			function ($) {
				return $.c7;
			},
			1.0),
			_Utils_Tuple2(
			function ($) {
				return $.cb;
			},
			0.5)
		]),
	dN: _List_fromArray(
		[
			_Utils_Tuple2(
			function ($) {
				return $.dI;
			},
			3.0),
			_Utils_Tuple2(
			function ($) {
				return $.aW;
			},
			2.0)
		]),
	eb: function ($) {
		return $.u;
	}
};
var $rluiten$elm_text_search$Index$Defaults$elmTextSearchIndexType = '-= ElmTextSearch Index Type 1 =-';
var $rluiten$elm_text_search$Index$Defaults$getIndexSimpleConfig = function (_v0) {
	var ref = _v0.eb;
	var fields = _v0.dp;
	var listFields = _v0.dN;
	return {dp: fields, a0: $rluiten$elm_text_search$Index$Defaults$elmTextSearchIndexType, dN: listFields, eb: ref};
};
var $rluiten$elm_text_search$StopWordFilter$createFilterFunc = F2(
	function (tokens, index) {
		var tokenSet = $elm$core$Set$fromList(tokens);
		return _Utils_Tuple2(
			index,
			function (word) {
				return !A2($elm$core$Set$member, word, tokenSet);
			});
	});
var $rluiten$elm_text_search$StopWordFilter$stopEnglishWordList = _List_fromArray(
	['a', 'able', 'about', 'across', 'after', 'all', 'almost', 'also', 'am', 'among', 'an', 'and', 'any', 'are', 'as', 'at', 'be', 'because', 'been', 'but', 'by', 'can', 'cannot', 'could', 'dear', 'did', 'do', 'does', 'either', 'else', 'ever', 'every', 'for', 'from', 'get', 'got', 'had', 'has', 'have', 'he', 'her', 'hers', 'him', 'his', 'how', 'however', 'i', 'if', 'in', 'into', 'is', 'it', 'its', 'just', 'least', 'let', 'like', 'likely', 'may', 'me', 'might', 'most', 'must', 'my', 'neither', 'no', 'nor', 'not', 'of', 'off', 'often', 'on', 'only', 'or', 'other', 'our', 'own', 'rather', 'said', 'say', 'says', 'she', 'should', 'since', 'so', 'some', 'than', 'that', 'the', 'their', 'them', 'then', 'there', 'these', 'they', 'this', 'tis', 'to', 'too', 'twas', 'us', 'wants', 'was', 'we', 'were', 'what', 'when', 'where', 'which', 'while', 'who', 'whom', 'why', 'will', 'with', 'would', 'yet', 'you', 'your']);
var $rluiten$elm_text_search$StopWordFilter$createDefaultFilterFunc = function (index) {
	return A2($rluiten$elm_text_search$StopWordFilter$createFilterFunc, $rluiten$elm_text_search$StopWordFilter$stopEnglishWordList, index);
};
var $rluiten$elm_text_search$Index$Defaults$defaultStopWordFilterFuncCreator = $rluiten$elm_text_search$StopWordFilter$createDefaultFilterFunc;
var $rluiten$elm_text_search$Index$Defaults$defaultFilterFactories = _List_fromArray(
	[$rluiten$elm_text_search$Index$Defaults$defaultStopWordFilterFuncCreator]);
var $rluiten$elm_text_search$Index$Utils$createFuncCreator = F2(
	function (func, index) {
		return _Utils_Tuple2(index, func);
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {dD: index, dP: match, dX: number, eq: submatches};
	});
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{c9: false, dU: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $rluiten$elm_text_search$TokenProcessors$forceRegex = A2(
	$elm$core$Basics$composeL,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never),
	$elm$regex$Regex$fromString);
var $rluiten$elm_text_search$TokenProcessors$trimmerRegex = $rluiten$elm_text_search$TokenProcessors$forceRegex('^\\W+|\\W+$');
var $rluiten$elm_text_search$TokenProcessors$trimmer = A2(
	$elm$regex$Regex$replace,
	$rluiten$elm_text_search$TokenProcessors$trimmerRegex,
	function (_v0) {
		return '';
	});
var $rluiten$elm_text_search$Index$Defaults$defaultTokenTrimmerFuncCreator = $rluiten$elm_text_search$Index$Utils$createFuncCreator($rluiten$elm_text_search$TokenProcessors$trimmer);
var $rluiten$elm_text_search$Index$Defaults$defaultInitialTransformFactories = _List_fromArray(
	[$rluiten$elm_text_search$Index$Defaults$defaultTokenTrimmerFuncCreator]);
var $elm$core$String$reverse = _String_reverse;
var $rluiten$stemmer$Stemmer$step1aX = function (drow) {
	return A2($elm$core$String$startsWith, 'sess', drow) ? A2($elm$core$String$dropLeft, 2, drow) : (A2($elm$core$String$startsWith, 'sei', drow) ? A2($elm$core$String$dropLeft, 2, drow) : (A2($elm$core$String$startsWith, 'ss', drow) ? drow : (A2($elm$core$String$startsWith, 's', drow) ? A2($elm$core$String$dropLeft, 1, drow) : drow)));
};
var $rluiten$stemmer$Stemmer$isVowelCore = F2(
	function (includeY, c) {
		switch (c) {
			case 'a':
				return true;
			case 'e':
				return true;
			case 'i':
				return true;
			case 'o':
				return true;
			case 'u':
				return true;
			case 'y':
				return includeY ? true : false;
			default:
				return false;
		}
	});
var $rluiten$stemmer$Stemmer$isVowelWithY = $rluiten$stemmer$Stemmer$isVowelCore(true);
var $rluiten$stemmer$Stemmer$hasVowel2X = function (word) {
	hasVowel2X:
	while (true) {
		var _v0 = $elm$core$String$uncons(word);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var h = _v1.a;
			var wordTail = _v1.b;
			var _v2 = $rluiten$stemmer$Stemmer$isVowelWithY(h);
			if (_v2) {
				return true;
			} else {
				var $temp$word = wordTail;
				word = $temp$word;
				continue hasVowel2X;
			}
		} else {
			return false;
		}
	}
};
var $rluiten$stemmer$Stemmer$isVowel = $rluiten$stemmer$Stemmer$isVowelCore(false);
var $rluiten$stemmer$Stemmer$hasVowelX = function (drow) {
	var _v0 = $elm$core$String$uncons(
		$elm$core$String$reverse(drow));
	if (!_v0.$) {
		var _v1 = _v0.a;
		var h = _v1.a;
		var wordTail = _v1.b;
		var _v2 = $rluiten$stemmer$Stemmer$isVowel(h);
		if (_v2) {
			return true;
		} else {
			return $rluiten$stemmer$Stemmer$hasVowel2X(wordTail);
		}
	} else {
		return false;
	}
};
var $rluiten$stemmer$Stemmer$foundConsonantX = F2(
	function (word, m) {
		foundConsonantX:
		while (true) {
			var _v3 = $elm$core$String$uncons(word);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var h = _v4.a;
				var wordTail = _v4.b;
				var _v5 = $rluiten$stemmer$Stemmer$isVowelWithY(h);
				if (_v5) {
					return A2($rluiten$stemmer$Stemmer$foundVowelX, wordTail, m);
				} else {
					var $temp$word = wordTail,
						$temp$m = m;
					word = $temp$word;
					m = $temp$m;
					continue foundConsonantX;
				}
			} else {
				return m;
			}
		}
	});
var $rluiten$stemmer$Stemmer$foundVowelX = F2(
	function (word, m) {
		foundVowelX:
		while (true) {
			var _v0 = $elm$core$String$uncons(word);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var h = _v1.a;
				var wordTail = _v1.b;
				var _v2 = $rluiten$stemmer$Stemmer$isVowel(h);
				if (_v2) {
					var $temp$word = wordTail,
						$temp$m = m;
					word = $temp$word;
					m = $temp$m;
					continue foundVowelX;
				} else {
					return A2($rluiten$stemmer$Stemmer$foundConsonantX, wordTail, m + 1);
				}
			} else {
				return m;
			}
		}
	});
var $rluiten$stemmer$Stemmer$foundLeadingConsonantX = function (word) {
	foundLeadingConsonantX:
	while (true) {
		var _v0 = $elm$core$String$uncons(word);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var h = _v1.a;
			var wordTail = _v1.b;
			var _v2 = $rluiten$stemmer$Stemmer$isVowelWithY(h);
			if (_v2) {
				return A2($rluiten$stemmer$Stemmer$foundVowelX, wordTail, 0);
			} else {
				var $temp$word = wordTail;
				word = $temp$word;
				continue foundLeadingConsonantX;
			}
		} else {
			return 0;
		}
	}
};
var $rluiten$stemmer$Stemmer$measureX = function (drow) {
	var word = $elm$core$String$reverse(drow);
	var _v0 = $elm$core$String$uncons(word);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var h = _v1.a;
		var wordTail = _v1.b;
		var _v2 = $rluiten$stemmer$Stemmer$isVowel(h);
		if (_v2) {
			return A2($rluiten$stemmer$Stemmer$foundVowelX, wordTail, 0);
		} else {
			return $rluiten$stemmer$Stemmer$foundLeadingConsonantX(wordTail);
		}
	} else {
		return 0;
	}
};
var $elm$core$String$cons = _String_cons;
var $rluiten$stemmer$Stemmer$endsWithCVCX = function (drow) {
	var _v0 = $elm$core$String$uncons(drow);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var c2 = _v1.a;
		var drowTail1 = _v1.b;
		if (!($rluiten$stemmer$Stemmer$isVowel(c2) || ((c2 === 'w') || ((c2 === 'x') || (c2 === 'y'))))) {
			var _v2 = $elm$core$String$uncons(drowTail1);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var v = _v3.a;
				var drowTail2 = _v3.b;
				if ($rluiten$stemmer$Stemmer$isVowelWithY(v)) {
					var _v4 = $elm$core$String$uncons(drowTail2);
					if (!_v4.$) {
						var _v5 = _v4.a;
						var c1 = _v5.a;
						var drowTail3 = _v5.b;
						return !$rluiten$stemmer$Stemmer$isVowel(c1);
					} else {
						return false;
					}
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $rluiten$stemmer$Stemmer$endsWithDoubleConsX = function (drow) {
	var _v0 = $elm$core$String$uncons(drow);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var c1 = _v1.a;
		var drowTail = _v1.b;
		if (!$rluiten$stemmer$Stemmer$isVowelWithY(c1)) {
			var _v2 = $elm$core$String$uncons(drowTail);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var c2 = _v3.a;
				var drowTail2 = _v3.b;
				return _Utils_eq(c1, c2);
			} else {
				return false;
			}
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $rluiten$stemmer$Stemmer$step1b2X = function (drow) {
	if (A2($elm$core$String$startsWith, 'ta', drow) || (A2($elm$core$String$startsWith, 'lb', drow) || A2($elm$core$String$startsWith, 'zi', drow))) {
		return A2($elm$core$String$cons, 'e', drow);
	} else {
		var _v0 = $elm$core$String$uncons(drow);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var h = _v1.a;
			var drowTail = _v1.b;
			return ($rluiten$stemmer$Stemmer$endsWithDoubleConsX(drow) && (!((h === 'l') || ((h === 's') || (h === 'z'))))) ? drowTail : ((($rluiten$stemmer$Stemmer$measureX(drow) === 1) && $rluiten$stemmer$Stemmer$endsWithCVCX(drow)) ? A2($elm$core$String$cons, 'e', drow) : drow);
		} else {
			return drow;
		}
	}
};
var $rluiten$stemmer$Stemmer$step1bX = function (drow) {
	if (A2($elm$core$String$startsWith, 'dee', drow)) {
		return ($rluiten$stemmer$Stemmer$measureX(
			A2($elm$core$String$dropLeft, 3, drow)) > 0) ? A2($elm$core$String$dropLeft, 1, drow) : drow;
	} else {
		if (A2($elm$core$String$startsWith, 'de', drow)) {
			var mets = A2($elm$core$String$dropLeft, 2, drow);
			return $rluiten$stemmer$Stemmer$hasVowelX(mets) ? $rluiten$stemmer$Stemmer$step1b2X(mets) : drow;
		} else {
			if (A2($elm$core$String$startsWith, 'gni', drow)) {
				var mets = A2($elm$core$String$dropLeft, 3, drow);
				return $rluiten$stemmer$Stemmer$hasVowelX(mets) ? $rluiten$stemmer$Stemmer$step1b2X(mets) : drow;
			} else {
				return drow;
			}
		}
	}
};
var $rluiten$stemmer$Stemmer$step1cX = function (drow) {
	var _v0 = $elm$core$String$uncons(drow);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var c = _v1.a;
		var drowTail = _v1.b;
		return ((c === 'y') && $rluiten$stemmer$Stemmer$hasVowelX(drowTail)) ? A2($elm$core$String$cons, 'i', drowTail) : drow;
	} else {
		return drow;
	}
};
var $rluiten$stemmer$Stemmer$step1X = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$Basics$composeL, $rluiten$stemmer$Stemmer$step1cX, $rluiten$stemmer$Stemmer$step1bX),
	$rluiten$stemmer$Stemmer$step1aX);
var $elm$core$String$append = _String_append;
var $rluiten$stemmer$Stemmer$replaceStartX = F3(
	function (measureThreshold, _v0, drow) {
		var start = _v0.a;
		var newStart = _v0.b;
		var startLen = $elm$core$String$length(start);
		var drowStart = A2($elm$core$String$left, startLen, drow);
		if (_Utils_eq(drowStart, start)) {
			var drowEnd = A2($elm$core$String$dropLeft, startLen, drow);
			return (_Utils_cmp(
				$rluiten$stemmer$Stemmer$measureX(drowEnd),
				measureThreshold) > 0) ? _Utils_Tuple2(
				true,
				A2($elm$core$String$append, newStart, drowEnd)) : _Utils_Tuple2(true, drow);
		} else {
			return _Utils_Tuple2(false, drow);
		}
	});
var $rluiten$stemmer$Stemmer$replaceStartsX = F3(
	function (measureThreshold, rules, drow) {
		replaceStartsX:
		while (true) {
			if (rules.b) {
				var r = rules.a;
				var rs = rules.b;
				var _v1 = A3($rluiten$stemmer$Stemmer$replaceStartX, measureThreshold, r, drow);
				var patternMatched = _v1.a;
				var newDrow = _v1.b;
				if (patternMatched) {
					return newDrow;
				} else {
					var $temp$measureThreshold = measureThreshold,
						$temp$rules = rs,
						$temp$drow = drow;
					measureThreshold = $temp$measureThreshold;
					rules = $temp$rules;
					drow = $temp$drow;
					continue replaceStartsX;
				}
			} else {
				return drow;
			}
		}
	});
var $rluiten$stemmer$Stemmer$toR = $elm$core$String$reverse;
var $rluiten$stemmer$Stemmer$step2RulesX = _List_fromArray(
	[
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ational'),
		$rluiten$stemmer$Stemmer$toR('ate')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('tional'),
		$rluiten$stemmer$Stemmer$toR('tion')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('enci'),
		$rluiten$stemmer$Stemmer$toR('ence')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('anci'),
		$rluiten$stemmer$Stemmer$toR('ance')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('izer'),
		$rluiten$stemmer$Stemmer$toR('ize')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('bli'),
		$rluiten$stemmer$Stemmer$toR('ble')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('alli'),
		$rluiten$stemmer$Stemmer$toR('al')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('entli'),
		$rluiten$stemmer$Stemmer$toR('ent')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('eli'),
		$rluiten$stemmer$Stemmer$toR('e')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ousli'),
		$rluiten$stemmer$Stemmer$toR('ous')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ization'),
		$rluiten$stemmer$Stemmer$toR('ize')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ation'),
		$rluiten$stemmer$Stemmer$toR('ate')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ator'),
		$rluiten$stemmer$Stemmer$toR('ate')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('alism'),
		$rluiten$stemmer$Stemmer$toR('al')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('iveness'),
		$rluiten$stemmer$Stemmer$toR('ive')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('fulness'),
		$rluiten$stemmer$Stemmer$toR('ful')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ousness'),
		$rluiten$stemmer$Stemmer$toR('ous')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('aliti'),
		$rluiten$stemmer$Stemmer$toR('al')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('iviti'),
		$rluiten$stemmer$Stemmer$toR('ive')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('biliti'),
		$rluiten$stemmer$Stemmer$toR('ble')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('logi'),
		$rluiten$stemmer$Stemmer$toR('log'))
	]);
var $rluiten$stemmer$Stemmer$step2X = function (drow) {
	return A3($rluiten$stemmer$Stemmer$replaceStartsX, 0, $rluiten$stemmer$Stemmer$step2RulesX, drow);
};
var $rluiten$stemmer$Stemmer$step3RulesX = _List_fromArray(
	[
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('icate'),
		$rluiten$stemmer$Stemmer$toR('ic')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ative'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('alize'),
		$rluiten$stemmer$Stemmer$toR('al')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('iciti'),
		$rluiten$stemmer$Stemmer$toR('ic')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ical'),
		$rluiten$stemmer$Stemmer$toR('ic')),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ful'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ness'),
		'')
	]);
var $rluiten$stemmer$Stemmer$step3X = function (drow) {
	return A3($rluiten$stemmer$Stemmer$replaceStartsX, 0, $rluiten$stemmer$Stemmer$step3RulesX, drow);
};
var $rluiten$stemmer$Stemmer$step4IonX = F3(
	function (mThreshold, startLen, drow) {
		var afterNoi = A2($elm$core$String$dropLeft, startLen, drow);
		var _v0 = $elm$core$String$uncons(afterNoi);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var drowEnd = _v1.b;
			return (((_char === 't') || (_char === 's')) && (_Utils_cmp(
				$rluiten$stemmer$Stemmer$measureX(afterNoi),
				mThreshold) > 0)) ? afterNoi : drow;
		} else {
			return drow;
		}
	});
var $rluiten$stemmer$Stemmer$step4RulesX = _List_fromArray(
	[
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('al'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ance'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ence'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('er'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ic'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('able'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ible'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ant'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ement'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ment'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ent'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ou'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ism'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ate'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('iti'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ous'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ive'),
		''),
		_Utils_Tuple2(
		$rluiten$stemmer$Stemmer$toR('ize'),
		'')
	]);
var $rluiten$stemmer$Stemmer$step4X = function (drow) {
	var mThreshold = 1;
	var ionCase = 'noi';
	var ionLen = $elm$core$String$length(ionCase);
	var drowStart = A2($elm$core$String$left, ionLen, drow);
	return _Utils_eq(drowStart, ionCase) ? A3($rluiten$stemmer$Stemmer$step4IonX, mThreshold, ionLen, drow) : A3($rluiten$stemmer$Stemmer$replaceStartsX, mThreshold, $rluiten$stemmer$Stemmer$step4RulesX, drow);
};
var $rluiten$stemmer$Stemmer$step5aX = function (drow) {
	var _v0 = $elm$core$String$uncons(drow);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var _char = _v1.a;
		var drowEnd = _v1.b;
		if (_char === 'e') {
			var m = $rluiten$stemmer$Stemmer$measureX(drowEnd);
			return (m > 1) ? drowEnd : (((m === 1) && (!$rluiten$stemmer$Stemmer$endsWithCVCX(drowEnd))) ? drowEnd : drow);
		} else {
			return drow;
		}
	} else {
		return drow;
	}
};
var $rluiten$stemmer$Stemmer$step5bX = function (drow) {
	var _v0 = $elm$core$String$uncons(drow);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var _char = _v1.a;
		var drowEnd = _v1.b;
		return ((_char === 'l') && (($rluiten$stemmer$Stemmer$measureX(drowEnd) > 1) && $rluiten$stemmer$Stemmer$endsWithDoubleConsX(drow))) ? drowEnd : drow;
	} else {
		return drow;
	}
};
var $rluiten$stemmer$Stemmer$step5X = A2($elm$core$Basics$composeL, $rluiten$stemmer$Stemmer$step5bX, $rluiten$stemmer$Stemmer$step5aX);
var $rluiten$stemmer$Stemmer$allStepsX = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$String$reverse, $rluiten$stemmer$Stemmer$step5X),
					$rluiten$stemmer$Stemmer$step4X),
				$rluiten$stemmer$Stemmer$step3X),
			$rluiten$stemmer$Stemmer$step2X),
		$rluiten$stemmer$Stemmer$step1X),
	$elm$core$String$reverse);
var $rluiten$stemmer$Stemmer$stem = function (word) {
	return ($elm$core$String$length(word) < 3) ? word : $rluiten$stemmer$Stemmer$allStepsX(word);
};
var $rluiten$elm_text_search$Index$Defaults$defaultStemmerFuncCreator = $rluiten$elm_text_search$Index$Utils$createFuncCreator($rluiten$stemmer$Stemmer$stem);
var $rluiten$elm_text_search$Index$Defaults$defaultTransformFactories = _List_fromArray(
	[$rluiten$elm_text_search$Index$Defaults$defaultStemmerFuncCreator]);
var $rluiten$elm_text_search$Index$Defaults$getDefaultIndexConfig = function (_v0) {
	var indexType = _v0.a0;
	var ref = _v0.eb;
	var fields = _v0.dp;
	var listFields = _v0.dN;
	return {dp: fields, bG: $rluiten$elm_text_search$Index$Defaults$defaultFilterFactories, a0: indexType, b4: $rluiten$elm_text_search$Index$Defaults$defaultInitialTransformFactories, dN: listFields, eb: ref, cY: $rluiten$elm_text_search$Index$Defaults$defaultTransformFactories};
};
var $rluiten$elm_text_search$Index$Model$Index = $elm$core$Basics$identity;
var $rluiten$elm_text_search$Index$Utils$buildOrderIndex = function (tokenSet) {
	var withIndex = A2(
		$elm$core$List$indexedMap,
		$elm$core$Tuple$pair,
		$elm$core$Set$toList(tokenSet));
	return A3(
		$elm$core$List$foldr,
		F2(
			function (_v0, d) {
				var i = _v0.a;
				var v = _v0.b;
				return A3($elm$core$Dict$insert, v, i, d);
			}),
		$elm$core$Dict$empty,
		withIndex);
};
var $rluiten$elm_text_search$Index$Load$createIndex = function (_v0) {
	var config = _v0.a;
	var decodedIndex = _v0.b;
	return $elm$json$Json$Decode$succeed(
		{
			aT: decodedIndex.aT,
			bv: $rluiten$elm_text_search$Index$Utils$buildOrderIndex(decodedIndex.aT),
			aV: decodedIndex.aV,
			dp: config.dp,
			bG: config.bG,
			dr: $elm$core$Maybe$Nothing,
			a$: $elm$core$Dict$empty,
			a0: decodedIndex.a0,
			a1: decodedIndex.a1,
			b4: config.b4,
			dF: $elm$core$Maybe$Nothing,
			dN: config.dN,
			eb: config.eb,
			bc: decodedIndex.bc,
			cY: config.cY,
			ew: $elm$core$Maybe$Nothing
		});
};
var $rluiten$elm_text_search$Index$Model$CodecIndexRecord = F5(
	function (indexVersion, indexType, documentStore, corpusTokens, tokenStore) {
		return {aT: corpusTokens, aV: documentStore, a0: indexType, a1: indexVersion, bc: tokenStore};
	});
var $rluiten$trie$TrieModel$EmptyTrie = {$: 0};
var $rluiten$trie$TrieModel$TrieNode = function (a) {
	return {$: 2, a: a};
};
var $rluiten$trie$TrieModel$ValNode = function (a) {
	return {$: 1, a: a};
};
var $rluiten$trie$TrieModel$ValTrieNode = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $rluiten$trie$Trie$Json$Decoder$decoderValDict = $elm$json$Json$Decode$dict;
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $rluiten$trie$Trie$Json$Decoder$decoder = function (valDec) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($rluiten$trie$TrieModel$EmptyTrie),
				$rluiten$trie$Trie$Json$Decoder$decoderTrie(valDec)
			]));
};
var $rluiten$trie$Trie$Json$Decoder$decoderTrie = function (valDec) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$rluiten$trie$TrieModel$ValNode,
				$rluiten$trie$Trie$Json$Decoder$decoderValDict(valDec)),
				A2(
				$elm$json$Json$Decode$map,
				$rluiten$trie$TrieModel$TrieNode,
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $rluiten$trie$Trie$Json$Decoder$decoderTrieDict(valDec);
					})),
				A2(
				$elm$json$Json$Decode$map,
				$rluiten$trie$TrieModel$ValTrieNode,
				$elm$json$Json$Decode$lazy(
					function (_v1) {
						return $rluiten$trie$Trie$Json$Decoder$decoderValTrieNode(valDec);
					})),
				$elm$json$Json$Decode$fail('Invalid Trie Structure found.')
			]));
};
var $rluiten$trie$Trie$Json$Decoder$decoderTrieDict = function (valDec) {
	return $elm$json$Json$Decode$dict(
		$rluiten$trie$Trie$Json$Decoder$decoder(valDec));
};
var $rluiten$trie$Trie$Json$Decoder$decoderValTrieNode = function (valDec) {
	return A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2(
			$elm$json$Json$Decode$index,
			0,
			$rluiten$trie$Trie$Json$Decoder$decoderValDict(valDec)),
		A2(
			$elm$json$Json$Decode$index,
			1,
			$rluiten$trie$Trie$Json$Decoder$decoderTrieDict(valDec)));
};
var $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$setDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Set$fromList,
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
var $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$documentStoreDecoder = $elm$json$Json$Decode$dict($rluiten$elm_text_search$ElmTextSearch$Json$Decoder$setDecoder);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $rluiten$elm_text_search$ElmTextSearch$Json$Decoder$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tokenStore',
	$rluiten$trie$Trie$Json$Decoder$decoder($elm$json$Json$Decode$float),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'corpusTokens',
		$rluiten$elm_text_search$ElmTextSearch$Json$Decoder$setDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'documentStore',
			$rluiten$elm_text_search$ElmTextSearch$Json$Decoder$documentStoreDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'indexType',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'indexVersion',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($rluiten$elm_text_search$Index$Model$CodecIndexRecord))))));
var $rluiten$elm_text_search$Index$Load$errorPrefix = 'Error cannot load Index.';
var $rluiten$elm_text_search$Index$Defaults$indexVersion = '1.1.0';
var $rluiten$elm_text_search$Index$Load$mapIndexConfig = F2(
	function (supportedIndexConfigs, index) {
		if (!_Utils_eq($rluiten$elm_text_search$Index$Defaults$indexVersion, index.a1)) {
			return $elm$json$Json$Decode$fail($rluiten$elm_text_search$Index$Load$errorPrefix + (' Version supported is ' + ($rluiten$elm_text_search$Index$Defaults$indexVersion + ('. Version tried to load is ' + (index.a1 + '.')))));
		} else {
			var config = A2(
				$elm$core$List$filter,
				function (cfg) {
					return _Utils_eq(cfg.a0, index.a0);
				},
				supportedIndexConfigs);
			if (!config.b) {
				return $elm$json$Json$Decode$fail($rluiten$elm_text_search$Index$Load$errorPrefix + (' Tried to load index of type \"' + (index.a0 + '\". It is not in supported index configurations.')));
			} else {
				var matchedConfig = config.a;
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(matchedConfig, index));
			}
		}
	});
var $rluiten$elm_text_search$Index$Load$loadIndexValueWith = F2(
	function (supportedIndexConfigs, inputValue) {
		return A2(
			$elm$json$Json$Decode$decodeValue,
			A2(
				$elm$json$Json$Decode$andThen,
				$rluiten$elm_text_search$Index$Load$createIndex,
				A2(
					$elm$json$Json$Decode$andThen,
					$rluiten$elm_text_search$Index$Load$mapIndexConfig(supportedIndexConfigs),
					$rluiten$elm_text_search$ElmTextSearch$Json$Decoder$decoder)),
			inputValue);
	});
var $rluiten$elm_text_search$Index$Load$loadIndexValue = F2(
	function (simpleConfig, inputValue) {
		return A2(
			$rluiten$elm_text_search$Index$Load$loadIndexValueWith,
			_List_fromArray(
				[
					$rluiten$elm_text_search$Index$Defaults$getDefaultIndexConfig(simpleConfig)
				]),
			inputValue);
	});
var $rluiten$elm_text_search$ElmTextSearch$fromValue = F2(
	function (simpleConfig, inputValue) {
		return A2(
			$rluiten$elm_text_search$Index$Load$loadIndexValue,
			$rluiten$elm_text_search$Index$Defaults$getIndexSimpleConfig(simpleConfig),
			inputValue);
	});
var $author$project$Search$decodeIndex = A2(
	$elm$core$Basics$composeR,
	$rluiten$elm_text_search$ElmTextSearch$fromValue($author$project$Search$config),
	$elm$core$Result$mapError($elm$json$Json$Decode$errorToString));
var $author$project$Lang$Lang = $elm$core$Basics$identity;
var $author$project$Lang$langDecoder = A2(
	$elm$json$Json$Decode$field,
	'Sheet1',
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$filterMap($elm$core$Basics$identity),
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$maybe(
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Tuple$pair,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'KEY', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'Key', $elm$json$Json$Decode$string)
							])),
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2($elm$json$Json$Decode$field, 'TRANSLATED TEXT', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'Translated text', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'ORIGINAL TEXT_1', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'ORIGINAL TEXT', $elm$json$Json$Decode$string)
							])))))));
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Lang$decoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$concat,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				$elm$core$Tuple$mapFirst(
					function (k) {
						return '@' + $elm$core$String$toLower(k);
					})),
			A2($elm$core$Basics$composeR, $elm$core$Dict$fromList, $elm$core$Basics$identity))),
	$author$project$Datamine$Util$resultDecoder(
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$Basics$composeR,
				$elm_community$result_extra$Result$Extra$combine,
				$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$map(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$second,
						$elm$json$Json$Decode$decodeValue($author$project$Lang$langDecoder))),
				$author$project$Datamine$Util$filteredJsons(
					$elm$core$String$contains('text_ui_'))))));
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$maybeDecode = F2(
	function (decoder, mjson) {
		var _v0 = A2($elm$core$Maybe$map, decoder, mjson);
		if (_v0.$ === 1) {
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		} else {
			if (_v0.a.$ === 1) {
				var err = _v0.a.a;
				return $krisajenkins$remotedata$RemoteData$Failure(err);
			} else {
				var ok = _v0.a.a;
				return $krisajenkins$remotedata$RemoteData$Success(ok);
			}
		}
	});
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $rluiten$trie$TrieModel$getNodeCore = F2(
	function (key, trie) {
		if (!key.b) {
			return $elm$core$Maybe$Just(trie);
		} else {
			var keyHead = key.a;
			var keyTail = key.b;
			var getTrie = function (trieDict) {
				return A2(
					$elm$core$Maybe$andThen,
					$rluiten$trie$TrieModel$getNodeCore(keyTail),
					A2($elm$core$Dict$get, keyHead, trieDict));
			};
			switch (trie.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Nothing;
				case 2:
					var trieDict = trie.a;
					return getTrie(trieDict);
				default:
					var _v2 = trie.a;
					var trieDict = _v2.b;
					return getTrie(trieDict);
			}
		}
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $rluiten$trie$TrieModel$getNodeByStr = F2(
	function (key, trie) {
		return $elm$core$List$isEmpty(key) ? $elm$core$Maybe$Nothing : A2($rluiten$trie$TrieModel$getNodeCore, key, trie);
	});
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rluiten$trie$TrieModel$toListString = function (str) {
	return A2(
		$elm$core$List$map,
		function (c) {
			return $elm$core$String$fromChar(c);
		},
		$elm$core$String$toList(str));
};
var $rluiten$trie$TrieModel$getNode = F2(
	function (key, trie) {
		return A2(
			$rluiten$trie$TrieModel$getNodeByStr,
			$rluiten$trie$TrieModel$toListString(key),
			trie);
	});
var $rluiten$trie$Trie$getNode = $rluiten$trie$TrieModel$getNode;
var $rluiten$elm_text_search$Index$Utils$applyFilterList = F2(
	function (filters, token) {
		applyFilterList:
		while (true) {
			if (!filters.b) {
				return true;
			} else {
				var filterFunc = filters.a;
				var restFilters = filters.b;
				if (token === '') {
					return false;
				} else {
					var _v2 = filterFunc(token);
					if (!_v2) {
						return false;
					} else {
						var $temp$filters = restFilters,
							$temp$token = token;
						filters = $temp$filters;
						token = $temp$token;
						continue applyFilterList;
					}
				}
			}
		}
	});
var $rluiten$elm_text_search$Index$Utils$runFactories = F2(
	function (factoryList, index) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (factory, _v0) {
					var u1index = _v0.a;
					var funcList = _v0.b;
					var _v1 = factory(u1index);
					var u2index = _v1.a;
					var newFunc = _v1.b;
					return _Utils_Tuple2(
						u2index,
						A2($elm$core$List$cons, newFunc, funcList));
				}),
			_Utils_Tuple2(index, _List_Nil),
			factoryList);
	});
var $rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList = F4(
	function (getFuncs, getFactoryFuncs, setFuncs, index) {
		var _v0 = getFuncs(index);
		if (!_v0.$) {
			var funcList = _v0.a;
			return _Utils_Tuple2(index, funcList);
		} else {
			var _v1 = A2(
				$rluiten$elm_text_search$Index$Utils$runFactories,
				getFactoryFuncs(index),
				index);
			var u1index = _v1.a;
			var newFuncList = _v1.b;
			var u2index = A2(setFuncs, u1index, newFuncList);
			return _Utils_Tuple2(u2index, newFuncList);
		}
	});
var $rluiten$elm_text_search$Index$Utils$setIndexFilters = F2(
	function (_v0, listFuncs) {
		var irec = _v0;
		return _Utils_update(
			irec,
			{
				dr: $elm$core$Maybe$Just(listFuncs)
			});
	});
var $rluiten$elm_text_search$Index$Utils$getOrSetFilterList = function (index) {
	return A4(
		$rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList,
		function (_v0) {
			var irec = _v0;
			return irec.dr;
		},
		function (_v1) {
			var irec = _v1;
			return irec.bG;
		},
		$rluiten$elm_text_search$Index$Utils$setIndexFilters,
		index);
};
var $rluiten$elm_text_search$Index$Utils$applyFilter = F2(
	function (index, strings) {
		var _v0 = $rluiten$elm_text_search$Index$Utils$getOrSetFilterList(index);
		var u1index = _v0.a;
		var filterList = _v0.b;
		return _Utils_Tuple2(
			u1index,
			A2(
				$elm$core$List$filter,
				$rluiten$elm_text_search$Index$Utils$applyFilterList(filterList),
				strings));
	});
var $rluiten$elm_text_search$Index$Utils$applyTransformList = F2(
	function (transforms, token) {
		applyTransformList:
		while (true) {
			if (!transforms.b) {
				return token;
			} else {
				var transform = transforms.a;
				var restTransforms = transforms.b;
				var newToken = transform(token);
				if (newToken === '') {
					return '';
				} else {
					var $temp$transforms = restTransforms,
						$temp$token = newToken;
					transforms = $temp$transforms;
					token = $temp$token;
					continue applyTransformList;
				}
			}
		}
	});
var $rluiten$elm_text_search$Index$Utils$setIndexInitialTransforms = F2(
	function (_v0, listFuncs) {
		var irec = _v0;
		return _Utils_update(
			irec,
			{
				dF: $elm$core$Maybe$Just(listFuncs)
			});
	});
var $rluiten$elm_text_search$Index$Utils$getOrSetInitialTransformList = function (index) {
	return A4(
		$rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList,
		function (_v0) {
			var irec = _v0;
			return irec.dF;
		},
		function (_v1) {
			var irec = _v1;
			return irec.b4;
		},
		$rluiten$elm_text_search$Index$Utils$setIndexInitialTransforms,
		index);
};
var $rluiten$elm_text_search$Index$Utils$applyInitialTransform = F2(
	function (index, strings) {
		var _v0 = $rluiten$elm_text_search$Index$Utils$getOrSetInitialTransformList(index);
		var u1index = _v0.a;
		var intitialTransformList = _v0.b;
		return _Utils_Tuple2(
			u1index,
			A2(
				$elm$core$List$filter,
				function (val) {
					return val !== '';
				},
				A2(
					$elm$core$List$map,
					$rluiten$elm_text_search$Index$Utils$applyTransformList(intitialTransformList),
					strings)));
	});
var $rluiten$elm_text_search$Index$Utils$setIndexTransforms = F2(
	function (_v0, listFuncs) {
		var irec = _v0;
		return _Utils_update(
			irec,
			{
				ew: $elm$core$Maybe$Just(listFuncs)
			});
	});
var $rluiten$elm_text_search$Index$Utils$getOrSetTransformList = function (index) {
	return A4(
		$rluiten$elm_text_search$Index$Utils$getOrSetIndexFuncList,
		function (_v0) {
			var irec = _v0;
			return irec.ew;
		},
		function (_v1) {
			var irec = _v1;
			return irec.cY;
		},
		$rluiten$elm_text_search$Index$Utils$setIndexTransforms,
		index);
};
var $rluiten$elm_text_search$Index$Utils$applyTransform = F2(
	function (index, strings) {
		var _v0 = $rluiten$elm_text_search$Index$Utils$getOrSetTransformList(index);
		var u1index = _v0.a;
		var transformList = _v0.b;
		return _Utils_Tuple2(
			u1index,
			A2(
				$elm$core$List$filter,
				function (val) {
					return val !== '';
				},
				A2(
					$elm$core$List$map,
					$rluiten$elm_text_search$Index$Utils$applyTransformList(transformList),
					strings)));
	});
var $rluiten$elm_text_search$Index$Utils$processTokens = F2(
	function (index, tokens) {
		var _v0 = A2($rluiten$elm_text_search$Index$Utils$applyInitialTransform, index, tokens);
		var u1index = _v0.a;
		var initialTransformTokens = _v0.b;
		var _v1 = A2($rluiten$elm_text_search$Index$Utils$applyFilter, u1index, initialTransformTokens);
		var u2index = _v1.a;
		var filterTokens = _v1.b;
		return A2($rluiten$elm_text_search$Index$Utils$applyTransform, u2index, filterTokens);
	});
var $rluiten$elm_text_search$TokenProcessors$defaultSeparator = $rluiten$elm_text_search$TokenProcessors$forceRegex('[\\s\\-]+');
var $elm$regex$Regex$split = _Regex_splitAtMost(_Regex_infinity);
var $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegex = F2(
	function (seperatorRegex, data) {
		var splitter = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$regex$Regex$split(seperatorRegex),
				$elm$core$String$toLower),
			$elm$core$String$trim);
		return A2(
			$elm$core$List$filter,
			function (token) {
				return $elm$core$String$length(token) > 0;
			},
			splitter(data));
	});
var $rluiten$elm_text_search$TokenProcessors$tokenizer = $rluiten$elm_text_search$TokenProcessors$tokenizerWithRegex($rluiten$elm_text_search$TokenProcessors$defaultSeparator);
var $rluiten$elm_text_search$Index$Utils$getTokens = F2(
	function (index, string) {
		return A2(
			$rluiten$elm_text_search$Index$Utils$processTokens,
			index,
			$rluiten$elm_text_search$TokenProcessors$tokenizer(string));
	});
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $rluiten$trie$TrieModel$expandCore = F3(
	function (key, trie, keyList) {
		var expandSub = F3(
			function (_char, trie1, foldList) {
				return A3(
					$rluiten$trie$TrieModel$expandCore,
					_Utils_ap(
						key,
						_List_fromArray(
							[_char])),
					trie1,
					foldList);
			});
		var addRefKey = function (refValues) {
			return (!$elm$core$Dict$isEmpty(refValues)) ? A2(
				$elm$core$List$cons,
				$elm$core$String$concat(key),
				keyList) : keyList;
		};
		switch (trie.$) {
			case 0:
				return keyList;
			case 1:
				var refValues = trie.a;
				return addRefKey(refValues);
			case 2:
				var trieDict = trie.a;
				return A3($elm$core$Dict$foldr, expandSub, keyList, trieDict);
			default:
				var _v1 = trie.a;
				var refValues = _v1.a;
				var trieDict = _v1.b;
				var dirtyList = addRefKey(refValues);
				return A3($elm$core$Dict$foldr, expandSub, dirtyList, trieDict);
		}
	});
var $rluiten$trie$TrieModel$expandByStr = F2(
	function (key, trie) {
		var _v0 = A2($rluiten$trie$TrieModel$getNodeByStr, key, trie);
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var keyTrie = _v0.a;
			return A3($rluiten$trie$TrieModel$expandCore, key, keyTrie, _List_Nil);
		}
	});
var $rluiten$trie$TrieModel$expand = F2(
	function (key, trie) {
		return A2(
			$rluiten$trie$TrieModel$expandByStr,
			$rluiten$trie$TrieModel$toListString(key),
			trie);
	});
var $rluiten$trie$Trie$expand = $rluiten$trie$TrieModel$expand;
var $rluiten$trie$TrieModel$getValues = function (trie) {
	switch (trie.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var refValues = trie.a;
			return $elm$core$Maybe$Just(refValues);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			var _v1 = trie.a;
			var refValues = _v1.a;
			return $elm$core$Maybe$Just(refValues);
	}
};
var $rluiten$trie$TrieModel$getByStr = F2(
	function (key, trie) {
		return A2(
			$elm$core$Maybe$andThen,
			$rluiten$trie$TrieModel$getValues,
			A2($rluiten$trie$TrieModel$getNodeByStr, key, trie));
	});
var $rluiten$trie$TrieModel$get = F2(
	function (key, trie) {
		return A2(
			$rluiten$trie$TrieModel$getByStr,
			$rluiten$trie$TrieModel$toListString(key),
			trie);
	});
var $rluiten$trie$Trie$get = $rluiten$trie$TrieModel$get;
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $rluiten$trie$TrieModel$valueCount = F2(
	function (key, trie) {
		return $elm$core$Dict$size(
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Dict$empty,
				A2($rluiten$trie$TrieModel$get, key, trie)));
	});
var $rluiten$trie$Trie$valueCount = $rluiten$trie$TrieModel$valueCount;
var $rluiten$elm_text_search$Index$Utils$calcIdf = F2(
	function (_v0, token) {
		var irec = _v0;
		var docFrequency = A2($rluiten$trie$Trie$valueCount, token, irec.bc);
		var idfLocal = (docFrequency > 0) ? (1 + A2(
			$elm$core$Basics$logBase,
			10,
			$elm$core$Dict$size(irec.aV) / docFrequency)) : 1;
		var updatedIdfCache = A3($elm$core$Dict$insert, token, idfLocal, irec.a$);
		var u1index = _Utils_update(
			irec,
			{a$: updatedIdfCache});
		return _Utils_Tuple2(u1index, idfLocal);
	});
var $rluiten$elm_text_search$Index$Utils$idf = F2(
	function (index, token) {
		var irec = index;
		var _v0 = A2($elm$core$Dict$get, token, irec.a$);
		if (_v0.$ === 1) {
			return A2($rluiten$elm_text_search$Index$Utils$calcIdf, index, token);
		} else {
			var idfValue = _v0.a;
			return _Utils_Tuple2(index, idfValue);
		}
	});
var $rluiten$sparsevector$SparseVector$insert = F3(
	function (index, value, svector) {
		return A3($elm$core$Dict$insert, index, value, svector);
	});
var $rluiten$elm_text_search$Index$Vector$similarityBoost = F2(
	function (token, expandedToken) {
		return _Utils_eq(expandedToken, token) ? 1 : (1 / A2(
			$elm$core$Basics$logBase,
			10,
			A2(
				$elm$core$Basics$max,
				3,
				$elm$core$String$length(expandedToken) - $elm$core$String$length(token))));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$union, dict1, dict2);
	});
var $rluiten$elm_text_search$Index$Vector$updateSetAndVec = F4(
	function (tf, token, expandedToken, _v0) {
		var docSets = _v0.a;
		var vec = _v0.b;
		var index = _v0.c;
		var irec = index;
		var _v1 = A2($rluiten$elm_text_search$Index$Utils$idf, index, expandedToken);
		var u1index = _v1.a;
		var u1irec = u1index;
		var keyIdf = _v1.b;
		var tfidf = (tf * keyIdf) * A2($rluiten$elm_text_search$Index$Vector$similarityBoost, token, expandedToken);
		var u1vec = A2(
			$elm$core$Maybe$withDefault,
			vec,
			A2(
				$elm$core$Maybe$map,
				function (pos) {
					return A3($rluiten$sparsevector$SparseVector$insert, pos, tfidf, vec);
				},
				A2($elm$core$Dict$get, expandedToken, irec.bv)));
		var expandedTokenDocSet = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Set$empty,
			A2(
				$elm$core$Maybe$map,
				function (dict) {
					return $elm$core$Set$fromList(
						$elm$core$Dict$keys(dict));
				},
				A2($rluiten$trie$Trie$get, expandedToken, u1irec.bc)));
		var u1docSets = A2($elm$core$Set$union, expandedTokenDocSet, docSets);
		return _Utils_Tuple3(u1docSets, u1vec, u1index);
	});
var $rluiten$elm_text_search$Index$Vector$buildDocVector = F4(
	function (tokensLength, fieldBoosts, baseToken, _v0) {
		var docSets = _v0.a;
		var vec = _v0.b;
		var index = _v0.c;
		var irec = index;
		var termFrequency = ((1 / tokensLength) * $elm$core$List$length(irec.dp)) * fieldBoosts;
		var expandedTokens = A2($rluiten$trie$Trie$expand, baseToken, irec.bc);
		var _v1 = A3(
			$elm$core$List$foldr,
			A2($rluiten$elm_text_search$Index$Vector$updateSetAndVec, termFrequency, baseToken),
			_Utils_Tuple3($elm$core$Set$empty, vec, index),
			expandedTokens);
		var docs = _v1.a;
		var vecU1 = _v1.b;
		var indexU1 = _v1.c;
		return _Utils_Tuple3(
			A2($elm$core$List$cons, docs, docSets),
			vecU1,
			indexU1);
	});
var $rluiten$sparsevector$SparseVector$empty = $elm$core$Dict$empty;
var $rluiten$elm_text_search$Index$Vector$getQueryVector = F3(
	function (fieldBoosts, tokens, index) {
		return A3(
			$elm$core$List$foldr,
			A2(
				$rluiten$elm_text_search$Index$Vector$buildDocVector,
				$elm$core$List$length(tokens),
				fieldBoosts),
			_Utils_Tuple3(_List_Nil, $rluiten$sparsevector$SparseVector$empty, index),
			tokens);
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$intersect, dict1, dict2);
	});
var $rluiten$elm_text_search$Utils$intersectSets = function (sets) {
	if (!sets.b) {
		return $elm$core$Set$empty;
	} else {
		var h = sets.a;
		var tail = sets.b;
		return A3(
			$elm$core$List$foldr,
			F2(
				function (set, agg) {
					return A2($elm$core$Set$intersect, set, agg);
				}),
			h,
			tail);
	}
};
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $rluiten$sparsevector$SparseVector$dot = F2(
	function (vec1, vec2) {
		var common = A2(
			$elm$core$Set$intersect,
			$elm$core$Set$fromList(
				$elm$core$Dict$keys(vec1)),
			$elm$core$Set$fromList(
				$elm$core$Dict$keys(vec2)));
		var d1 = A2(
			$elm$core$Dict$filter,
			F2(
				function (k, v) {
					return A2($elm$core$Set$member, k, common);
				}),
			vec1);
		var d2 = A2(
			$elm$core$Dict$filter,
			F2(
				function (k, v) {
					return A2($elm$core$Set$member, k, common);
				}),
			vec2);
		return $elm$core$List$sum(
			A3(
				$elm$core$List$map2,
				F2(
					function (v1, v2) {
						return v1 * v2;
					}),
				$elm$core$Dict$values(d1),
				$elm$core$Dict$values(d2)));
	});
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $rluiten$sparsevector$SparseVector$magnitude = function (svector) {
	return $elm$core$Basics$sqrt(
		$elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (x) {
					return x * x;
				},
				$elm$core$Dict$values(svector))));
};
var $rluiten$sparsevector$SparseVector$cosineSimilarity = F2(
	function (vec1, vec2) {
		return A2($rluiten$sparsevector$SparseVector$dot, vec1, vec2) / ($rluiten$sparsevector$SparseVector$magnitude(vec1) * $rluiten$sparsevector$SparseVector$magnitude(vec2));
	});
var $rluiten$elm_text_search$Index$Vector$updateDocVector = F3(
	function (docRef, token, inputTuple) {
		var index = inputTuple.a;
		var irec = index;
		var docVector = inputTuple.b;
		return A2(
			$elm$core$Maybe$withDefault,
			inputTuple,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (position, termFrequency) {
						var _v0 = A2($rluiten$elm_text_search$Index$Utils$idf, index, token);
						var u1index = _v0.a;
						var idfScore = _v0.b;
						return _Utils_Tuple2(
							u1index,
							A3($rluiten$sparsevector$SparseVector$insert, position, termFrequency * idfScore, docVector));
					}),
				A2($elm$core$Dict$get, token, irec.bv),
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$Dict$get(docRef),
					A2($rluiten$trie$Trie$get, token, irec.bc))));
	});
var $rluiten$elm_text_search$Index$Vector$getDocVector = F2(
	function (index, docRef) {
		var irec = index;
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(index, $rluiten$sparsevector$SparseVector$empty),
			A2(
				$elm$core$Maybe$map,
				function (tokenSet) {
					return A3(
						$elm$core$List$foldr,
						$rluiten$elm_text_search$Index$Vector$updateDocVector(docRef),
						_Utils_Tuple2(index, $rluiten$sparsevector$SparseVector$empty),
						$elm$core$Set$toList(tokenSet));
				},
				A2($elm$core$Dict$get, docRef, irec.aV)));
	});
var $rluiten$elm_text_search$Index$Vector$scoreAndCompare = F3(
	function (queryVector, ref, _v0) {
		var index = _v0.a;
		var docs = _v0.b;
		var _v1 = A2($rluiten$elm_text_search$Index$Vector$getDocVector, index, ref);
		var u1index = _v1.a;
		var docVector = _v1.b;
		return _Utils_Tuple2(
			u1index,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					ref,
					A2($rluiten$sparsevector$SparseVector$cosineSimilarity, queryVector, docVector)),
				docs));
	});
var $rluiten$elm_text_search$Index$searchTokens = F2(
	function (tokens, index) {
		var irec = index;
		var fieldBoosts = $elm$core$List$sum(
			A2($elm$core$List$map, $elm$core$Tuple$second, irec.dp));
		var _v0 = A3($rluiten$elm_text_search$Index$Vector$getQueryVector, fieldBoosts, tokens, index);
		var tokenDocSets = _v0.a;
		var queryVector = _v0.b;
		var u1index = _v0.c;
		var _v1 = A3(
			$elm$core$List$foldr,
			$rluiten$elm_text_search$Index$Vector$scoreAndCompare(queryVector),
			_Utils_Tuple2(u1index, _List_Nil),
			$elm$core$Set$toList(
				$rluiten$elm_text_search$Utils$intersectSets(tokenDocSets)));
		var u2index = _v1.a;
		var matchedDocs = _v1.b;
		return _Utils_Tuple2(
			u2index,
			$elm$core$List$reverse(
				A2($elm$core$List$sortBy, $elm$core$Tuple$second, matchedDocs)));
	});
var $rluiten$elm_text_search$Index$search = F2(
	function (query, index) {
		var _v0 = A2($rluiten$elm_text_search$Index$Utils$getTokens, index, query);
		var i1index = _v0.a;
		var i1irec = i1index;
		var tokens = _v0.b;
		var tokenInStore = function (token) {
			return !_Utils_eq(
				A2($rluiten$trie$Trie$getNode, token, i1irec.bc),
				$elm$core$Maybe$Nothing);
		};
		return $elm$core$Dict$isEmpty(i1irec.aV) ? $elm$core$Result$Err('Error there are no documents in index to search.') : ($elm$core$String$isEmpty(
			$elm$core$String$trim(query)) ? $elm$core$Result$Err('Error query is empty.') : ($elm$core$List$isEmpty(tokens) ? $elm$core$Result$Err('Error after tokenisation there are no terms to search for.') : (($elm$core$List$isEmpty(tokens) || (!A2($elm$core$List$any, tokenInStore, tokens))) ? $elm$core$Result$Ok(
			_Utils_Tuple2(i1index, _List_Nil)) : $elm$core$Result$Ok(
			A2($rluiten$elm_text_search$Index$searchTokens, tokens, i1index)))));
	});
var $rluiten$elm_text_search$ElmTextSearch$search = $rluiten$elm_text_search$Index$search;
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Search$search = F2(
	function (dm, q) {
		return ($elm$core$String$length(q) <= 2) ? $elm$core$Basics$always(
			$elm$core$Result$Err('Search too short')) : A2(
			$elm$core$Basics$composeR,
			$rluiten$elm_text_search$ElmTextSearch$search(q),
			$elm$core$Result$map(
				$elm$core$Tuple$mapSecond(
					$elm$core$List$take(25))));
	});
var $author$project$View$Search$search = F3(
	function (q, dm, model) {
		var _v0 = model.L;
		if (_v0.$ === 3) {
			var searchIndex = _v0.a;
			var _v1 = A3($author$project$Search$search, dm, q, searchIndex);
			if (_v1.$ === 1) {
				var err = _v1.a;
				return _Utils_update(
					model,
					{
						bX: q,
						bY: $elm$core$Result$Err(err)
					});
			} else {
				var _v2 = _v1.a;
				var index = _v2.a;
				var res = _v2.b;
				return _Utils_update(
					model,
					{
						bX: q,
						bY: $elm$core$Result$Ok(res),
						L: $krisajenkins$remotedata$RemoteData$Success(index)
					});
			}
		} else {
			return _Utils_update(
				model,
				{bX: q});
		}
	});
var $author$project$Page$Search$init = F3(
	function (q, dm, model) {
		return A3(
			$author$project$View$Search$search,
			A2($elm$core$Maybe$withDefault, '', q),
			dm,
			model);
	});
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$langRequest = _Platform_outgoingPort(
	'langRequest',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lang',
					$elm$json$Json$Encode$string($.i)),
					_Utils_Tuple2(
					'revision',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.aM))
				]));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Route$toPath = function (r) {
	toPath:
	while (true) {
		switch (r.$) {
			case 22:
				var next = r.a;
				var $temp$r = next;
				r = $temp$r;
				continue toPath;
			case 23:
				var next = r.b;
				var $temp$r = next;
				r = $temp$r;
				continue toPath;
			case 0:
				return '';
			case 1:
				return 'loot';
			case 2:
				var id = r.a;
				return 'loot/' + id;
			case 3:
				return 'loot/unique';
			case 4:
				var id = r.a;
				return 'loot/unique/' + id;
			case 5:
				var form = r.a;
				return 'skill';
			case 6:
				var id = r.a;
				return 'skill/' + id;
			case 7:
				var id = r.a;
				return 'skill-variant/' + id;
			case 8:
				return 'affix';
			case 9:
				return 'gem';
			case 10:
				return 'passive';
			case 11:
				return 'reagent';
			case 12:
				var name = r.a;
				return 'city/' + name;
			case 13:
				return 'ailment';
			case 14:
				var type_ = r.a;
				var id = r.b;
				return 'source/' + (type_ + ('/' + id));
			case 15:
				var type_ = r.a;
				var id = r.b;
				return 'offline/' + (type_ + ('/' + id));
			case 16:
				return 'search';
			case 17:
				var t = r.a;
				return 'table/' + t;
			case 18:
				return 'build-revision';
			case 19:
				return 'language';
			case 20:
				return 'changelog';
			default:
				return 'privacy';
		}
	}
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Route$toQuery = function (route) {
	toQuery:
	while (true) {
		switch (route.$) {
			case 22:
				var next = route.a;
				var $temp$route = next;
				route = $temp$route;
				continue toQuery;
			case 23:
				var o = route.a;
				var next = route.b;
				var $temp$route = next;
				route = $temp$route;
				continue toQuery;
			case 16:
				var query = route.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('q'),
							query)
						]));
			case 3:
				var tags = route.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('keywords'),
							tags)
						]));
			case 1:
				var tier = route.a;
				var kws = route.b;
				var okws = route.c;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('keywords'),
							kws),
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('optional_keywords'),
							okws),
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$int('tier'),
							tier)
						]));
			case 5:
				var form = route.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							$elm$url$Url$Builder$string('form'),
							form)
						]));
			default:
				return _List_Nil;
		}
	}
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $author$project$Route$toString = function (route) {
	return _Utils_ap(
		$author$project$Route$toPath(route),
		$elm$url$Url$Builder$toQuery(
			$author$project$Route$toQuery(route)));
};
var $author$project$Route$replaceUrl = function (mnav) {
	if (mnav.$ === 1) {
		return $elm$core$Basics$always($elm$core$Platform$Cmd$none);
	} else {
		var nav = mnav.a;
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Route$toString,
			$elm$browser$Browser$Navigation$replaceUrl(nav));
	}
};
var $author$project$Ports$revisionRequest = _Platform_outgoingPort(
	'revisionRequest',
	function ($) {
		return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
	});
var $author$project$Route$Options = F3(
	function (lang, revision, features) {
		return {bF: features, i: lang, aM: revision};
	});
var $author$project$Route$emptyOptions = A3($author$project$Route$Options, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Route$toOptions = function (route) {
	if (route.$ === 23) {
		var o = route.a;
		return o;
	} else {
		return $author$project$Route$emptyOptions;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Route$toMOptions = A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Route$emptyOptions, $author$project$Route$toOptions);
var $author$project$Main$routeTo = F2(
	function (mroute, model0) {
		_v0$2:
		while (true) {
			if (!mroute.$) {
				switch (mroute.a.$) {
					case 22:
						var route = mroute.a.a;
						return _Utils_Tuple2(
							model0,
							A2($author$project$Route$replaceUrl, model0.aI, route));
					case 23:
						var _v1 = mroute.a;
						var opts = _v1.a;
						var route = _v1.b;
						var opts1 = $author$project$Route$toMOptions(mroute);
						var opts0 = $author$project$Route$toMOptions(model0.n);
						var _v2 = A2(
							$author$project$Main$routeTo,
							$elm$core$Maybe$Just(route),
							model0);
						var model1 = _v2.a;
						var cmd1 = _v2.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$batch,
							function (_v5) {
								var m = _v5.a;
								var cmd = _v5.b;
								return _Utils_eq(opts0.aM, opts1.aM) ? _Utils_Tuple2(m, cmd) : _Utils_Tuple2(
									_Utils_update(
										m,
										{o: $krisajenkins$remotedata$RemoteData$Loading}),
									A2(
										$elm$core$List$cons,
										$author$project$Ports$revisionRequest(opts1.aM),
										cmd));
							}(
								function (_v3) {
									var m = _v3.a;
									var cmd = _v3.b;
									if (_Utils_eq(opts0.i, opts1.i)) {
										return _Utils_Tuple2(m, cmd);
									} else {
										var _v4 = opts1.i;
										if (_v4.$ === 1) {
											return _Utils_Tuple2(
												_Utils_update(
													m,
													{i: m.aD}),
												cmd);
										} else {
											var lang = _v4.a;
											return _Utils_Tuple2(
												_Utils_update(
													m,
													{i: $krisajenkins$remotedata$RemoteData$Loading}),
												A2(
													$elm$core$List$cons,
													$author$project$Ports$langRequest(
														{i: lang, aM: opts1.aM}),
													cmd));
										}
									}
								}(
									_Utils_Tuple2(
										_Utils_update(
											model1,
											{n: mroute}),
										_List_fromArray(
											[cmd1])))));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		var _v6 = model0.o;
		if (_v6.$ === 3) {
			var dm = _v6.a;
			var model = _Utils_update(
				model0,
				{n: mroute});
			if ((!mroute.$) && (mroute.a.$ === 16)) {
				var q = mroute.a.a;
				return _Utils_Tuple2(
					A3($author$project$Page$Search$init, q, dm, model),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model0,
					{n: mroute}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $elm$core$Set$singleton = function (key) {
	return A2($elm$core$Dict$singleton, key, 0);
};
var $author$project$Main$init_ = F3(
	function (flags, route, nav) {
		var defaultLang = A2(
			$author$project$Main$maybeDecode,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeValue($author$project$Lang$decoder),
				$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
			flags.o);
		return A2(
			$author$project$Main$routeTo,
			route,
			{
				ay: flags.ay,
				az: flags.az,
				bp: 0,
				o: A2($author$project$Main$maybeDecode, $author$project$Datamine$decode, flags.o),
				aD: defaultLang,
				bD: $elm$core$Set$empty,
				bH: $elm$core$Set$singleton('default'),
				bI: $elm$core$Set$empty,
				bJ: $elm$core$Set$empty,
				bK: 0,
				bL: $elm$core$Set$empty,
				bM: $elm$core$Set$empty,
				bX: '',
				bY: $elm$core$Result$Ok(_List_Nil),
				i: defaultLang,
				aG: flags.aG,
				aI: nav,
				aq: $elm$core$Dict$empty,
				n: $elm$core$Maybe$Nothing,
				L: A2($author$project$Main$maybeDecode, $author$project$Search$decodeIndex, flags.L)
			});
	});
var $author$project$Route$WithOptions = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {I: frag, d1: params, H: unvisited, A: value, O: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.H;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.A);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.A);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.a5),
					$elm$url$Url$Parser$prepareQuery(url.cu),
					url.ds,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$Affixes = {$: 8};
var $author$project$Route$Ailments = {$: 13};
var $author$project$Route$BuildRevisions = {$: 18};
var $author$project$Route$Changelog = {$: 20};
var $author$project$Route$City = function (a) {
	return {$: 12, a: a};
};
var $author$project$Route$Gems = {$: 9};
var $author$project$Route$Home = {$: 0};
var $author$project$Route$Langs = {$: 19};
var $author$project$Route$NormalItem = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$NormalItems = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Route$Offline = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Route$Passives = {$: 10};
var $author$project$Route$Privacy = {$: 21};
var $author$project$Route$Reagents = {$: 11};
var $author$project$Route$Redirect = function (a) {
	return {$: 22, a: a};
};
var $author$project$Route$Search = function (a) {
	return {$: 16, a: a};
};
var $author$project$Route$Skill = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$SkillVariant = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$Skills = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$Source = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Route$Table = function (a) {
	return {$: 17, a: a};
};
var $author$project$Route$UniqueItem = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$UniqueItems = function (a) {
	return {$: 3, a: a};
};
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.O;
		var unvisited = _v0.H;
		var params = _v0.d1;
		var frag = _v0.I;
		var value = _v0.A;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.O;
			var unvisited = _v1.H;
			var params = _v1.d1;
			var frag = _v1.I;
			var value = _v1.A;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.O;
		var unvisited = _v1.H;
		var params = _v1.d1;
		var frag = _v1.I;
		var value = _v1.A;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.O;
		var unvisited = _v0.H;
		var params = _v0.d1;
		var frag = _v0.I;
		var value = _v0.A;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.O;
			var unvisited = _v0.H;
			var params = _v0.d1;
			var frag = _v0.I;
			var value = _v0.A;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$baseParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$Home, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Skills,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('skill'),
				$elm$url$Url$Parser$Query$string('form'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Skill,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('skill'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SkillVariant,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('skill-variant'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Affixes,
			$elm$url$Url$Parser$s('affix')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Gems,
			$elm$url$Url$Parser$s('gem')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Passives,
			$elm$url$Url$Parser$s('passive')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Reagents,
			$elm$url$Url$Parser$s('reagent')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$City,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('city'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Ailments,
			$elm$url$Url$Parser$s('ailment')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Source,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('source'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Offline,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('offline'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Search,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s('search'),
				$elm$url$Url$Parser$Query$string('q'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Table,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('table'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$BuildRevisions,
			$elm$url$Url$Parser$s('build-revision')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Langs,
			$elm$url$Url$Parser$s('language')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Changelog,
			$elm$url$Url$Parser$s('changelog')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Privacy,
			$elm$url$Url$Parser$s('privacy')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect(
				A3(
					$author$project$Route$NormalItems,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just('weapon'),
					$elm$core$Maybe$Nothing)),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				$elm$url$Url$Parser$s('weapon'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect(
				A3(
					$author$project$Route$NormalItems,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just('shield'),
					$elm$core$Maybe$Nothing)),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				$elm$url$Url$Parser$s('shield'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect(
				A3(
					$author$project$Route$NormalItems,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just('armor'),
					$elm$core$Maybe$Nothing)),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				$elm$url$Url$Parser$s('armor'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect(
				A3(
					$author$project$Route$NormalItems,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just('accessory'),
					$elm$core$Maybe$Nothing)),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				$elm$url$Url$Parser$s('accessory'))),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Route$Redirect, $author$project$Route$NormalItem),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('weapon'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Route$Redirect, $author$project$Route$NormalItem),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('shield'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Route$Redirect, $author$project$Route$NormalItem),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('armor'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Route$Redirect, $author$project$Route$NormalItem),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('accessory'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect(
				$author$project$Route$UniqueItems(
					$elm$core$Maybe$Just('weapon'))),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					$elm$url$Url$Parser$s('weapon')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect(
				$author$project$Route$UniqueItems(
					$elm$core$Maybe$Just('shield'))),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					$elm$url$Url$Parser$s('shield')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect(
				$author$project$Route$UniqueItems(
					$elm$core$Maybe$Just('armor'))),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					$elm$url$Url$Parser$s('armor')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Redirect(
				$author$project$Route$UniqueItems(
					$elm$core$Maybe$Just('accessory'))),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					$elm$url$Url$Parser$s('accessory')))),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Route$Redirect, $author$project$Route$UniqueItem),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('weapon'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Route$Redirect, $author$project$Route$UniqueItem),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('shield'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Route$Redirect, $author$project$Route$UniqueItem),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('armor'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Route$Redirect, $author$project$Route$UniqueItem),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('accessory'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$UniqueItems,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s('unique'),
					$elm$url$Url$Parser$Query$string('keywords')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$UniqueItem,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('unique'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$NormalItems,
			A2(
				$elm$url$Url$Parser$questionMark,
				A2(
					$elm$url$Url$Parser$questionMark,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s('loot'),
						$elm$url$Url$Parser$Query$int('tier')),
					$elm$url$Url$Parser$Query$string('keywords')),
				$elm$url$Url$Parser$Query$string('optional_keywords'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$NormalItem,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('loot'),
				$elm$url$Url$Parser$string))
		]));
var $author$project$Route$maybeStringParser = function (path) {
	return $elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Parser$map,
				$elm$core$Maybe$Just,
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s(path),
					$elm$url$Url$Parser$string)),
				A2($elm$url$Url$Parser$map, $elm$core$Maybe$Nothing, $elm$url$Url$Parser$top)
			]));
};
var $author$project$Route$optionsParser = A2(
	$elm$url$Url$Parser$map,
	$author$project$Route$Options,
	A2(
		$elm$url$Url$Parser$slash,
		$elm$url$Url$Parser$top,
		A2(
			$elm$url$Url$Parser$slash,
			$author$project$Route$maybeStringParser('l'),
			A2(
				$elm$url$Url$Parser$slash,
				$author$project$Route$maybeStringParser('v'),
				$author$project$Route$maybeStringParser('f')))));
var $author$project$Route$parser = A2(
	$elm$url$Url$Parser$map,
	$elm$core$Tuple$pair,
	A2(
		$elm$url$Url$Parser$slash,
		$author$project$Route$optionsParser,
		$elm$url$Url$Parser$oneOf(
			_List_fromArray(
				[
					A2($elm$url$Url$Parser$map, $elm$core$Maybe$Just, $author$project$Route$baseParser),
					A2($elm$url$Url$Parser$map, $elm$core$Maybe$Nothing, $elm$url$Url$Parser$top)
				]))));
var $author$project$Route$parse = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$Parser$parse($author$project$Route$parser),
	$elm$core$Maybe$andThen(
		function (_v0) {
			var o = _v0.a;
			var route = _v0.b;
			return _Utils_eq(o, $author$project$Route$emptyOptions) ? route : A2(
				$elm$core$Maybe$map,
				$author$project$Route$WithOptions(o),
				route);
		}));
var $author$project$Ports$ssr = _Platform_outgoingPort('ssr', $elm$json$Json$Encode$string);
var $author$project$View$Loading$ssrRootId = 'ssr-root';
var $author$project$Main$init = F3(
	function (flags, url, nav) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (cmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							$author$project$Ports$ssr($author$project$View$Loading$ssrRootId)
						]));
			},
			A3(
				$author$project$Main$init_,
				flags,
				$author$project$Route$parse(url),
				$elm$core$Maybe$Just(nav)));
	});
var $author$project$Main$LoadAssets = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$LoadAssetsFailure = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$LoadAssetsProgress = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Ports$loadAssets = _Platform_incomingPort(
	'loadAssets',
	A2(
		$elm$json$Json$Decode$andThen,
		function (revision) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (name) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (json) {
							return $elm$json$Json$Decode$succeed(
								{aF: json, q: name, aM: revision});
						},
						A2($elm$json$Json$Decode$field, 'json', $elm$json$Json$Decode$value));
				},
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'revision',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
					])))));
var $author$project$Ports$loadAssetsFailure = _Platform_incomingPort(
	'loadAssetsFailure',
	A2(
		$elm$json$Json$Decode$andThen,
		function (revision) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (name) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (err) {
							return $elm$json$Json$Decode$succeed(
								{aX: err, q: name, aM: revision});
						},
						A2($elm$json$Json$Decode$field, 'err', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
		},
		A2(
			$elm$json$Json$Decode$field,
			'revision',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
					])))));
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Ports$loadAssetsProgress = _Platform_incomingPort(
	'loadAssetsProgress',
	A2(
		$elm$json$Json$Decode$andThen,
		function (size) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (revision) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (progress) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (name) {
									return $elm$json$Json$Decode$succeed(
										{q: name, aq: progress, aM: revision, em: size});
								},
								A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'progress', $elm$json$Json$Decode$int));
				},
				A2(
					$elm$json$Json$Decode$field,
					'revision',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$field, 'size', $elm$json$Json$Decode$int)));
var $author$project$Main$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$loadAssets($author$project$Main$LoadAssets),
				$author$project$Ports$loadAssetsProgress($author$project$Main$LoadAssetsProgress),
				$author$project$Ports$loadAssetsFailure($author$project$Main$LoadAssetsFailure)
			]));
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Main$remoteDataOr = F2(
	function (a, b) {
		if (a.$ === 3) {
			return a;
		} else {
			return b;
		}
	});
var $author$project$Main$NavMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Main$Noop = {$: 0};
var $author$project$Main$SearchMsg = function (a) {
	return {$: 9, a: a};
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Route$toAnalytics = function (mroute) {
	if (mroute.$ === 1) {
		return '/404';
	} else {
		var route = mroute.a;
		switch (route.$) {
			case 23:
				var next = route.b;
				return $author$project$Route$toAnalytics(
					$elm$core$Maybe$Just(next));
			case 2:
				return $author$project$Route$toPath(
					$author$project$Route$NormalItem('ID'));
			case 4:
				return $author$project$Route$toPath(
					$author$project$Route$UniqueItem('ID'));
			case 6:
				return $author$project$Route$toPath(
					$author$project$Route$Skill('ID'));
			case 7:
				return $author$project$Route$toPath(
					$author$project$Route$SkillVariant('ID'));
			case 12:
				return $author$project$Route$toPath(
					$author$project$Route$City('ID'));
			case 14:
				return $author$project$Route$toPath(
					A2($author$project$Route$Source, 'TYPE', 'ID'));
			case 15:
				return $author$project$Route$toPath(
					A2($author$project$Route$Offline, 'TYPE', 'ID'));
			case 17:
				return $author$project$Route$toPath(
					$author$project$Route$Table('ID'));
			default:
				return $author$project$Route$toPath(route);
		}
	}
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.d6;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.ds,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.cu,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.d3,
					_Utils_ap(http, url.dz)),
				url.a5)));
};
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Util$toggleSet = F2(
	function (k, ks) {
		return A2($elm$core$Set$member, k, ks) ? A2($elm$core$Set$remove, k, ks) : A2($elm$core$Set$insert, k, ks);
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $author$project$View$AffixFilterForm$update = F3(
	function (msg, dm, model) {
		switch (msg.$) {
			case 0:
				var s = msg.a;
				if (s === '') {
					return _Utils_update(
						model,
						{bK: 0});
				} else {
					var _v1 = $elm$core$String$toInt(s);
					if (_v1.$ === 1) {
						return model;
					} else {
						var i = _v1.a;
						return _Utils_update(
							model,
							{
								bK: A3($elm$core$Basics$clamp, 0, 200, i)
							});
					}
				}
			case 1:
				var name = msg.a;
				return _Utils_update(
					model,
					{
						bI: A2($author$project$Util$toggleSet, name, model.bI)
					});
			case 2:
				var kw = msg.a;
				return _Utils_update(
					model,
					{
						bL: A2($author$project$Util$toggleSet, kw, model.bL)
					});
			case 3:
				var kw = msg.a;
				return _Utils_update(
					model,
					{
						bJ: A2($author$project$Util$toggleSet, kw, model.bJ)
					});
			case 4:
				var kw = msg.a;
				return _Utils_update(
					model,
					{
						bM: A2($author$project$Util$toggleSet, kw, model.bM)
					});
			default:
				var kw = msg.a;
				return _Utils_update(
					model,
					{
						bH: A2($author$project$Util$toggleSet, kw, model.bH)
					});
		}
	});
var $author$project$Page$Affixes$update = F3(
	function (msg, dm, model) {
		if (!msg.$) {
			var cls = msg.a;
			return _Utils_update(
				model,
				{
					bD: A2($author$project$Util$toggleSet, cls, model.bD)
				});
		} else {
			var msg_ = msg.a;
			return A3($author$project$View$AffixFilterForm$update, msg_, dm, model);
		}
	});
var $author$project$Page$Ailments$update = F3(
	function (msg, dm, model) {
		var str = msg;
		if (str === '') {
			return _Utils_update(
				model,
				{bp: 0});
		} else {
			var _v1 = $elm$core$String$toInt(str);
			if (_v1.$ === 1) {
				return model;
			} else {
				var n = _v1.a;
				return _Utils_update(
					model,
					{
						bp: A3($elm$core$Basics$clamp, 0, 90, n)
					});
			}
		}
	});
var $author$project$Page$City$update = F2(
	function (msg, model) {
		var str = msg;
		if (str === '') {
			return _Utils_update(
				model,
				{bp: 0});
		} else {
			var _v1 = $elm$core$String$toInt(str);
			if (_v1.$ === 1) {
				return model;
			} else {
				var n = _v1.a;
				return _Utils_update(
					model,
					{
						bp: A3($elm$core$Basics$clamp, 0, 90, n)
					});
			}
		}
	});
var $author$project$View$Affix$update = F2(
	function (msg, model) {
		var _class = msg;
		return _Utils_update(
			model,
			{
				bD: A2($author$project$Util$toggleSet, _class, model.bD)
			});
	});
var $author$project$Page$NormalItem$update = F3(
	function (msg, dm, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			return A2($author$project$View$Affix$update, msg_, model);
		} else {
			var msg_ = msg.a;
			return A3($author$project$View$AffixFilterForm$update, msg_, dm, model);
		}
	});
var $author$project$Route$pushUrl = function (mnav) {
	if (mnav.$ === 1) {
		return $elm$core$Basics$always($elm$core$Platform$Cmd$none);
	} else {
		var nav = mnav.a;
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Route$toString,
			$elm$browser$Browser$Navigation$pushUrl(nav));
	}
};
var $author$project$Page$Search$update = F3(
	function (msg, dm, model) {
		if (!msg.$) {
			var q = msg.a;
			return _Utils_Tuple2(
				A3($author$project$View$Search$search, q, dm, model),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				model,
				A2(
					$author$project$Route$pushUrl,
					model.aI,
					$author$project$Route$Search(
						$elm$core$Maybe$Just(model.bX))));
		}
	});
var $author$project$View$Nav$update = F3(
	function (msg, dm, model) {
		if (!msg.$) {
			var q = msg.a;
			return _Utils_Tuple2(
				A3($author$project$View$Search$search, q, dm, model),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				model,
				A2(
					$author$project$Route$pushUrl,
					model.aI,
					$author$project$Route$Search(
						$elm$core$Maybe$Just(model.bX))));
		}
	});
var $author$project$Ports$urlChange = _Platform_outgoingPort(
	'urlChange',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'path',
					$elm$json$Json$Encode$string($.a5)),
					_Utils_Tuple2(
					'query',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.cu)),
					_Utils_Tuple2(
					'route',
					$elm$json$Json$Encode$string($.n))
				]));
	});
var $author$project$Main$updateOk = F3(
	function (msg, dm, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var res = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var res = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				var res = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 4:
				var url = msg.a;
				var route = $author$project$Route$parse(url);
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									function () {
									if ((!route.$) && (route.a.$ === 22)) {
										return $elm$core$Platform$Cmd$none;
									} else {
										return $author$project$Ports$urlChange(
											{
												a5: url.a5,
												cu: url.cu,
												n: $author$project$Route$toAnalytics(route)
											});
									}
								}()
								]));
					},
					A2($author$project$Main$routeTo, route, model));
			case 5:
				if (!msg.a.$) {
					var url = msg.a.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									function () {
									var _v2 = model.aI;
									if (_v2.$ === 1) {
										return $elm$core$Platform$Cmd$none;
									} else {
										var nav = _v2.a;
										return A2(
											$elm$browser$Browser$Navigation$pushUrl,
											nav,
											$elm$url$Url$toString(url));
									}
								}(),
									A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always($author$project$Main$Noop),
									A2($elm$browser$Browser$Dom$setViewport, 0, 0))
								])));
				} else {
					var url = msg.a.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 6:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Page$NormalItem$update, msg_, dm, model),
					$elm$core$Platform$Cmd$none);
			case 7:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Page$Affixes$update, msg_, dm, model),
					$elm$core$Platform$Cmd$none);
			case 8:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					A2($author$project$View$Affix$update, msg_, model),
					$elm$core$Platform$Cmd$none);
			case 9:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Main$SearchMsg),
					A3($author$project$Page$Search$update, msg_, dm, model));
			case 10:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Page$City$update, msg_, model),
					$elm$core$Platform$Cmd$none);
			case 11:
				var msg_ = msg.a;
				return _Utils_Tuple2(
					A3($author$project$Page$Ailments$update, msg_, dm, model),
					$elm$core$Platform$Cmd$none);
			default:
				var msg_ = msg.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Main$NavMsg),
					A3($author$project$View$Nav$update, msg_, dm, model));
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var res = msg.a;
				var opts = $author$project$Route$toMOptions(model.n);
				var name = _Utils_ap(
					res.q,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$elm$core$Basics$append('/'),
						res.aM));
				return A2(
					$author$project$Main$routeTo,
					model.n,
					function () {
						if (_Utils_eq(opts.aM, res.aM)) {
							var _v1 = res.q;
							switch (_v1) {
								case 'datamine':
									var defaultLang = $krisajenkins$remotedata$RemoteData$fromResult(
										A2(
											$elm$core$Result$mapError,
											$elm$json$Json$Decode$errorToString,
											A2($elm$json$Json$Decode$decodeValue, $author$project$Lang$decoder, res.aF)));
									return _Utils_update(
										model,
										{
											o: $krisajenkins$remotedata$RemoteData$fromResult(
												$author$project$Datamine$decode(res.aF)),
											aD: defaultLang,
											i: function () {
												var _v2 = model.i;
												switch (_v2.$) {
													case 3:
														return model.i;
													case 2:
														return model.i;
													default:
														return defaultLang;
												}
											}()
										});
								case 'searchIndex':
									return _Utils_update(
										model,
										{
											L: $krisajenkins$remotedata$RemoteData$fromResult(
												$author$project$Search$decodeIndex(res.aF))
										});
								default:
									if (A2($elm$core$String$startsWith, 'lang/', res.q)) {
										var _v3 = A2($elm$json$Json$Decode$decodeValue, $author$project$Lang$decoder, res.aF);
										if (!_v3.$) {
											var lang = _v3.a;
											return _Utils_update(
												model,
												{
													i: $krisajenkins$remotedata$RemoteData$Success(lang)
												});
										} else {
											var err = _v3.a;
											return model;
										}
									} else {
										return model;
									}
							}
						} else {
							return model;
						}
					}());
			case 2:
				var res = msg.a;
				var opts = $author$project$Route$toMOptions(model.n);
				var name = _Utils_ap(
					res.q,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$elm$core$Basics$append('/'),
						res.aM));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aq: A3(
								$elm$core$Dict$insert,
								name,
								_Utils_Tuple2(res.aq, res.em),
								model.aq)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var err = msg.a;
				var opts = $author$project$Route$toMOptions(model.n);
				var name = _Utils_ap(
					err.q,
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$elm$core$Basics$append('/'),
						err.aM));
				return _Utils_Tuple2(
					function () {
						if (_Utils_eq(opts.aM, err.aM)) {
							var _v4 = err.q;
							switch (_v4) {
								case 'datamine':
									return _Utils_update(
										model,
										{
											o: A2(
												$author$project$Main$remoteDataOr,
												model.o,
												$krisajenkins$remotedata$RemoteData$Failure('Couldn\'t fetch datamine. Something is very wrong.\n\n' + err.aX))
										});
								case 'searchIndex':
									return _Utils_update(
										model,
										{
											L: A2(
												$author$project$Main$remoteDataOr,
												model.L,
												$krisajenkins$remotedata$RemoteData$Failure('Couldn\'t fetch searchIndex. Something is very wrong.\n\n' + err.aX))
										});
								default:
									var _v5 = opts.i;
									if (!_v5.$) {
										var lang = _v5.a;
										return _Utils_eq(err.q, 'lang/' + (lang + '_xml')) ? _Utils_update(
											model,
											{
												i: $krisajenkins$remotedata$RemoteData$Failure('Couldn\'t fetch lang/' + (lang + ('. Something is very wrong.\n\n' + err.aX)))
											}) : model;
									} else {
										return model;
									}
							}
						} else {
							return model;
						}
					}(),
					$elm$core$Platform$Cmd$none);
			default:
				var _v6 = model.o;
				if (_v6.$ === 3) {
					var dm = _v6.a;
					return A3($author$project$Main$updateOk, msg, dm, model);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Main$AilmentsMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Main$CityMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$NormalItemMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Main$PageAffixesMsg = function (a) {
	return {$: 7, a: a};
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Route$optionsPath = function (o) {
	return A2(
		$elm$core$String$join,
		'/',
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					['']),
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (l) {
						return _List_fromArray(
							['l', l]);
					},
					o.i),
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (v) {
						return _List_fromArray(
							['v', v]);
					},
					o.aM),
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					function (f) {
						return _List_fromArray(
							['f', f]);
					},
					o.bF),
					_List_fromArray(
					[''])
				])));
};
var $author$project$Route$base = function (o) {
	return A3(
		$elm$html$Html$node,
		'base',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(
				$author$project$Route$optionsPath(o))
			]),
		_List_Nil);
};
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _v0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var f = _v0.a.a;
										var value = _v0.b.a;
										return $krisajenkins$remotedata$RemoteData$Success(
											f(value));
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									default:
										var _v4 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 2:
								var error = _v0.a.a;
								return $krisajenkins$remotedata$RemoteData$Failure(error);
							case 1:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$3;
									case 0:
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									case 0:
										break _v0$5;
									default:
										break _v0$5;
								}
						}
					}
					var _v3 = _v0.a;
					return $krisajenkins$remotedata$RemoteData$NotAsked;
				}
				var _v2 = _v0.b;
				return $krisajenkins$remotedata$RemoteData$Loading;
			}
			var _v1 = _v0.a;
			return $krisajenkins$remotedata$RemoteData$Loading;
		}
		var error = _v0.b.a;
		return $krisajenkins$remotedata$RemoteData$Failure(error);
	});
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2($krisajenkins$remotedata$RemoteData$map, f, a));
	});
var $author$project$Page$Affixes$FormMsg = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$View$Affix$affixesByClass = function (affixes) {
	var classOrId = function (a) {
		return A2($elm$core$Maybe$withDefault, a.ax, a.bt);
	};
	var classOrder = $elm_community$list_extra$List$Extra$unique(
		A2($elm$core$List$map, classOrId, affixes));
	var byClass = A2($elm_community$dict_extra$Dict$Extra$groupBy, classOrId, affixes);
	return A2(
		$elm$core$List$filterMap,
		function (c) {
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(c),
				A2($elm$core$Dict$get, c, byClass));
		},
		classOrder);
};
var $author$project$Route$href = A2($elm$core$Basics$composeR, $author$project$Route$toString, $elm$html$Html$Attributes$href);
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Datamine$GemFamily$fromAffix = F2(
	function (dm, affix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Dict$get,
				$elm$core$String$toLower(affix.ax),
				dm.bQ));
	});
var $author$project$Datamine$GemFamily$filterAffix = F2(
	function (dm, famIds) {
		return _Utils_eq(famIds, $elm$core$Set$empty) ? $elm$core$Basics$always(true) : A2(
			$elm$core$Basics$composeR,
			$author$project$Datamine$GemFamily$fromAffix(dm),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function ($) {
						return $.bU;
					}),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Set$fromList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Set$intersect(famIds),
						A2($elm$core$Basics$composeR, $elm$core$Set$isEmpty, $elm$core$Basics$not)))));
	});
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$View$AffixFilterForm$isVisible = F3(
	function (dm, model, aff) {
		return ((model.bK <= 0) || ((_Utils_cmp(model.bK, aff.bz.dH.dS) > -1) && (_Utils_cmp(model.bK, aff.bz.dH.dQ) < 1))) && (A3($author$project$Datamine$GemFamily$filterAffix, dm, model.bI, aff) && ((!((aff.ex === 'slave') || (aff.bz.dA && A2(
			$elm$core$String$startsWith,
			'slave_',
			A2($elm$core$Maybe$withDefault, '', aff.bt))))) && ((A2($elm$core$Set$member, 'hidden', model.bH) || (aff.bz.dt > 0)) && (A2($elm$core$Set$member, 'default', model.bH) || (aff.bz.dt <= 0)))));
	});
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Page$Affixes$ExpandClass = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$Datamine$Affix$formatEffectOverrides = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('cast_deathmark_on_hit', '@ui_eim_deathmark_on_hit'),
			_Utils_Tuple2('umbracosts_percent_elemental', '@ui_eim_umbracost_percent_elemental'),
			_Utils_Tuple2('criticaldamage_on_bleeding', '@ui_eim_criticaldamage_on_bleeding_pts'),
			_Utils_Tuple2('convert_physical_to_frost', '@ui_eim_convert_physcial_to_frost')
		]));
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Util$formatFloat = F2(
	function (digits, f) {
		var s = $elm$core$String$fromFloat(f);
		var _v0 = A2($elm$core$String$split, '.', s);
		_v0$2:
		while (true) {
			if (_v0.b) {
				if (_v0.b.b) {
					if (!_v0.b.b.b) {
						var head = _v0.a;
						var _v1 = _v0.b;
						var tail = _v1.a;
						return (_Utils_cmp(
							$elm$core$String$length(head),
							digits) > -1) ? head : A2($elm$core$String$left, digits + 1, s);
					} else {
						break _v0$2;
					}
				} else {
					return s;
				}
			} else {
				break _v0$2;
			}
		}
		return s;
	});
var $author$project$Datamine$Util$formatEffectStat = function (_v0) {
	var index = _v0.a;
	var _v1 = _v0.b;
	var name = _v1.a;
	var stat = _v1.b;
	var val = _Utils_eq(stat.dS, stat.dQ) ? A2($author$project$Util$formatFloat, 5, stat.dS) : ('(' + (A2($author$project$Util$formatFloat, 5, stat.dS) + ('-' + (A2($author$project$Util$formatFloat, 5, stat.dQ) + ')'))));
	var suffix = A2(
		$elm$core$String$contains,
		'percent',
		$elm$core$String$toLower(name)) ? '%' : '';
	return A2(
		$elm$core$String$replace,
		'%' + $elm$core$String$fromInt(index + 1),
		_Utils_ap(val, suffix));
};
var $author$project$Lang$get = F2(
	function (_v0, key) {
		var d = _v0;
		return A2(
			$elm$core$Dict$get,
			$elm$core$String$toLower(key),
			d);
	});
var $author$project$Datamine$Affix$formatEffect = F2(
	function (lang, effect) {
		var stats = (effect.ai === 'default_attacks_chain') ? $elm$core$List$reverse(effect.ba) : effect.ba;
		var key = A2(
			$elm$core$Maybe$withDefault,
			'@ui_eim_' + effect.ai,
			A2($elm$core$Dict$get, effect.ai, $author$project$Datamine$Affix$formatEffectOverrides));
		return A2(
			$elm$core$Maybe$map,
			function (template) {
				return A3(
					$elm$core$List$foldl,
					$author$project$Datamine$Util$formatEffectStat,
					template,
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, stats));
			},
			A2($author$project$Lang$get, lang, key));
	});
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$View$Affix$summarizeEffects = function (effects) {
	var foldStats = F2(
		function (a, b) {
			var bStats = $elm$core$Dict$fromList(b.ba);
			return _Utils_update(
				a,
				{
					ba: A2(
						$elm$core$List$map,
						function (_v1) {
							var k = _v1.a;
							var av = _v1.b;
							return _Utils_Tuple2(
								k,
								function () {
									var _v2 = A2($elm$core$Dict$get, k, bStats);
									if (_v2.$ === 1) {
										return av;
									} else {
										var bv = _v2.a;
										return {
											dQ: A2($elm$core$Basics$max, av.dQ, bv.dQ),
											dS: A2($elm$core$Basics$min, av.dS, bv.dS)
										};
									}
								}());
						},
						a.ba)
				});
		});
	var byId = A2(
		$elm_community$dict_extra$Dict$Extra$filterMap,
		F2(
			function (k, es) {
				if (!es.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!es.b.b) {
						var e = es.a;
						return $elm$core$Maybe$Just(e);
					} else {
						var head = es.a;
						var tail = es.b;
						return $elm$core$Maybe$Just(
							A3($elm$core$List$foldl, foldStats, head, tail));
					}
				}
			}),
		A2(
			$elm_community$dict_extra$Dict$Extra$groupBy,
			function ($) {
				return $.ai;
			},
			effects));
	return A2(
		$elm$core$List$filterMap,
		function (e) {
			return A2($elm$core$Dict$get, e, byId);
		},
		$elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.ai;
				},
				effects)));
};
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Page$Affixes$viewAffixClassRow = F4(
	function (lang, dm, model, _v0) {
		var cls = _v0.a;
		var affixes = _v0.b;
		var keywords = function () {
			var _v2 = A2(
				$elm$core$List$map,
				function (a) {
					return _Utils_ap(a.bz.dO, a.bz.d$);
				},
				affixes);
			if (!_v2.b) {
				return _List_Nil;
			} else {
				var head = _v2.a;
				var tail = _v2.b;
				var all = A3(
					$elm$core$List$foldl,
					A2($elm$core$Basics$composeR, $elm$core$Set$fromList, $elm$core$Set$intersect),
					$elm$core$Set$fromList(head),
					tail);
				return A2(
					$elm$core$List$filter,
					function (k) {
						return A2($elm$core$Set$member, k, all);
					},
					head);
			}
		}();
		var isExpanded = A2($elm$core$Set$member, cls, model.bD);
		var gentypes = function () {
			var _v1 = $elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.ex;
					},
					affixes));
			if (!_v1.b) {
				return _List_Nil;
			} else {
				if (!_v1.b.b) {
					var a = _v1.a;
					return _List_fromArray(
						[a]);
				} else {
					return _List_Nil;
				}
			}
		}();
		var effects = A2(
			$elm$core$List$filterMap,
			$author$project$Datamine$Affix$formatEffect(lang),
			$author$project$View$Affix$summarizeEffects(
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.aW;
					},
					affixes)));
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('expand-affix-class'),
					$elm$html$Html$Attributes$title('Affix class: ' + (cls + ' \nNo more than one affix from the same class may appear on an item')),
					$elm$html$Html$Events$onClick(
					$author$project$Page$Affixes$ExpandClass(cls))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('fa-caret-down', isExpanded),
											_Utils_Tuple2('fa-caret-right', !isExpanded)
										]))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (e) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(e)
									]));
						},
						effects)),
					A2($elm$html$Html$td, _List_Nil, _List_Nil),
					A2($elm$html$Html$td, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (k) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('badge')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(k)
									]));
						},
						_Utils_ap(keywords, gentypes))),
					A2($elm$html$Html$td, _List_Nil, _List_Nil),
					A2($elm$html$Html$td, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-outline-secondary p-1 nowrap')
								]),
							isExpanded ? _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-caret-down'),
											A2($elm$html$Html$Attributes$style, 'display', 'inline')
										]),
									_List_Nil),
									$elm$html$Html$text(' Hide')
								]) : _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-caret-right'),
											A2($elm$html$Html$Attributes$style, 'display', 'inline')
										]),
									_List_Nil),
									$elm$html$Html$text(' Expand')
								]))
						]))
				]));
	});
var $author$project$Route$keywords = function (kws) {
	if (!kws.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(
			A2($elm$core$String$join, ',', kws));
	}
};
var $author$project$Route$normalItems = F3(
	function (tier, kws, okws) {
		return A3(
			$author$project$Route$NormalItems,
			tier,
			$author$project$Route$keywords(kws),
			$author$project$Route$keywords(okws));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$View$Affix$viewEffect = F2(
	function (lang, effect) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$title(
						'@ui_eim_' + (effect.ai + ('; ' + A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $elm$core$Tuple$first, effect.ba)))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$Affix$formatEffect, lang, effect)))
					]))
			]);
	});
var $author$project$View$Affix$viewAffixes = function (lang) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$concatMap(
			function ($) {
				return $.aW;
			}),
		$elm$core$List$map(
			A2(
				$elm$core$Basics$composeR,
				$author$project$View$Affix$viewEffect(lang),
				$elm$html$Html$li(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item')
						])))));
};
var $author$project$View$Affix$viewAffix = F2(
	function (lang, a) {
		return A2(
			$author$project$View$Affix$viewAffixes,
			lang,
			_List_fromArray(
				[a]));
	});
var $elm$html$Html$details = _VirtualDom_node('details');
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $author$project$View$Affix$viewAffixEnslaved = F3(
	function (lang, dm, a) {
		var enslaved = A3(
			$elm$core$List$foldl,
			F2(
				function (cls, accum) {
					var _v2 = A2($elm$core$Dict$get, cls, dm.cc);
					if (_v2.$ === 1) {
						return _Utils_update(
							accum,
							{
								Q: A2($elm$core$List$cons, cls, accum.Q)
							});
					} else {
						var es = _v2.a;
						return _Utils_update(
							accum,
							{
								x: _Utils_ap(es, accum.x)
							});
					}
				}),
			{x: _List_Nil, Q: _List_Nil},
			a.dj);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					function () {
					var _v0 = enslaved.Q;
					if (!_v0.b) {
						return _List_Nil;
					} else {
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('enslaved-affixes-errs')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$String$join, ', ', enslaved.Q))
									]))
							]);
					}
				}(),
					function () {
					var _v1 = enslaved.x;
					if (!_v1.b) {
						return _List_Nil;
					} else {
						if (!_v1.b.b) {
							var e = _v1.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									A2($author$project$View$Affix$viewAffix, lang, e))
								]);
						} else {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$details,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('enslaved-affixes')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$summary,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(
													'enslaved affix-classes: ' + A2($elm$core$String$join, ', ', a.dj))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(enslaved.x))),
													$elm$html$Html$text(' negative Hunt affixes')
												])),
											A2(
											$elm$html$Html$ul,
											_List_Nil,
											_Utils_ap(
												$elm$core$List$concat(
													A2(
														$elm$core$List$map,
														$author$project$View$Affix$viewAffix(lang),
														enslaved.x)),
												A2(
													$elm$core$List$map,
													function (err) {
														return A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('???'),
																	$elm$html$Html$text(err),
																	$elm$html$Html$text('???')
																]));
													},
													enslaved.Q)))
										]))
								]);
						}
					}
				}()
				]));
	});
var $author$project$Datamine$GemFamily$intersectBy = F2(
	function (fn, lists) {
		if (!lists.b) {
			return _List_Nil;
		} else {
			var headList = lists.a;
			var tailLists = lists.b;
			var toSet = A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(fn),
				$elm$core$Set$fromList);
			var tailSets = A2($elm$core$List$map, toSet, tailLists);
			var headSet = toSet(headList);
			var intersection = A3($elm$core$List$foldl, $elm$core$Set$intersect, headSet, tailSets);
			return A2(
				$elm$core$List$filter,
				function (item) {
					return A2(
						$elm$core$Set$member,
						fn(item),
						intersection);
				},
				headList);
		}
	});
var $author$project$Datamine$GemFamily$fromAffixes = function (dm) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			$author$project$Datamine$GemFamily$fromAffix(dm)),
		$author$project$Datamine$GemFamily$intersectBy(
			function ($) {
				return $.bU;
			}));
};
var $author$project$Datamine$GemFamily$gems = F2(
	function (dm, fam) {
		return A2(
			$elm$core$List$filterMap,
			function (g) {
				return A2(
					$elm$core$Dict$get,
					$elm$core$String$toLower(g.du),
					dm.bV);
			},
			fam.ec);
	});
var $author$project$Datamine$Util$imghost = $elm$core$String$toLower('https://img-wolcendb.erosson.org/Game/Libs/UI/u_resources');
var $author$project$Datamine$Gem$img = function (gem) {
	return $author$project$Datamine$Util$imghost + ('/gems/' + $elm$core$String$toLower(gem.b2));
};
var $author$project$Datamine$GemFamily$img = function (dm) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Datamine$GemFamily$gems(dm),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$reverse,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$head,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$map($author$project$Datamine$Gem$img),
					$elm$core$Maybe$withDefault('')))));
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Datamine$Gem$label = function (lang) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.av;
		},
		$author$project$Lang$get(lang));
};
var $author$project$Datamine$GemFamily$label = F2(
	function (lang, dm) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Datamine$GemFamily$gems(dm),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filterMap(
					$author$project$Datamine$Gem$label(lang)),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$sortBy($elm$core$String$length),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$head,
						$elm$core$Maybe$withDefault('')))));
	});
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$View$Affix$viewGemFamiliesList = F3(
	function (lang, dm, affixes) {
		return A2(
			$elm$core$List$map,
			function (fam) {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('gem-icon'),
							$elm$html$Html$Attributes$title(
							A3($author$project$Datamine$GemFamily$label, lang, dm, fam) + (' (' + (fam.bU + ') in a socket makes this affix more likely to appear with crafting reagents'))),
							$elm$html$Html$Attributes$src(
							A2($author$project$Datamine$GemFamily$img, dm, fam))
						]),
					_List_Nil);
			},
			A2($author$project$Datamine$GemFamily$fromAffixes, dm, affixes));
	});
var $author$project$View$Affix$viewGemFamilies = F3(
	function (lang, dm, affix) {
		return A3(
			$author$project$View$Affix$viewGemFamiliesList,
			lang,
			dm,
			_List_fromArray(
				[affix]));
	});
var $author$project$Page$Affixes$viewAffixRow = F4(
	function (lang, dm, model, a) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$td, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$title(a.ax),
									$elm$html$Html$Attributes$class('affixes')
								]),
							A2($author$project$View$Affix$viewAffix, lang, a)),
						A3($author$project$View$Affix$viewAffixEnslaved, lang, dm, a))),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(a.et))
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('nowrap')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(a.bz.dH.dS) + ('-' + $elm$core$String$fromInt(a.bz.dH.dQ)))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$map,
								function (k) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$title('MandatoryKeyword: items must have this keyword to spawn this affix'),
												$elm$html$Html$Attributes$class('badge badge-primary')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(k)
											]));
								},
								a.bz.dO),
								A2(
								$elm$core$List$map,
								function (k) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$title('OptionalKeyword: items must have any one of these keywords to spawn this affix'),
												$elm$html$Html$Attributes$class('badge badge-info')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(k)
											]));
								},
								a.bz.d$),
								a.bz.ei ? _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$title('Sarisel: only spawns from Sarisel expeditions'),
											$elm$html$Html$Attributes$class('badge badge-success')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sarisel')
										]))
								]) : _List_Nil,
								a.bz.de ? _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$title('CraftOnly: only spawns from using crafting reagents with socketed gems'),
											$elm$html$Html$Attributes$class('badge badge-success')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('CraftOnly')
										]))
								]) : _List_Nil,
								a.bz.dA ? _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$title('Hunt: Tributary affix; only spawns from Bloodtrail content'),
											$elm$html$Html$Attributes$class('badge badge-success')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Hunt')
										]))
								]) : _List_Nil,
								_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('badge')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(a.ex)
										]))
								])
							]))),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('nowrap')
						]),
					A3($author$project$View$Affix$viewGemFamilies, lang, dm, a)),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(a.bz.dt))
						])),
					A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('['),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											A2($author$project$Route$Source, 'magic-affix', a.ax))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										])),
									$elm$html$Html$text('|'),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$title('List all items that can spawn this affix'),
											$author$project$Route$href(
											A3($author$project$Route$normalItems, $elm$core$Maybe$Nothing, a.bz.dO, a.bz.d$))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Items')
										])),
									$elm$html$Html$text(']')
								]))
						]))
				]));
	});
var $author$project$Page$Affixes$viewAffixClass = F4(
	function (lang, dm, model, _v0) {
		var cls = _v0.a;
		var affixes = _v0.b;
		if (!affixes.b) {
			return _List_Nil;
		} else {
			if (!affixes.b.b) {
				var affix = affixes.a;
				return _List_fromArray(
					[
						A4($author$project$Page$Affixes$viewAffixRow, lang, dm, model, affix)
					]);
			} else {
				var head = affixes.a;
				var isExpanded = A2($elm$core$Set$member, cls, model.bD);
				return A2(
					$elm$core$List$cons,
					A4(
						$author$project$Page$Affixes$viewAffixClassRow,
						lang,
						dm,
						model,
						_Utils_Tuple2(cls, affixes)),
					isExpanded ? A2(
						$elm$core$List$map,
						A3($author$project$Page$Affixes$viewAffixRow, lang, dm, model),
						affixes) : _List_Nil);
			}
		}
	});
var $author$project$View$AffixFilterForm$InputFrequency0 = function (a) {
	return {$: 5, a: a};
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$View$AffixFilterForm$viewFrequencyForm = function (model) {
	return A2(
		$elm$html$Html$form,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-group form-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-3'),
								A2($elm$html$Html$Attributes$style, 'text-align', 'right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Show only affixes with drop frequency')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col')
							]),
						A2(
							$elm$core$List$map,
							function (o) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-check form-check-inline')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('form-check-input'),
													$elm$html$Html$Attributes$id(o.u),
													$elm$html$Html$Attributes$type_('checkbox'),
													$elm$html$Html$Attributes$checked(
													A2($elm$core$Set$member, o.u, model.bH)),
													$elm$html$Html$Events$onCheck(
													$elm$core$Basics$always(
														$author$project$View$AffixFilterForm$InputFrequency0(o.u)))
												]),
											_List_Nil),
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('form-check-label badge'),
													$elm$html$Html$Attributes$for(o.u),
													$elm$html$Html$Attributes$title(o.bd)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(o.dJ)
												]))
										]));
							},
							_List_fromArray(
								[
									{u: 'default', dJ: 'Available', bd: 'frequency > 0; normal affixes available to players.'},
									{u: 'hidden', dJ: 'Unavailable', bd: 'frequency == 0; affixes not currently available to players. You probably don\'t want this.'}
								])))
					]))
			]));
};
var $author$project$View$AffixFilterForm$InputGemFamily = function (a) {
	return {$: 1, a: a};
};
var $author$project$View$AffixFilterForm$viewGemForm = F2(
	function (dm, model) {
		return A2(
			$elm$html$Html$form,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-group form-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-3'),
									A2($elm$html$Html$Attributes$style, 'text-align', 'right')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Show only affixes of gem families ')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col')
								]),
							A2(
								$elm$core$List$map,
								function (fam) {
									var id = 'affix-filter-gem-' + fam.bU;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-check form-check-inline')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('form-check-input'),
														$elm$html$Html$Attributes$id(id),
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Events$onCheck(
														$elm$core$Basics$always(
															$author$project$View$AffixFilterForm$InputGemFamily(fam.bU)))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$label,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('form-check-label'),
														$elm$html$Html$Attributes$for(id)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('gem-icon'),
																$elm$html$Html$Attributes$src(
																A2($author$project$Datamine$GemFamily$img, dm, fam))
															]),
														_List_Nil)
													]))
											]));
								},
								dm.J))
						]))
				]));
	});
var $author$project$View$AffixFilterForm$InputGentypeFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$View$AffixFilterForm$InputKeywordFilter = function (a) {
	return {$: 2, a: a};
};
var $author$project$View$AffixFilterForm$InputXpackFilter = function (a) {
	return {$: 4, a: a};
};
var $author$project$View$AffixFilterForm$viewKeywordForm = F2(
	function (dm, model) {
		return A2(
			$elm$html$Html$form,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-group form-row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col-sm-3'),
									A2($elm$html$Html$Attributes$style, 'text-align', 'right')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Show only affixes with keyword')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('col')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (kw) {
											var id = 'affix-filter-keyword-' + kw;
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('form-check form-check-inline')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('form-check-input'),
																$elm$html$Html$Attributes$id(id),
																$elm$html$Html$Attributes$type_('checkbox'),
																$elm$html$Html$Events$onCheck(
																$elm$core$Basics$always(
																	$author$project$View$AffixFilterForm$InputKeywordFilter(kw)))
															]),
														_List_Nil),
														A2(
														$elm$html$Html$label,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('form-check-label badge'),
																$elm$html$Html$Attributes$for(id)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(kw)
															]))
													]));
										},
										dm.ce)),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (kw) {
												var id = 'affix-filter-gentype-' + kw;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('form-check form-check-inline')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('form-check-input'),
																	$elm$html$Html$Attributes$id(id),
																	$elm$html$Html$Attributes$type_('checkbox'),
																	$elm$html$Html$Events$onCheck(
																	$elm$core$Basics$always(
																		$author$project$View$AffixFilterForm$InputGentypeFilter(kw)))
																]),
															_List_Nil),
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('form-check-label badge'),
																	$elm$html$Html$Attributes$for(id)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(kw)
																]))
														]));
											},
											_List_fromArray(
												['prefix', 'suffix'])),
										A2(
											$elm$core$List$map,
											function (kw) {
												var id = 'affix-filter-xpack-' + kw;
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('form-check form-check-inline')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$input,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('form-check-input'),
																	$elm$html$Html$Attributes$id(id),
																	$elm$html$Html$Attributes$type_('checkbox'),
																	$elm$html$Html$Events$onCheck(
																	$elm$core$Basics$always(
																		$author$project$View$AffixFilterForm$InputXpackFilter(kw)))
																]),
															_List_Nil),
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('form-check-label badge'),
																	$elm$html$Html$Attributes$for(id)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(kw)
																]))
														]));
											},
											_List_fromArray(
												['sarisel', 'hunt']))))
								]))
						]))
				]));
	});
var $author$project$View$AffixFilterForm$InputItemLevel = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$View$AffixFilterForm$viewLevelForm = function (model) {
	return A2(
		$elm$html$Html$form,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-group form-row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm-3'),
								A2($elm$html$Html$Attributes$style, 'text-align', 'right'),
								$elm$html$Html$Attributes$for('affix-filter-itemlevel')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Show only affixes for item level ')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('affix-filter-itemlevel'),
								$elm$html$Html$Attributes$type_('number'),
								$elm$html$Html$Attributes$class('col-sm-2 form-control'),
								$elm$html$Html$Attributes$min('0'),
								$elm$html$Html$Attributes$max('200'),
								$elm$html$Html$Attributes$value(
								(!model.bK) ? '' : $elm$core$String$fromInt(model.bK)),
								$elm$html$Html$Events$onInput($author$project$View$AffixFilterForm$InputItemLevel)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('invisible', !model.bK)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(', or '),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('button'),
										$elm$html$Html$Attributes$class('btn btn-outline-dark'),
										$elm$html$Html$Events$onClick(
										$author$project$View$AffixFilterForm$InputItemLevel('0'))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Show affixes for all item levels')
									]))
							]))
					]))
			]));
};
var $author$project$Page$Affixes$view = F3(
	function (lang, dm, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Affixes)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Affixes')
							]))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Page$Affixes$FormMsg,
				$author$project$View$AffixFilterForm$viewLevelForm(model)),
				A2(
				$elm$html$Html$map,
				$author$project$Page$Affixes$FormMsg,
				A2($author$project$View$AffixFilterForm$viewGemForm, dm, model)),
				A2(
				$elm$html$Html$map,
				$author$project$Page$Affixes$FormMsg,
				A2($author$project$View$AffixFilterForm$viewKeywordForm, dm, model)),
				A2(
				$elm$html$Html$map,
				$author$project$Page$Affixes$FormMsg,
				$author$project$View$AffixFilterForm$viewFrequencyForm(model)),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('table affixes')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_Nil),
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('effects')
											])),
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('tier')
											])),
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('level')
											])),
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('keywords')
											])),
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('gemFamilies')
											])),
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('frequency')
											])),
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('source')
											]))
									]))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$concatMap,
							A3($author$project$Page$Affixes$viewAffixClass, lang, dm, model),
							$author$project$View$Affix$affixesByClass(
								A2(
									$elm$core$List$filter,
									A2($author$project$View$AffixFilterForm$isVisible, dm, model),
									(A2($elm$core$Set$member, 'sarisel', model.bM) ? $elm$core$List$filter(
										function (a) {
											return a.bz.ei;
										}) : (A2($elm$core$Set$member, 'hunt', model.bM) ? $elm$core$List$filter(
										function (a) {
											return a.bz.dA;
										}) : $elm$core$Basics$identity))(
										($elm$core$Set$isEmpty(model.bJ) ? $elm$core$Basics$identity : $elm$core$List$filter(
											function (a) {
												return A2($elm$core$Set$member, a.ex, model.bJ);
											}))(
											($elm$core$Set$isEmpty(model.bL) ? $elm$core$Basics$identity : $elm$core$List$filter(
												function (a) {
													return A2(
														$elm$core$List$any,
														function (k) {
															return A2($elm$core$Set$member, k, model.bL);
														},
														_Utils_ap(a.bz.dO, a.bz.d$));
												}))(dm.x.aH)))))))
					]))
			]);
	});
var $author$project$Page$Ailments$InputPlayerLevel = $elm$core$Basics$identity;
var $author$project$Page$Ailments$view = F2(
	function (dm, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Ailments)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Ailments')
							]))
					])),
				A2(
				$elm$html$Html$form,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-group row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-3')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Player level')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-9')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-control'),
												$elm$html$Html$Attributes$type_('number'),
												$elm$html$Html$Attributes$min('0'),
												$elm$html$Html$Attributes$max('90'),
												$elm$html$Html$Attributes$value(
												(!model.bp) ? '' : $elm$core$String$fromInt(model.bp)),
												$elm$html$Html$Events$onInput($elm$core$Basics$identity)
											]),
										_List_Nil)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (ail) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('float-right')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('['),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															A2($author$project$Route$Source, 'ailment', ail.q))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Source')
														])),
													$elm$html$Html$text(']')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'clear', 'right')
												]),
											_List_Nil),
											$elm$html$Html$text(ail.q)
										])),
									A2(
									$elm$html$Html$table,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-body')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$thead,
											_List_Nil,
											A2(
												$elm$core$List$cons,
												A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('level')
														])),
												function () {
													var _v0 = ail.d1;
													if (!_v0.b) {
														return _List_Nil;
													} else {
														var p = _v0.a;
														return A2(
															$elm$core$List$map,
															function (_v1) {
																var k = _v1.a;
																return A2(
																	$elm$html$Html$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(k)
																		]));
															},
															p.eA);
													}
												}())),
											A2(
											$elm$html$Html$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (p) {
													return A2(
														$elm$html$Html$tr,
														_List_Nil,
														A2(
															$elm$core$List$cons,
															A2(
																$elm$html$Html$td,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$elm$core$String$fromInt(p.dL))
																	])),
															A2(
																$elm$core$List$map,
																function (_v2) {
																	var v = _v2.b;
																	return A2(
																		$elm$html$Html$td,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$elm$core$String$fromFloat(v))
																			]));
																},
																p.eA)));
												},
												A2(
													$elm$core$List$filter,
													function (p) {
														return (!model.bp) || _Utils_eq(model.bp, p.dL);
													},
													ail.d1)))
										]))
								]));
					},
					dm.ab))
			]);
	});
var $author$project$Route$hrefOptions = function (o) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Route$toString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$append(
				$author$project$Route$optionsPath(o)),
			$elm$html$Html$Attributes$href));
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Page$BuildRevisions$view = F2(
	function (dm, m) {
		var options = $author$project$Route$toMOptions(m.n);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$BuildRevisions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Build Revisions')
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('View WolcenDB with data exported from older Wolcen build revisions.')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-group')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list-group-item list-group-item-action'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'active',
										_Utils_eq($elm$core$Maybe$Nothing, options.aM))
									])),
								A2(
								$author$project$Route$hrefOptions,
								_Utils_update(
									options,
									{aM: $elm$core$Maybe$Nothing}),
								$author$project$Route$Home)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Latest revision')
									]))
							])),
					A2(
						$elm$core$List$map,
						function (r) {
							return A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-group-item list-group-item-action'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'active',
												_Utils_eq(
													$elm$core$Maybe$Just(r),
													options.aM))
											])),
										A2(
										$author$project$Route$hrefOptions,
										_Utils_update(
											options,
											{
												aM: $elm$core$Maybe$Just(r)
											}),
										$author$project$Route$Home)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(r)
									]));
						},
						$elm$core$List$reverse(m.ay))))
			]);
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$html$Html$small = _VirtualDom_node('small');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $elm_explorations$markdown$Markdown$defaultOptions = {
	by: $elm$core$Maybe$Nothing,
	dx: $elm$core$Maybe$Just(
		{c8: false, es: false}),
	eh: true,
	en: false
};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $elm_explorations$markdown$Markdown$toHtml = $elm_explorations$markdown$Markdown$toHtmlWith($elm_explorations$markdown$Markdown$defaultOptions);
var $author$project$Page$Changelog$view = function (m) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('breadcrumb')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('breadcrumb-item active'),
							$author$project$Route$href($author$project$Route$Home)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Home')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('breadcrumb-item active'),
							$author$project$Route$href($author$project$Route$Changelog)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Changelog')
						]))
				])),
			A2(
			$elm$html$Html$small,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Contact the developer: '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://github.com/erosson/wolcendb/issues/new'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Github issue')
								])),
							$elm$html$Html$text('.')
						]))
				])),
			A2(
			$elm_explorations$markdown$Markdown$toHtml,
			_List_Nil,
			A2(
				$elm$core$String$join,
				'---',
				A2(
					$elm$core$List$drop,
					1,
					A2($elm$core$String$split, '---', m.az))))
		]);
};
var $author$project$Page$City$InputPlayerLevel = $elm$core$Basics$identity;
var $author$project$Datamine$City$label = F2(
	function (lang, s) {
		return A2($author$project$Lang$get, lang, s.av);
	});
var $author$project$Datamine$City$htmlTagRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('<[^>]*>'));
var $author$project$Datamine$City$lore = F2(
	function (lang, s) {
		return A2($author$project$Lang$get, lang, s.aO);
	});
var $author$project$Datamine$City$projectOutcomes = F2(
	function (lang, proj) {
		return A2(
			$elm$core$Maybe$andThen,
			function (lore_) {
				var _v0 = A2($elm$core$String$split, 'Outcomes:', lore_);
				if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
					var head = _v0.a;
					var _v1 = _v0.b;
					var tail = _v1.a;
					var out = A3(
						$elm$core$String$replace,
						'\\n',
						'',
						A3(
							$elm$regex$Regex$replace,
							$author$project$Datamine$City$htmlTagRegex,
							$elm$core$Basics$always(''),
							tail));
					return (out === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(out);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A2($author$project$Datamine$City$lore, lang, proj));
	});
var $author$project$Datamine$City$projectRewards = function (dm) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.cD;
		},
		$elm$core$List$filterMap(
			function (_v0) {
				var rewardName = _v0.cC;
				var weight = _v0._;
				return A2(
					$elm$core$Maybe$map,
					function (r) {
						return {eg: r, _: weight};
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(rewardName),
						dm.bs));
			}));
};
var $author$project$Datamine$City$rolledProjects = function (dm) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.cE;
		},
		$elm$core$List$filterMap(
			function (r) {
				return A2(
					$elm$core$Maybe$map,
					function (p) {
						return {aU: r.aU, d5: p, _: r._};
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(r.cs),
						dm.br));
			}));
};
var $author$project$Datamine$City$rangeToString = F2(
	function (_v0, r) {
		var parens = _v0.ao;
		return _Utils_eq(r.dS, r.dQ) ? $elm$core$String$fromInt(r.dS) : (parens ? ('(' + ($elm$core$String$fromInt(r.dS) + (' to ' + ($elm$core$String$fromInt(r.dQ) + ')')))) : ($elm$core$String$fromInt(r.dS) + (' to ' + $elm$core$String$fromInt(r.dQ))));
	});
var $elm$core$Basics$round = _Basics_round;
var $author$project$Datamine$City$rewardCurrencyFormat = F3(
	function (label_, playerLevel, curr) {
		return ((!curr.dS) && ((!curr.dQ) && (!curr.T))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			label_ + (': ' + A2(
				$author$project$Datamine$City$rangeToString,
				{ao: false},
				{
					dQ: curr.dQ + $elm$core$Basics$round(playerLevel * curr.T),
					dS: curr.dS + $elm$core$Basics$round(playerLevel * curr.T)
				})));
	});
var $author$project$Datamine$City$rewardCurrencyToString = F2(
	function (label_, curr) {
		return ((!curr.dS) && ((!curr.dQ) && (!curr.T))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			label_ + (': ' + (A2(
				$author$project$Datamine$City$rangeToString,
				{ao: true},
				curr) + (' + (playerLevel * ' + ($elm$core$String$fromFloat(curr.T) + ')')))));
	});
var $author$project$Datamine$City$rewardToString = function (reward) {
	return _Utils_ap(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$andThen,
					$author$project$Datamine$City$rewardCurrencyToString('Gold'),
					reward.a_),
					A2(
					$elm$core$Maybe$andThen,
					$author$project$Datamine$City$rewardCurrencyToString('Primordial affinity'),
					reward.a4)
				])),
		A2(
			$elm$core$List$map,
			function (f) {
				return 'Items: ' + (A2(
					$author$project$Datamine$City$rangeToString,
					{ao: false},
					f) + (' (' + (f.q + ')')));
			},
			reward.aZ));
};
var $author$project$Datamine$City$rewardFormat = F2(
	function (_v0, reward) {
		var playerLevel = _v0.d2;
		return (!playerLevel) ? $author$project$Datamine$City$rewardToString(reward) : _Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$andThen,
						A2($author$project$Datamine$City$rewardCurrencyFormat, 'Gold', playerLevel),
						reward.a_),
						A2(
						$elm$core$Maybe$andThen,
						A2($author$project$Datamine$City$rewardCurrencyFormat, 'Primordial affinity', playerLevel),
						reward.a4)
					])),
			A2(
				$elm$core$List$map,
				function (f) {
					return A2(
						$author$project$Datamine$City$rangeToString,
						{ao: false},
						f) + (' items: ' + f.q);
				},
				reward.aZ));
	});
var $author$project$Util$percent = function (p) {
	return A2(
		$elm$core$String$left,
		5,
		$elm$core$String$fromFloat(p * 100)) + '%';
};
var $author$project$Page$City$viewWeight = F2(
	function (totalWeight, roll) {
		return ((!totalWeight) || (!roll._)) ? A2($elm$html$Html$span, _List_Nil, _List_Nil) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('badge float-right'),
					$elm$html$Html$Attributes$title(
					$elm$core$String$fromInt(roll._) + ('/' + $elm$core$String$fromInt(totalWeight)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Util$percent(roll._ / totalWeight))
				]));
	});
var $author$project$Page$City$viewRewards = F3(
	function (lang, model, rolls) {
		var totalWeight = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $._;
				},
				rolls));
		return A2(
			$elm$core$List$map,
			function (roll) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item card p-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-header p-1')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$title(roll.eg.q)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'???',
												A2($author$project$Datamine$City$label, lang, roll.eg)))
										])),
									A2($author$project$Page$City$viewWeight, totalWeight, roll)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-body p-1')
								]),
							function () {
								var _v0 = A2(
									$author$project$Datamine$City$rewardFormat,
									{d2: model.bp},
									roll.eg);
								if (!_v0.b) {
									return _List_fromArray(
										[
											$elm$html$Html$text('No rewards')
										]);
								} else {
									var rewardLines = _v0;
									return A2(
										$elm$core$List$map,
										function (s) {
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(s)
													]));
										},
										rewardLines);
								}
							}())
						]));
			},
			rolls);
	});
var $author$project$Page$City$viewMain = F4(
	function (lang, dm, model, building) {
		var label = A2(
			$elm$core$Maybe$withDefault,
			'???',
			A2($author$project$Datamine$City$label, lang, building));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('City Rewards')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href(
								$author$project$Route$City(building.q))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					])),
				A2(
				$elm$html$Html$form,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-group row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-3')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Player level')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('col-sm-9')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-control'),
												$elm$html$Html$Attributes$type_('number'),
												$elm$html$Html$Attributes$min('0'),
												$elm$html$Html$Attributes$max('90'),
												$elm$html$Html$Attributes$value(
												(!model.bp) ? '' : $elm$core$String$fromInt(model.bp)),
												$elm$html$Html$Events$onInput($elm$core$Basics$identity)
											]),
										_List_Nil)
									]))
							]))
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-group')
					]),
				A2(
					$elm$core$List$map,
					function (r) {
						return A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item card p-0')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-header')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('float-right')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('['),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															A2($author$project$Route$Source, 'city-project', r.d5.q))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Source')
														])),
													$elm$html$Html$text(']')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'clear', 'right')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(r.d5.av),
													A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'???',
														A2($author$project$Datamine$City$label, lang, r.d5)))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mx-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'???',
												A2($author$project$Datamine$City$projectOutcomes, lang, r.d5)))
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-body')
										]),
									A3(
										$author$project$Page$City$viewRewards,
										lang,
										model,
										A2($author$project$Datamine$City$projectRewards, dm, r.d5)))
								]));
					},
					A2($author$project$Datamine$City$rolledProjects, dm, building)))
			]);
	});
var $author$project$Page$City$view = F4(
	function (lang, dm, model, name) {
		return A2(
			$elm$core$Maybe$map,
			A3($author$project$Page$City$viewMain, lang, dm, model),
			A2($elm$core$Dict$get, name, dm.bn));
	});
var $author$project$Datamine$Affix$getNonmagicIds = function (dm) {
	return $elm$core$List$filterMap(
		function (id) {
			return A2($elm$core$Dict$get, id, dm.ci);
		});
};
var $author$project$Datamine$Gem$affixes = function (dm) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.aW;
		},
		$elm$core$List$map(
			$elm$core$Tuple$mapSecond(
				function (affixId) {
					return A2(
						$author$project$Datamine$Affix$getNonmagicIds,
						dm,
						_List_fromArray(
							[affixId]));
				})));
};
var $author$project$Datamine$Gem$formatSocket = function (socket) {
	_v0$9:
	while (true) {
		switch (socket.$) {
			case 0:
				switch (socket.a) {
					case 1:
						return 'Offensive I: ';
					case 2:
						return 'Offensive II: ';
					case 3:
						return 'Offensive III: ';
					default:
						break _v0$9;
				}
			case 1:
				switch (socket.a) {
					case 1:
						return 'Defensive I: ';
					case 2:
						return 'Defensive II: ';
					case 3:
						return 'Defensive III: ';
					default:
						break _v0$9;
				}
			default:
				switch (socket.a) {
					case 1:
						return 'Support I: ';
					case 2:
						return 'Support II: ';
					case 3:
						return 'Support III: ';
					default:
						break _v0$9;
				}
		}
	}
	return '???SOCKET???: ';
};
var $author$project$Datamine$Gem$effects = F2(
	function (lang, dm) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Datamine$Gem$affixes(dm),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function (_v0) {
						var socket = _v0.a;
						var affs = _v0.b;
						return A2(
							$elm$core$List$map,
							$elm$core$Basics$append(
								$author$project$Datamine$Gem$formatSocket(socket)),
							A2(
								$elm$core$List$filterMap,
								$author$project$Datamine$Affix$formatEffect(lang),
								A2(
									$elm$core$List$concatMap,
									function ($) {
										return $.aW;
									},
									affs)));
					}),
				$elm$core$List$concat));
	});
var $author$project$Page$Gems$view = F2(
	function (lang, dm) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Gems)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Gems')
							]))
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (gem) {
								return A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(gem.av)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('skill-icon'),
																	$elm$html$Html$Attributes$src(
																	$author$project$Datamine$Gem$img(gem))
																]),
															_List_Nil)
														])),
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'???',
														A2($author$project$Datamine$Gem$label, lang, gem))),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('['),
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$author$project$Route$href(
																	A2($author$project$Route$Source, 'gem', gem.q))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Source')
																])),
															$elm$html$Html$text(']')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('list-group affixes nowrap')
														]),
													A2(
														$elm$core$List$map,
														function (s) {
															return A2(
																$elm$html$Html$li,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('list-group-item'),
																		A2($elm$html$Html$Attributes$style, 'display', 'inline')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(s)
																	]));
														},
														A3($author$project$Datamine$Gem$effects, lang, dm, gem)))
												]))
										]));
							},
							dm.aj))
					]))
			]);
	});
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Util$titleCase = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split(' '),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(
			function (w) {
				return _Utils_ap(
					$elm$core$String$toUpper(
						A2($elm$core$String$left, 1, w)),
					A2($elm$core$String$dropLeft, 1, w));
			}),
		$elm$core$String$join(' ')));
var $author$project$Page$Home$view = function (dm) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Loot, skill, city, and magic affix lists for the action RPG '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$target('_blank'),
											$elm$html$Html$Attributes$href('https://wolcengame.com/')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Wolcen: Lords of Mayhem')
										])),
									$elm$html$Html$text('.')
								]))
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Player')
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-group list-group-flush')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$Skills($elm$core$Maybe$Nothing))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Skills')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href($author$project$Route$Passives)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Passives')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href($author$project$Route$Ailments)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Ailments')
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('card-header')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Apocalypse Forms')
												])),
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group list-group-flush')
												]),
											A2(
												$elm$core$List$map,
												function (form) {
													return A2(
														$elm$html$Html$li,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('list-group-item')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$a,
																_List_fromArray(
																	[
																		$author$project$Route$href(
																		$author$project$Route$Skills(
																			$elm$core$Maybe$Just(form)))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Util$titleCase(form))
																	]))
															]));
												},
												$author$project$Datamine$Skill$apocForms))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Loot')
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-group list-group-flush')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href($author$project$Route$Affixes)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Magic Affixes')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															A3(
																$author$project$Route$NormalItems,
																$elm$core$Maybe$Nothing,
																$elm$core$Maybe$Just('weapon'),
																$elm$core$Maybe$Nothing))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Weapons')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															A3(
																$author$project$Route$NormalItems,
																$elm$core$Maybe$Nothing,
																$elm$core$Maybe$Just('shield'),
																$elm$core$Maybe$Nothing))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Shields')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															A3(
																$author$project$Route$NormalItems,
																$elm$core$Maybe$Nothing,
																$elm$core$Maybe$Just('armor'),
																$elm$core$Maybe$Nothing))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Armors')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															A3(
																$author$project$Route$NormalItems,
																$elm$core$Maybe$Nothing,
																$elm$core$Maybe$Just('accessory'),
																$elm$core$Maybe$Nothing))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Accessories')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href($author$project$Route$Gems)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Gems')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href($author$project$Route$Reagents)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Reagents')
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Uniques')
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-group list-group-flush')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$UniqueItems(
																$elm$core$Maybe$Just('weapon')))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Weapons')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$UniqueItems(
																$elm$core$Maybe$Just('shield')))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Shields')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$UniqueItems(
																$elm$core$Maybe$Just('armor')))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Armors')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$UniqueItems(
																$elm$core$Maybe$Just('accessory')))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Accessories')
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('card-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('City')
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-group list-group-flush')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$City('building_seekers_garrison'))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Seekers')
														]))
												])),
											A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$City('building_trade_assembly'))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Trade Assembly')
														]))
												]))
										]))
								]))
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-unstyled')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-link'),
													$author$project$Route$href($author$project$Route$Langs)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Choose Language '),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('badge')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('(BETA)')
														]))
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-link'),
													$author$project$Route$href($author$project$Route$Changelog)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Changelog')
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-link'),
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$href('https://github.com/erosson/wolcendb')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Source code')
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('btn btn-link'),
													$author$project$Route$href($author$project$Route$Privacy)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Privacy')
												]))
										]))
								])),
							A2(
							$elm$html$Html$small,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Wolcen build revision '),
											A2(
											$elm$html$Html$code,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(dm.aM.bk)
												])),
											$elm$html$Html$text(', created at '),
											A2(
											$elm$html$Html$code,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(dm.aM.dg)
												])),
											$elm$html$Html$text('. See data for '),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$author$project$Route$href($author$project$Route$BuildRevisions)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('other Wolcen versions')
												]))
										]))
								])),
							A2(
							$elm$html$Html$small,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('This site is fan-made and not affiliated with '),
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$target('_blank'),
													$elm$html$Html$Attributes$href('https://wolcengame.com/')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Wolcen Studios')
												])),
											$elm$html$Html$text('.')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Page$Langs$view = function (m) {
	var options = $author$project$Route$toMOptions(m.n);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('breadcrumb')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('breadcrumb-item active'),
							$author$project$Route$href($author$project$Route$Home)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Home')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('breadcrumb-item active'),
							$author$project$Route$href($author$project$Route$Langs)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select Language')
						]))
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Translate all text exported from Wolcen, like skill/item names and affix text. Website text is not translated (yet), sorry.')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Beware: this feature is new to WolcenDB and still only '),
					A2(
					$elm$html$Html$code,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('beta')
						])),
					$elm$html$Html$text(' quality. Expect bugs.')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-group')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item list-group-item-action'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'active',
									_Utils_eq($elm$core$Maybe$Nothing, options.i))
								])),
							A2(
							$author$project$Route$hrefOptions,
							_Utils_update(
								options,
								{i: $elm$core$Maybe$Nothing}),
							$author$project$Route$Home)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Default language')
								]))
						])),
				A2(
					$elm$core$List$map,
					function (r) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item list-group-item-action'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'active',
											_Utils_eq(
												$elm$core$Maybe$Just(r),
												options.i))
										])),
									A2(
									$author$project$Route$hrefOptions,
									_Utils_update(
										options,
										{
											i: $elm$core$Maybe$Just(r)
										}),
									$author$project$Route$Home)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(r)
								]));
					},
					$elm$core$List$reverse(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$toLower,
								A2(
									$elm$core$Basics$composeR,
									A2($elm$core$String$replace, '_xml.pak', ''),
									A2($elm$core$String$replace, 'chineses', 'chinese'))),
							$elm$core$List$reverse(m.aG))))))
		]);
};
var $author$project$Page$NormalItem$FormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$NormalItem$ItemMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Datamine$NormalItem$formatStat = function (r) {
	return _Utils_eq(r.dS, r.dQ) ? ((!r.dS) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$fromInt(r.dS))) : $elm$core$Maybe$Just(
		$elm$core$String$fromInt(r.dS) + ('-' + $elm$core$String$fromInt(r.dQ)));
};
var $author$project$Datamine$NormalItem$baseEffects = F2(
	function (dm, nitem) {
		switch (nitem.$) {
			case 0:
				var w = nitem.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return 'Damage: ' + s;
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$NormalItem$formatStat, w.bw)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return 'Resource: ' + s;
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$NormalItem$formatStat, w.cB))
						]));
			case 1:
				var w = nitem.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + ' All Resistance';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$NormalItem$formatStat, w.cM)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + '% Block Chance';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$NormalItem$formatStat, w.cK)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + '% Block Efficiency';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$NormalItem$formatStat, w.cL))
						]));
			case 2:
				var a = nitem.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + ' Health';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$NormalItem$formatStat, a.b_)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + ' Force Shield';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$NormalItem$formatStat, a.bO)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + ' All Resistance';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$NormalItem$formatStat, a.bh))
						]));
			default:
				return _List_Nil;
		}
	});
var $author$project$Datamine$NormalItem$img = F2(
	function (dm, nitem) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$String$toLower,
			function () {
				switch (nitem.$) {
					case 3:
						var item = nitem.a;
						return $elm$core$Maybe$Just($author$project$Datamine$Util$imghost + ('/armors/' + item.b2));
					case 2:
						var item = nitem.a;
						return A2(
							$elm$core$Maybe$map,
							function (t) {
								return $author$project$Datamine$Util$imghost + ('/armors/' + t.b2);
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(item.bi),
								dm.aB));
					default:
						return A2(
							$elm$core$Maybe$map,
							function (t) {
								return $author$project$Datamine$Util$imghost + ('/weapons/' + t.b2);
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(
									$author$project$Datamine$NormalItem$name(nitem)),
								dm.aC));
				}
			}());
	});
var $author$project$Datamine$NormalItem$implicitAffixes = function (nitem) {
	switch (nitem.$) {
		case 0:
			var i = nitem.a;
			return i.D;
		case 1:
			var i = nitem.a;
			return i.D;
		case 2:
			var i = nitem.a;
			return i.D;
		default:
			var i = nitem.a;
			return i.D;
	}
};
var $author$project$Datamine$NormalItem$implicitEffects = F2(
	function (lang, dm) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Datamine$NormalItem$implicitAffixes,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Datamine$Affix$getNonmagicIds(dm),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$concatMap(
						function ($) {
							return $.aW;
						}),
					$elm$core$List$filterMap(
						$author$project$Datamine$Affix$formatEffect(lang)))));
	});
var $author$project$Datamine$NormalItem$keywords = function (nitem) {
	switch (nitem.$) {
		case 0:
			var i = nitem.a;
			return i.dI;
		case 1:
			var i = nitem.a;
			return i.dI;
		case 2:
			var i = nitem.a;
			return i.dI;
		default:
			var i = nitem.a;
			return i.dI;
	}
};
var $author$project$Datamine$NormalItem$uiName = function (nitem) {
	switch (nitem.$) {
		case 0:
			var i = nitem.a;
			return i.av;
		case 1:
			var i = nitem.a;
			return i.av;
		case 2:
			var i = nitem.a;
			return i.av;
		default:
			var i = nitem.a;
			return i.av;
	}
};
var $author$project$Datamine$NormalItem$label = function (lang) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Datamine$NormalItem$uiName,
		$author$project$Lang$get(lang));
};
var $author$project$Datamine$NormalItem$levelPrereq = function (n) {
	switch (n.$) {
		case 0:
			var i = n.a;
			return i.dM;
		case 1:
			var i = n.a;
			return i.dM;
		case 2:
			var i = n.a;
			return i.dM;
		default:
			var i = n.a;
			return i.dM;
	}
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Datamine$NormalItem$isKeywordAffix = F2(
	function (itemKeywords, affix) {
		var isItemKeyword = function (k) {
			return A2($elm$core$Set$member, k, itemKeywords);
		};
		return A2($elm$core$List$all, isItemKeyword, affix.bz.dO) && (A2($elm$core$List$any, isItemKeyword, affix.bz.d$) || _Utils_eq(affix.bz.d$, _List_Nil));
	});
var $author$project$Datamine$NormalItem$possibleAffixes = F2(
	function (dm, item) {
		var itemKeywords = $elm$core$Set$fromList(
			$author$project$Datamine$NormalItem$keywords(item));
		return A2(
			$elm$core$List$filter,
			$author$project$Datamine$NormalItem$isKeywordAffix(itemKeywords),
			dm.x.aH);
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$View$Affix$Expand = $elm$core$Basics$identity;
var $author$project$View$Affix$viewItemAffixClassSummary = F4(
	function (lang, totalWeight, expanded, effects) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas collapse-caret'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('fa-caret-down', expanded),
								_Utils_Tuple2('fa-caret-right', !expanded)
							]))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (s) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(s)
								]));
					},
					A2(
						$elm$core$List$filterMap,
						$author$project$Datamine$Affix$formatEffect(lang),
						$author$project$View$Affix$summarizeEffects(effects))))
			]);
	});
var $author$project$View$Affix$viewWeights = F2(
	function (totalWeight, affixes) {
		var w = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (a) {
					return a.bz.dt;
				},
				A2(
					$elm$core$List$filter,
					function (a) {
						return !a.bz.ei;
					},
					affixes)));
		return ((!totalWeight) || (!w)) ? A2($elm$html$Html$span, _List_Nil, _List_Nil) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					$elm$core$String$fromInt(w) + ('/' + $elm$core$String$fromInt(totalWeight)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Util$percent(w / totalWeight))
				]));
	});
var $author$project$View$Affix$viewWeight = F2(
	function (totalWeight, affix) {
		return A2(
			$author$project$View$Affix$viewWeights,
			totalWeight,
			_List_fromArray(
				[affix]));
	});
var $author$project$View$Affix$viewItemAffixRow = F4(
	function (lang, dm, totalWeight, affix) {
		var ilvl = $elm$core$String$fromInt(affix.bz.dH.dS) + ('-' + $elm$core$String$fromInt(affix.bz.dH.dQ));
		return _Utils_ap(
			A2(
				$elm$core$List$concatMap,
				$author$project$View$Affix$viewEffect(lang),
				affix.aW),
			_Utils_ap(
				affix.bz.de ? _List_fromArray(
					[
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('badge badge-outline-light float-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('['),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href(
										A2($author$project$Route$Source, 'magic-affix', affix.ax))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('s')
									])),
								$elm$html$Html$text(']')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('badge badge-outline-light float-right')
							]),
						_List_fromArray(
							[
								A2($author$project$View$Affix$viewWeight, totalWeight, affix)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('badge badge-outline-light float-right')
							]),
						A3($author$project$View$Affix$viewGemFamilies, lang, dm, affix))
					]) : _List_fromArray(
					[
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('badge badge-outline-light float-right')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('['),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href(
										A2($author$project$Route$Source, 'magic-affix', affix.ax))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('s')
									])),
								$elm$html$Html$text(']')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('badge badge-outline-light float-right'),
								$elm$html$Html$Attributes$title('Monsters between levels ' + (ilvl + ' can drop items with this affix'))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ilvl' + ilvl)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('badge badge-outline-light float-right')
							]),
						_List_fromArray(
							[
								A2($author$project$View$Affix$viewWeight, totalWeight, affix)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('badge badge-outline-light float-right')
							]),
						A3($author$project$View$Affix$viewGemFamilies, lang, dm, affix))
					]),
				A3($author$project$View$Affix$viewAffixEnslaved, lang, dm, affix)));
	});
var $author$project$View$Affix$viewItemAffixClass = F5(
	function (lang, dm, totalWeight, expandeds, _v0) {
		var name = _v0.a;
		var affixes = _v0.b;
		if (!affixes.b) {
			return _List_Nil;
		} else {
			if (!affixes.b.b) {
				var affix = affixes.a;
				return A4($author$project$View$Affix$viewItemAffixRow, lang, dm, totalWeight, affix);
			} else {
				var head = affixes.a;
				var expanded = A2($elm$core$Set$member, name, expandeds);
				return A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('badge badge-outline-light float-right')
									]),
								_List_fromArray(
									[
										A2($author$project$View$Affix$viewWeights, totalWeight, affixes)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('badge badge-outline-light float-right')
									]),
								A3($author$project$View$Affix$viewGemFamiliesList, lang, dm, affixes)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('expand-affix-class'),
										$elm$html$Html$Attributes$title('Affix class: ' + (name + ' \nNo more than one affix from the same class may appear on an item')),
										$elm$html$Html$Events$onClick(name)
									]),
								A4(
									$author$project$View$Affix$viewItemAffixClassSummary,
									lang,
									totalWeight,
									expanded,
									A2(
										$elm$core$List$concatMap,
										function ($) {
											return $.aW;
										},
										affixes))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'clear', 'right')
									]),
								_List_Nil)
							])),
					expanded ? _List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group')
								]),
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									A3($author$project$View$Affix$viewItemAffixRow, lang, dm, totalWeight),
									$elm$html$Html$li(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list-group-item py-1')
											]))),
								affixes))
						]) : _List_Nil);
			}
		}
	});
var $author$project$View$Affix$viewItemAffixes = F5(
	function (title, lang, dm, expandeds, affixes) {
		if (_Utils_eq(affixes, _List_Nil)) {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		} else {
			var totalWeight = $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function (a) {
						return a.bz.dt;
					},
					A2(
						$elm$core$List$filter,
						function (a) {
							return !a.bz.ei;
						},
						affixes)));
			var classes = $author$project$View$Affix$affixesByClass(affixes);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list-group list-group-flush')
							]),
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								A4($author$project$View$Affix$viewItemAffixClass, lang, dm, totalWeight, expandeds),
								$elm$html$Html$li(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-group-item py-1')
										]))),
							classes))
					]));
		}
	});
var $author$project$View$Affix$viewItem = F4(
	function (lang, dm, expandeds, affixes) {
		var _v0 = A2(
			$elm$core$List$partition,
			function (a) {
				return a.bz.de;
			},
			affixes);
		var craftables = _v0.a;
		var affixes1 = _v0.b;
		var _v1 = A2(
			$elm$core$List$partition,
			function (a) {
				return a.bz.ei;
			},
			affixes1);
		var sarisels = _v1.a;
		var affixes2 = _v1.b;
		var _v2 = A2(
			$elm$core$List$partition,
			function (a) {
				return a.bz.dA;
			},
			affixes2);
		var hunts = _v2.a;
		var naturals = _v2.b;
		var _v3 = A2(
			$elm$core$List$partition,
			function (a) {
				return a.ex === 'prefix';
			},
			hunts);
		var huntPre = _v3.a;
		var huntSuf = _v3.b;
		var _v4 = A2(
			$elm$core$List$partition,
			function (a) {
				return a.ex === 'prefix';
			},
			naturals);
		var naturalPre = _v4.a;
		var naturalSuf = _v4.b;
		var _v5 = A2(
			$elm$core$List$partition,
			function (a) {
				return a.ex === 'prefix';
			},
			sarisels);
		var sariselPre = _v5.a;
		var sariselSuf = _v5.b;
		var _v6 = A2(
			$elm$core$List$partition,
			function (a) {
				return a.ex === 'prefix';
			},
			craftables);
		var craftablePre = _v6.a;
		var craftableSuf = _v6.b;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm')
							]),
						_List_fromArray(
							[
								A5($author$project$View$Affix$viewItemAffixes, 'Magic prefixes [click to expand]', lang, dm, expandeds, naturalPre)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm')
							]),
						_List_fromArray(
							[
								A5($author$project$View$Affix$viewItemAffixes, 'Magic suffixes', lang, dm, expandeds, naturalSuf)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm')
							]),
						_List_fromArray(
							[
								A5($author$project$View$Affix$viewItemAffixes, 'Sarisel prefixes', lang, dm, expandeds, sariselPre)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm')
							]),
						_List_fromArray(
							[
								A5($author$project$View$Affix$viewItemAffixes, 'Sarisel suffixes', lang, dm, expandeds, sariselSuf)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm')
							]),
						_List_fromArray(
							[
								A5($author$project$View$Affix$viewItemAffixes, 'Hunt prefixes', lang, dm, expandeds, huntPre)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm')
							]),
						_List_fromArray(
							[
								A5($author$project$View$Affix$viewItemAffixes, 'Hunt suffixes', lang, dm, expandeds, huntSuf)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm')
							]),
						_List_fromArray(
							[
								A5($author$project$View$Affix$viewItemAffixes, 'Craft-only prefixes', lang, dm, expandeds, craftablePre)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-sm')
							]),
						_List_fromArray(
							[
								A5($author$project$View$Affix$viewItemAffixes, 'Craft-only suffixes', lang, dm, expandeds, craftableSuf)
							]))
					]))
			]);
	});
var $author$project$Page$NormalItem$viewMain = F4(
	function (lang, dm, m, nitem) {
		var label = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'???',
				A2($author$project$Datamine$NormalItem$label, lang, nitem)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href(
								A3($author$project$Route$NormalItems, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Normal Items')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href(
								$author$project$Route$NormalItem(
									$author$project$Datamine$NormalItem$name(nitem)))
							]),
						_List_fromArray(
							[label]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-header')
							]),
						_List_fromArray(
							[label])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item float-right')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($author$project$Datamine$NormalItem$img, dm, nitem)))
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('['),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$author$project$Route$href(
														A2(
															$author$project$Route$Source,
															'normal-loot',
															$author$project$Datamine$NormalItem$name(nitem)))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Source')
													])),
												$elm$html$Html$text(']')
											]))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Level: '),
										$elm$html$Html$text(
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											'-',
											$elm$core$String$fromInt,
											$author$project$Datamine$NormalItem$levelPrereq(nitem)))
									])),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-group affixes')
									]),
								A2(
									$elm$core$List$map,
									function (s) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(s)
												]));
									},
									A2($author$project$Datamine$NormalItem$baseEffects, dm, nitem))),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-group affixes')
									]),
								A2(
									$elm$core$List$map,
									function (s) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(s)
												]));
									},
									A3($author$project$Datamine$NormalItem$implicitEffects, lang, dm, nitem))),
								A2(
								$elm$html$Html$small,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-muted')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Keywords: '),
										$elm$html$Html$text(
										A2(
											$elm$core$String$join,
											', ',
											$author$project$Datamine$NormalItem$keywords(nitem)))
									]))
							]))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Page$NormalItem$FormMsg,
				$author$project$View$AffixFilterForm$viewLevelForm(m)),
				A2(
				$elm$html$Html$map,
				$author$project$Page$NormalItem$FormMsg,
				A2($author$project$View$AffixFilterForm$viewGemForm, dm, m)),
				A2(
				$elm$html$Html$map,
				$author$project$Page$NormalItem$ItemMsg,
				A2(
					$elm$html$Html$div,
					_List_Nil,
					A4(
						$author$project$View$Affix$viewItem,
						lang,
						dm,
						m.bD,
						A2(
							$elm$core$List$filter,
							A2($author$project$View$AffixFilterForm$isVisible, dm, m),
							A2($author$project$Datamine$NormalItem$possibleAffixes, dm, nitem)))))
			]);
	});
var $author$project$Page$NormalItem$view = F4(
	function (lang, dm, model, name) {
		return A2(
			$elm$core$Maybe$map,
			A3($author$project$Page$NormalItem$viewMain, lang, dm, model),
			A2(
				$elm$core$Dict$get,
				$elm$core$String$toLower(name),
				dm.ca));
	});
var $author$project$Page$NormalItems$tier = $elm$core$Maybe$withDefault(16);
var $author$project$Page$NormalItems$tierTag = function (i) {
	return 'tier_' + $elm$core$String$fromInt(i);
};
var $author$project$Page$NormalItems$tiers = A2($elm$core$List$range, 1, 18);
var $author$project$Page$NormalItems$tierTags = $elm$core$Set$fromList(
	A2($elm$core$List$map, $author$project$Page$NormalItems$tierTag, $author$project$Page$NormalItems$tiers));
var $author$project$Page$NormalItems$armorKeywordGroups = _List_fromArray(
	[
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['armor', 'heavy']),
			'Heavy Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'heavy', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'heavy', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'heavy', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'heavy', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'heavy', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'heavy', 'hand']),
				'Hand')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['armor', 'warrior']),
			'Brawler Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'warrior', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'warrior', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'warrior', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'warrior', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'warrior', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'warrior', 'hand']),
				'Hand')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['armor', 'rogue']),
			'Rogue Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'rogue', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'rogue', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'rogue', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'rogue', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'rogue', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'rogue', 'hand']),
				'Hand')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['armor', 'mage']),
			'Mage Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'mage', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'mage', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'mage', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'mage', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'mage', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'mage', 'hand']),
				'Hand')
			]))
	]);
var $author$project$Page$NormalItems$otherKeywordGroups = _List_fromArray(
	[
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['armor']),
			'All Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'hand']),
				'Hand'),
				_Utils_Tuple2(
				_List_fromArray(
					['armor', 'shield']),
				'Shield'),
				_Utils_Tuple2(
				_List_fromArray(
					['trinket']),
				'Catalyst')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['accessory']),
			'Accessories'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['accessory', 'ring']),
				'Ring'),
				_Utils_Tuple2(
				_List_fromArray(
					['accessory', 'amulet']),
				'Amulet'),
				_Utils_Tuple2(
				_List_fromArray(
					['accessory', 'belt']),
				'Belt')
			]))
	]);
var $author$project$Page$NormalItems$viewKeywordGroups = F3(
	function (mtier, activeKws, okws) {
		return $elm$core$List$map(
			function (_v0) {
				var _v1 = _v0.a;
				var mainKws = _v1.a;
				var mainlabel = _v1.b;
				var entries = _v0.b;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card d-inline-flex'),
							A2($elm$html$Html$Attributes$style, 'max-width', '15em')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-header p-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											A3($author$project$Route$normalItems, mtier, mainKws, okws)),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'btn btn-link btn-outline-primary m-0',
													_Utils_eq(mainKws, activeKws))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(mainlabel)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-body p-0')
								]),
							A2(
								$elm$core$List$map,
								function (_v2) {
									var kws = _v2.a;
									var label = _v2.b;
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn btn-link'),
												$author$project$Route$href(
												A3($author$project$Route$normalItems, mtier, kws, okws)),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'btn-outline-primary',
														_Utils_eq(kws, activeKws))
													]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(label)
											]));
								},
								entries))
						]));
			});
	});
var $author$project$Page$NormalItems$visibleTiers = A2($elm$core$List$range, 1, 16);
var $author$project$Page$NormalItems$weaponKeywordGroups = _List_fromArray(
	[
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['1h', 'melee']),
			'One-handed melee'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['1h', 'melee', 'axe']),
				'Axe'),
				_Utils_Tuple2(
				_List_fromArray(
					['1h', 'melee', 'mace']),
				'Mace'),
				_Utils_Tuple2(
				_List_fromArray(
					['1h', 'melee', 'sword']),
				'Sword'),
				_Utils_Tuple2(
				_List_fromArray(
					['1h', 'melee', 'dagger']),
				'Dagger'),
				_Utils_Tuple2(
				_List_fromArray(
					['shield']),
				'Shield')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['2h', 'melee']),
			'Two-handed melee'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['2h', 'melee', 'axe']),
				'Axe'),
				_Utils_Tuple2(
				_List_fromArray(
					['2h', 'melee', 'mace']),
				'Mace'),
				_Utils_Tuple2(
				_List_fromArray(
					['2h', 'melee', 'sword']),
				'Sword')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['magic']),
			'Magic weapons'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['1h', 'magic']),
				'Catalyst'),
				_Utils_Tuple2(
				_List_fromArray(
					['2h', 'magic']),
				'Staff')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['ranged']),
			'Ranged weapons'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['1h', 'ranged']),
				'Pistol'),
				_Utils_Tuple2(
				_List_fromArray(
					['2h', 'ranged']),
				'Bow')
			]))
	]);
var $author$project$Page$NormalItems$viewMain = F6(
	function (lang, dm, mtier, keywords, okws, items) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href(
								A3($author$project$Route$normalItems, mtier, keywords, okws))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Loot')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A4($author$project$Page$NormalItems$viewKeywordGroups, mtier, keywords, okws, $author$project$Page$NormalItems$weaponKeywordGroups)),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A4($author$project$Page$NormalItems$viewKeywordGroups, mtier, keywords, okws, $author$project$Page$NormalItems$armorKeywordGroups)),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A4($author$project$Page$NormalItems$viewKeywordGroups, mtier, keywords, okws, $author$project$Page$NormalItems$otherKeywordGroups)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-header p-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Tier')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-body p-0')
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								function (t) {
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('btn'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'btn-outline-primary',
														_Utils_eq(
															t,
															$author$project$Page$NormalItems$tier(mtier)))
													])),
												$author$project$Route$href(
												A3(
													$author$project$Route$normalItems,
													$elm$core$Maybe$Just(t),
													keywords,
													okws))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												'T' + $elm$core$String$fromInt(t))
											]));
								},
								$author$project$Page$NormalItems$visibleTiers),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'btn-outline-primary',
													!$author$project$Page$NormalItems$tier(mtier))
												])),
											$author$project$Route$href(
											A3(
												$author$project$Route$normalItems,
												$elm$core$Maybe$Just(0),
												keywords,
												okws))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('All')
										]))
								])))
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-group')
					]),
				A2(
					$elm$core$List$map,
					function (nitem) {
						return A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('col-sm-2')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$NormalItem(
																$author$project$Datamine$NormalItem$name(nitem)))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('item-list-img'),
																	$elm$html$Html$Attributes$src(
																	A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A2($author$project$Datamine$NormalItem$img, dm, nitem)))
																]),
															_List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('col-sm-10')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$NormalItem(
																$author$project$Datamine$NormalItem$name(nitem)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'???',
																A2($author$project$Datamine$NormalItem$label, lang, nitem)))
														])),
													A3(
													$elm_community$maybe_extra$Maybe$Extra$unwrap,
													A2($elm$html$Html$p, _List_Nil, _List_Nil),
													function (lvl) {
														return A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	'Level: ' + $elm$core$String$fromInt(lvl))
																]));
													},
													$author$project$Datamine$NormalItem$levelPrereq(nitem)),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('list-group affixes')
														]),
													A2(
														$elm$core$List$map,
														function (s) {
															return A2(
																$elm$html$Html$li,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('list-group-item')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(s)
																	]));
														},
														A2($author$project$Datamine$NormalItem$baseEffects, dm, nitem))),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('list-group affixes')
														]),
													A2(
														$elm$core$List$map,
														function (s) {
															return A2(
																$elm$html$Html$li,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('list-group-item')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(s)
																	]));
														},
														A3($author$project$Datamine$NormalItem$implicitEffects, lang, dm, nitem))),
													A2(
													$elm$html$Html$small,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('text-muted')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Keywords: '),
															$elm$html$Html$text(
															A2(
																$elm$core$String$join,
																', ',
																$author$project$Datamine$NormalItem$keywords(nitem)))
														]))
												]))
										]))
								]));
					},
					items))
			]);
	});
var $author$project$Page$NormalItems$view = F5(
	function (lang, dm, mtier, kwStr, okwStr) {
		var tier_ = $author$project$Page$NormalItems$tierTag(
			$author$project$Page$NormalItems$tier(mtier));
		var okwList = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(''),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2(
					$elm$core$String$split,
					',',
					$elm$core$String$toLower(
						A2($elm$core$Maybe$withDefault, '', okwStr)))));
		var kwList = A2(
			$elm$core$List$filter,
			$elm$core$Basics$neq(''),
			A2(
				$elm$core$List$map,
				$elm$core$String$trim,
				A2(
					$elm$core$String$split,
					',',
					$elm$core$String$toLower(
						A2($elm$core$Maybe$withDefault, '', kwStr)))));
		var isItemKeyword = F2(
			function (itemKws, kw) {
				return A2($elm$core$Set$member, kw, itemKws);
			});
		var allTiers = !A2($elm$core$Set$member, tier_, $author$project$Page$NormalItems$tierTags);
		var loot = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Datamine$NormalItem$keywords,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map($elm$core$String$toLower),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Set$fromList,
						function (itemKws) {
							return A2(
								$elm$core$List$all,
								isItemKeyword(itemKws),
								kwList) && (($elm$core$List$isEmpty(okwList) || A2(
								$elm$core$List$any,
								isItemKeyword(itemKws),
								okwList)) && (allTiers || A2($elm$core$Set$member, tier_, itemKws)));
						}))),
			dm.al);
		return A6($author$project$Page$NormalItems$viewMain, lang, dm, mtier, kwList, okwList, loot);
	});
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Datamine$UniqueItem$defaultAffixes = function (uitem) {
	switch (uitem.$) {
		case 0:
			var i = uitem.a;
			return i.C;
		case 1:
			var i = uitem.a;
			return i.C;
		case 2:
			var i = uitem.a;
			return i.C;
		default:
			var i = uitem.a;
			return i.C;
	}
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Page$Offline$encodeEffectStats = function (_v0) {
	var stat = _v0.a;
	var range = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'semantic',
				$elm$json$Json$Encode$string(stat)),
				_Utils_Tuple2(
				'value',
				$elm$json$Json$Encode$float(range.dQ))
			]));
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Page$Offline$encodeEffect = F2(
	function (affix, effect) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'EffectId',
					$elm$json$Json$Encode$string(effect.ai)),
					_Utils_Tuple2(
					'EffectName',
					$elm$json$Json$Encode$string(affix.ax)),
					_Utils_Tuple2(
					'MaxStack',
					$elm$json$Json$Encode$int(1)),
					_Utils_Tuple2(
					'bDefault',
					$elm$json$Json$Encode$int(1)),
					_Utils_Tuple2(
					'Parameters',
					A2($elm$json$Json$Encode$list, $author$project$Page$Offline$encodeEffectStats, effect.ba))
				]));
	});
var $author$project$Page$Offline$encodeAffix = function (aff) {
	return A2(
		$elm$core$List$map,
		$author$project$Page$Offline$encodeEffect(aff),
		aff.aW);
};
var $author$project$Page$Offline$encodeAffixes = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$concatMap($author$project$Page$Offline$encodeAffix),
	$elm$json$Json$Encode$list($elm$core$Basics$identity));
var $author$project$Datamine$UniqueItem$implicitAffixes = function (uitem) {
	switch (uitem.$) {
		case 0:
			var i = uitem.a;
			return i.D;
		case 1:
			var i = uitem.a;
			return i.D;
		case 2:
			var i = uitem.a;
			return i.D;
		default:
			var i = uitem.a;
			return i.D;
	}
};
var $author$project$Datamine$UniqueItem$uiName = function (nitem) {
	switch (nitem.$) {
		case 0:
			var i = nitem.a;
			return i.av;
		case 1:
			var i = nitem.a;
			return i.av;
		case 2:
			var i = nitem.a;
			return i.av;
		default:
			var i = nitem.a;
			return i.av;
	}
};
var $author$project$Datamine$UniqueItem$label = function (lang) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Datamine$UniqueItem$uiName,
		$author$project$Lang$get(lang));
};
var $author$project$Page$Offline$maybeIf = F2(
	function (pred, val) {
		return pred(val) ? $elm$core$Maybe$Just(val) : $elm$core$Maybe$Nothing;
	});
var $author$project$Page$Offline$getOffline = F4(
	function (lang, dm, type_, id) {
		if (type_ === 'unique-loot') {
			return A2(
				$elm$core$Maybe$map,
				function (uitem) {
					var label = A2(
						$elm$core$Maybe$withDefault,
						'???',
						A2($author$project$Datamine$UniqueItem$label, lang, uitem));
					return _Utils_Tuple3(
						label,
						_List_fromArray(
							[
								$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'InventoryX',
										$elm$json$Json$Encode$int(0)),
										_Utils_Tuple2(
										'InventoryY',
										$elm$json$Json$Encode$int(0)),
										_Utils_Tuple2(
										'Rarity',
										$elm$json$Json$Encode$int(6)),
										_Utils_Tuple2(
										'Quality',
										$elm$json$Json$Encode$int(1)),
										_Utils_Tuple2(
										'Type',
										function () {
											switch (uitem.$) {
												case 0:
													return $elm$json$Json$Encode$int(3);
												case 1:
													return $elm$json$Json$Encode$int(3);
												case 2:
													return $elm$json$Json$Encode$int(2);
												default:
													return $elm$json$Json$Encode$int(2);
											}
										}()),
										_Utils_Tuple2(
										'Value',
										$elm$json$Json$Encode$string(
											$elm$core$String$fromInt(1))),
										_Utils_Tuple2(
										'Level',
										$elm$json$Json$Encode$int(1)),
										A2(
										$elm$core$Tuple$mapSecond,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$filterMap($elm$core$Basics$identity),
											$elm$json$Json$Encode$object),
										function () {
											switch (uitem.$) {
												case 0:
													var w = uitem.a;
													return _Utils_Tuple2(
														'Weapon',
														_List_fromArray(
															[
																$elm$core$Maybe$Just(
																_Utils_Tuple2(
																	'Name',
																	$elm$json$Json$Encode$string(w.q))),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.dS;
																	},
																	A2(
																		$elm$core$Basics$composeR,
																		$elm$json$Json$Encode$int,
																		$elm$core$Tuple$pair('DamageMin'))),
																w.bw),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.dQ;
																	},
																	A2(
																		$elm$core$Basics$composeR,
																		$elm$json$Json$Encode$int,
																		$elm$core$Tuple$pair('DamageMax'))),
																w.bw),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	function ($) {
																		return $.dQ;
																	},
																	A2(
																		$elm$core$Basics$composeR,
																		$elm$json$Json$Encode$int,
																		$elm$core$Tuple$pair('ResourceGeneration'))),
																w.cB)
															]));
												case 1:
													var w = uitem.a;
													return _Utils_Tuple2(
														'Weapon',
														_List_fromArray(
															[
																$elm$core$Maybe$Just(
																_Utils_Tuple2(
																	'Name',
																	$elm$json$Json$Encode$string(w.q))),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$elm$json$Json$Encode$int,
																	$elm$core$Tuple$pair('ShieldResistance')),
																A2(
																	$elm$core$Maybe$andThen,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.dQ;
																		},
																		$author$project$Page$Offline$maybeIf(
																			$elm$core$Basics$neq(0))),
																	w.cM)),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$elm$json$Json$Encode$int,
																	$elm$core$Tuple$pair('ShieldBlockChance')),
																A2(
																	$elm$core$Maybe$andThen,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.dQ;
																		},
																		$author$project$Page$Offline$maybeIf(
																			$elm$core$Basics$neq(0))),
																	w.cK)),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$elm$json$Json$Encode$int,
																	$elm$core$Tuple$pair('ShieldBlockEfficiency')),
																A2(
																	$elm$core$Maybe$andThen,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.dQ;
																		},
																		$author$project$Page$Offline$maybeIf(
																			$elm$core$Basics$neq(0))),
																	w.cL))
															]));
												case 2:
													var w = uitem.a;
													return _Utils_Tuple2(
														'Armor',
														_List_fromArray(
															[
																$elm$core$Maybe$Just(
																_Utils_Tuple2(
																	'Name',
																	$elm$json$Json$Encode$string(w.q))),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$elm$json$Json$Encode$int,
																	$elm$core$Tuple$pair('Health')),
																A2(
																	$elm$core$Maybe$andThen,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.dQ;
																		},
																		$author$project$Page$Offline$maybeIf(
																			$elm$core$Basics$neq(0))),
																	w.b_)),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$elm$json$Json$Encode$int,
																	$elm$core$Tuple$pair('Armor')),
																A2(
																	$elm$core$Maybe$andThen,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.dQ;
																		},
																		$author$project$Page$Offline$maybeIf(
																			$elm$core$Basics$neq(0))),
																	w.bO)),
																A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$elm$json$Json$Encode$int,
																	$elm$core$Tuple$pair('Resistance')),
																A2(
																	$elm$core$Maybe$andThen,
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.dQ;
																		},
																		$author$project$Page$Offline$maybeIf(
																			$elm$core$Basics$neq(0))),
																	w.bh))
															]));
												default:
													var w = uitem.a;
													return _Utils_Tuple2(
														'Armor',
														_List_fromArray(
															[
																$elm$core$Maybe$Just(
																_Utils_Tuple2(
																	'Name',
																	$elm$json$Json$Encode$string(w.q)))
															]));
											}
										}()),
										_Utils_Tuple2(
										'MagicEffects',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'Default',
													$author$project$Page$Offline$encodeAffixes(
														A2(
															$author$project$Datamine$Affix$getNonmagicIds,
															dm,
															$author$project$Datamine$UniqueItem$implicitAffixes(uitem)))),
													_Utils_Tuple2(
													'RolledAffixes',
													$author$project$Page$Offline$encodeAffixes(
														A2(
															$author$project$Datamine$Affix$getNonmagicIds,
															dm,
															$author$project$Datamine$UniqueItem$defaultAffixes(uitem))))
												])))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$UniqueItems($elm$core$Maybe$Nothing))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Unique Loot')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$UniqueItem(id))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										A2($author$project$Route$Source, type_, id))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Offline')
									]))
							]));
				},
				A2(
					$elm$core$Dict$get,
					$elm$core$String$toLower(id),
					dm.c_));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Page$Offline$viewOffline = function (json) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$textarea,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control'),
					$elm$html$Html$Attributes$readonly(true),
					A2($elm$html$Html$Attributes$style, 'height', '30em')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$json$Json$Encode$encode, 8, json) + ',\n')
				]))
		]);
};
var $author$project$Page$Offline$view = F4(
	function (lang, dm, type_, id) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var label = _v0.a;
				var sources = _v0.b;
				var breadcrumb = _v0.c;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$ol,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href($author$project$Route$Home)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Home')
									])),
							breadcrumb)),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(label),
								$elm$html$Html$text(': '),
								A2(
								$elm$html$Html$code,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(id)
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The code below can be used to cheat/modify your saved games in offline mode. (Online-mode saves cannot be modified.)')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Make a backup copy of your saved game file before attempting this.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Usage: ')
							])),
						A2(
						$elm$html$Html$ol,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Close Wolcen')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Find your saved game file. Usually it\'s in '),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('C:\\Users\\<YOUR_USERNAME_HERE>\\Saved Games\\wolcen\\savegames\\characters')
											])),
										$elm$html$Html$text(' and ends with '),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('.json')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Make a backup copy of your saved game file ('),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('ctrl-c, ctrl-v')
											])),
										$elm$html$Html$text('). '),
										A2(
										$elm$html$Html$ul,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Seriously, don\'t skip making the backup copy. If these steps break your saved game, the WolcenDB developer cannot and will not help you.')
													]))
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Copy ('),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('ctrl-c')
											])),
										$elm$html$Html$text(') all of the code below.')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Open your saved game file in Notepad. Find ('),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('ctrl-f')
											])),
										$elm$html$Html$text(') the '),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('\"InventoryGrid\"')
											])),
										$elm$html$Html$text(' section. Paste ('),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('ctrl-v')
											])),
										$elm$html$Html$text(') the code below '),
										A2(
										$elm$html$Html$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('immediately after the first '),
												A2(
												$elm$html$Html$code,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('[')
													]))
											])),
										$elm$html$Html$text('.')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Change '),
										A2(
										$elm$html$Html$code,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('InventoryX, InventoryY')
											])),
										$elm$html$Html$text(' to empty coordinates in your inventory. Alternately, make sure the top-left of your inventory is empty before doing all this.')
									])),
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Open Wolcen. Enjoy your ill-gotten gains.')
									]))
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list-group')
							]),
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$Offline$viewOffline,
								$elm$html$Html$li(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-group-item')
										]))),
							sources))
					]);
			},
			A4($author$project$Page$Offline$getOffline, lang, dm, type_, id));
	});
var $author$project$Lang$mget = function (lang) {
	return $elm$core$Maybe$andThen(
		$author$project$Lang$get(lang));
};
var $author$project$Datamine$Passive$formatEffect = F2(
	function (lang, effect) {
		return A2(
			$elm$core$Maybe$map,
			function (template) {
				return A3(
					$elm$core$List$foldl,
					$author$project$Datamine$Util$formatEffectStat,
					template,
					A2(
						$elm$core$List$indexedMap,
						$elm$core$Tuple$pair,
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$mapSecond(
								function (v) {
									return A2($author$project$Datamine$Util$Range, v, v);
								}),
							effect.cI)));
			},
			A2($author$project$Lang$mget, lang, effect.b0));
	});
var $author$project$Datamine$Passive$effects = function (lang) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.aW;
		},
		$elm$core$List$filterMap(
			$author$project$Datamine$Passive$formatEffect(lang)));
};
var $author$project$Datamine$Passive$label = F2(
	function (lang, s) {
		return A2($author$project$Lang$get, lang, s.av);
	});
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {bu: col, dc: contextStack, cp: problem, cF: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.cF, s.bu, x, s.c));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bu: 1, c: s.c, d: s.d, b: s.b + 1, cF: s.cF + 1, a: s.a}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{bu: s.bu + 1, c: s.c, d: s.d, b: newOffset, cF: s.cF, a: s.a}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{bu: col, c: s0.c, d: s0.d, b: offset, cF: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.cF, s.bu, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.b, s.cF, s.bu, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.c)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.b, newOffset) < 0,
			0,
			{bu: newCol, c: s.c, d: s.d, b: newOffset, cF: newRow, a: s.a});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.b, s.cF, s.bu, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{bu: newCol, c: s.c, d: s.d, b: newOffset, cF: newRow, a: s.a});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$comment = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($hecrj$html_parser$Html$Parser$Comment),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {bu: s.bu + (newOffset - s.b), c: s.c, d: s.d, b: newOffset, cF: s.cF, a: s.a};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.b, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.a);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.cF, s.bu - (floatOffset + s.b), invalid, s.c));
		} else {
			if (_Utils_eq(s.b, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.b, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.b, floatOffset, s.a));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.b, s.a)) {
			var zeroOffset = s.b + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.a) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.dG,
				c.b$,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.a),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.a) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.dG,
				c.cj,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.a),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.a) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.dG,
				c.bj,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.a),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.dG,
				c.bE,
				c.b6,
				c.bN,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.dG,
				c.bE,
				c.b6,
				c.bN,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.b, s.a),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				bj: $elm$core$Result$Err(invalid),
				bE: expecting,
				bN: $elm$core$Result$Err(invalid),
				b$: $elm$core$Result$Err(invalid),
				b6: $elm$core$Result$Ok($elm$core$Basics$identity),
				dG: invalid,
				cj: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {bu: col, cp: problem, cF: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.cF, p.bu, p.cp);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{bu: 1, c: _List_Nil, d: 1, b: 0, cF: 1, a: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$View$Desc$format = A2(
	$elm$core$Basics$composeR,
	A2($elm$core$String$replace, '\\n', '<br />'),
	function (raw) {
		var _v0 = $hecrj$html_parser$Html$Parser$run(raw);
		if (!_v0.$) {
			var nodes = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('desc'),
							$elm$html$Html$Attributes$title(raw)
						]),
					$hecrj$html_parser$Html$Parser$Util$toVirtualDom(nodes))
				]);
		} else {
			var err = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('desc')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(raw)
						]))
				]);
		}
	});
var $author$project$View$Desc$mformat = $elm$core$Maybe$map($author$project$View$Desc$format);
var $author$project$View$Desc$desc = F2(
	function (lang, key) {
		return $author$project$View$Desc$mformat(
			A2($author$project$Lang$get, lang, key));
	});
var $author$project$View$Desc$mdesc = function (lang) {
	return $elm$core$Maybe$andThen(
		$author$project$View$Desc$desc(lang));
};
var $author$project$Datamine$Passive$nodeTypeLabel = F3(
	function (lang, entry, tree) {
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				'Unknown',
				A2($author$project$Datamine$Passive$label, lang, tree)),
			function () {
				var _v0 = entry.d8;
				switch (_v0) {
					case 2:
						return ' Notable';
					case 3:
						return ' Keystone';
					default:
						return '';
				}
			}());
	});
var $author$project$Page$Passives$view = F2(
	function (lang, dm) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Passives)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Passives')
							]))
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (_v1) {
								var entry = _v1.a;
								var passive = _v1.b;
								var tree = _v1.c;
								return A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(passive.av),
													A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$b,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$elm$core$Maybe$withDefault,
																		'???',
																		A2($author$project$Datamine$Passive$label, lang, passive)))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('passive-' + entry.bl)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A3($author$project$Datamine$Passive$nodeTypeLabel, lang, entry, tree))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('['),
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$author$project$Route$href(
																	A2($author$project$Route$Source, 'passive', passive.q))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Source')
																])),
															$elm$html$Html$text(']')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													A2(
														$elm$core$Maybe$withDefault,
														_List_fromArray(
															[
																$elm$html$Html$text('')
															]),
														A2($author$project$View$Desc$mdesc, lang, passive.bP))),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('list-group affixes')
														]),
													A2(
														$elm$core$List$map,
														function (s) {
															return A2(
																$elm$html$Html$li,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('list-group-item')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(s)
																	]));
														},
														A2($author$project$Datamine$Passive$effects, lang, passive))),
													A2(
													$elm$html$Html$p,
													_List_Nil,
													A2(
														$elm$core$Maybe$withDefault,
														_List_fromArray(
															[
																$elm$html$Html$text('')
															]),
														A2($author$project$View$Desc$mdesc, lang, passive.b1)))
												]))
										]));
							},
							A2(
								$elm$core$List$sortBy,
								function (_v0) {
									var entry = _v0.a;
									var passive = _v0.b;
									var tree = _v0.c;
									return _Utils_Tuple2(tree.q, -entry.d8);
								},
								dm.ck)))
					]))
			]);
	});
var $author$project$Page$Privacy$view = _List_fromArray(
	[
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('WolcenDB privacy policy')
			])),
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('We use '),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('https://analytics.google.com')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Google Analytics')
					])),
				$elm$html$Html$text(' to see which pages on WolcenDB are most popular. If this bothers you, feel free to '),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('https://tools.google.com/dlpage/gaoptout')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('opt-out of Google Analytics')
					])),
				$elm$html$Html$text('.')
			])),
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Otherwise, we don\'t use your data at all')
			])),
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Like, we don\'t even have logins here')
			]))
	]);
var $author$project$Datamine$Reagent$desc = F2(
	function (lang, s) {
		return A2($author$project$Lang$get, lang, s.bP);
	});
var $author$project$Datamine$Reagent$img = function (item) {
	return $author$project$Datamine$Util$imghost + ('/' + item.b2);
};
var $author$project$Datamine$Reagent$label = F2(
	function (lang, s) {
		return A2($author$project$Lang$get, lang, s.av);
	});
var $author$project$Datamine$Reagent$lore = F2(
	function (lang, s) {
		return A2($author$project$Lang$get, lang, s.cb);
	});
var $author$project$Page$Reagents$view = F2(
	function (lang, dm) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Reagents)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reagents')
							]))
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (reagent) {
								return A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('skill-icon'),
																	$elm$html$Html$Attributes$src(
																	$author$project$Datamine$Reagent$img(reagent))
																]),
															_List_Nil)
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$title(reagent.av)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'???',
																A2($author$project$Datamine$Reagent$label, lang, reagent)))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('['),
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$author$project$Route$href(
																	A2($author$project$Route$Source, 'reagent', reagent.q))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Source')
																])),
															$elm$html$Html$text(']')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												$author$project$View$Desc$mformat(
													A2($author$project$Datamine$Reagent$desc, lang, reagent)))),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											A2(
												$elm$core$Maybe$withDefault,
												_List_Nil,
												$author$project$View$Desc$mformat(
													A2($author$project$Datamine$Reagent$lore, lang, reagent))))
										]));
							},
							dm.ar))
					]))
			]);
	});
var $author$project$Page$Search$SearchInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Search$SearchSubmit = {$: 1};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Search$SearchResult = F5(
	function (id, score, category, route, label) {
		return {bl: category, u: id, dJ: label, n: route, ej: score};
	});
var $author$project$Datamine$Skill$label = F2(
	function (lang, s) {
		return A2($author$project$Lang$get, lang, s.av);
	});
var $author$project$Search$toResult = F3(
	function (lang, dm, _v0) {
		var docId = _v0.a;
		var score = _v0.b;
		var result = A2($author$project$Search$SearchResult, docId, score);
		var _v1 = A2($elm$core$String$split, '/', docId);
		_v1$6:
		while (true) {
			if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
				switch (_v1.a) {
					case 'gem':
						var _v2 = _v1.b;
						var id = _v2.a;
						return A2(
							$elm$core$Maybe$map,
							function (gem) {
								return A3(
									result,
									_List_fromArray(
										['Gem']),
									$author$project$Route$Gems,
									A2(
										$elm$core$Maybe$withDefault,
										'???',
										A2($author$project$Datamine$Gem$label, lang, gem)));
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(id),
								dm.bV));
					case 'skill':
						var _v3 = _v1.b;
						var id = _v3.a;
						return A2(
							$elm$core$Maybe$map,
							function (skill) {
								return A3(
									result,
									_List_fromArray(
										['Skill']),
									$author$project$Route$Skill(id),
									A2(
										$elm$core$Maybe$withDefault,
										'???',
										A2($author$project$Datamine$Skill$label, lang, skill)));
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(id),
								dm.cR));
					case 'skill-variant':
						var _v4 = _v1.b;
						var id = _v4.a;
						return A2(
							$elm$core$Maybe$map,
							function (_v5) {
								var _var = _v5.a;
								var skill = _v5.b;
								return A3(
									result,
									_List_fromArray(
										[
											'Skill Variant',
											A2(
											$elm$core$Maybe$withDefault,
											'???',
											A2($author$project$Datamine$Skill$label, lang, skill))
										]),
									$author$project$Route$SkillVariant(_var.be),
									A2(
										$elm$core$Maybe$withDefault,
										'???',
										A2($author$project$Datamine$Skill$label, lang, _var)));
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(id),
								dm.cP));
					case 'passive':
						var _v6 = _v1.b;
						var id = _v6.a;
						return A2(
							$elm$core$Maybe$map,
							function (_v7) {
								var entry = _v7.a;
								var passive = _v7.b;
								var tree = _v7.c;
								return A3(
									result,
									_List_fromArray(
										[
											'Passive',
											A2(
											$elm$core$Maybe$withDefault,
											'???',
											A2($author$project$Datamine$Passive$label, lang, tree))
										]),
									$author$project$Route$Passives,
									A2(
										$elm$core$Maybe$withDefault,
										'???',
										A2($author$project$Datamine$Passive$label, lang, passive)));
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(id),
								dm.cl));
					case 'normal-loot':
						var _v8 = _v1.b;
						var id = _v8.a;
						return A2(
							$elm$core$Maybe$map,
							function (nitem) {
								return A3(
									result,
									_List_fromArray(
										['Normal Loot']),
									$author$project$Route$NormalItem(
										$author$project$Datamine$NormalItem$name(nitem)),
									A2(
										$elm$core$Maybe$withDefault,
										'???',
										A2($author$project$Datamine$NormalItem$label, lang, nitem)));
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(id),
								dm.ca));
					case 'unique-loot':
						var _v9 = _v1.b;
						var id = _v9.a;
						return A2(
							$elm$core$Maybe$map,
							function (uitem) {
								return A3(
									result,
									_List_fromArray(
										['Unique Loot']),
									$author$project$Route$UniqueItem(
										$author$project$Datamine$UniqueItem$name(uitem)),
									A2(
										$elm$core$Maybe$withDefault,
										'???',
										A2($author$project$Datamine$UniqueItem$label, lang, uitem)));
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(id),
								dm.c_));
					default:
						break _v1$6;
				}
			} else {
				break _v1$6;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Search$toResults = F2(
	function (lang, dm) {
		return $elm$core$List$filterMap(
			A2($author$project$Search$toResult, lang, dm));
	});
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$View$Nav$viewMain = function (searchbar) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar navbar-expand-sm navbar-light bg-light')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-brand'),
						$author$project$Route$href($author$project$Route$Home)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('WolcenDB')
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Attributes$class('navbar-toggler'),
						A2($elm$html$Html$Attributes$attribute, 'data-toggle', 'collapse'),
						A2($elm$html$Html$Attributes$attribute, 'data-target', 'navbarLinks')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-toggler-icon')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('navbarLinks'),
						$elm$html$Html$Attributes$class('collapse navbar-collapse')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-nav mr-auto')
							]),
						_List_Nil),
						searchbar
					]))
			]));
};
var $author$project$View$Nav$viewNoSearchbar = $author$project$View$Nav$viewMain(
	A2($elm$html$Html$span, _List_Nil, _List_Nil));
var $author$project$View$Loading$viewErr = function (err) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					$author$project$View$Nav$viewNoSearchbar,
					A2(
					$elm$html$Html$pre,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('alert alert-danger')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$String$right, 100000, err))
						]))
				]))
		]);
};
var $author$project$View$Loading$viewLoading = F2(
	function (args, model) {
		var alert = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert alert-info loading-alert')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fas fa-spinner fa-spin')
						]),
					_List_Nil),
					$elm$html$Html$text(' Loading...'),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var key = _v0.a;
							var _v1 = _v0.b;
							var val = _v1.a;
							var max = _v1.b;
							var pct = $author$project$Util$percent(
								A3($elm$core$Basics$clamp, 0, 1, val / max));
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('loading progress')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('progress-bar bg-info'),
												A2($elm$html$Html$Attributes$style, 'width', pct),
												A2($elm$html$Html$Attributes$style, 'text-align', 'left')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												key + (': ' + ($elm$core$String$fromInt(val) + ('/' + ($elm$core$String$fromInt(max) + (' - ' + pct))))))
											]))
									]));
						},
						A2(
							$elm$core$List$sortBy,
							$elm$core$Tuple$first,
							$elm$core$Dict$toList(model.aq)))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-size', '60%')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Thanks for waiting!')
						]))
				]));
		return args.dV ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container')
					]),
				_List_fromArray(
					[
						$author$project$View$Nav$viewNoSearchbar,
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$id($author$project$View$Loading$ssrRootId)
																							]),
																						_List_Nil)
																					]))
																			]))
																	]))
															]))
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container fixed-top'),
						A2($elm$html$Html$Attributes$style, 'top', '3.5em')
					]),
				_List_fromArray(
					[alert]))
			]) : _List_fromArray(
			[alert]);
	});
var $author$project$View$Loading$view = F4(
	function (args, model, rd, next) {
		switch (rd.$) {
			case 2:
				var err = rd.a;
				return $author$project$View$Loading$viewErr(err);
			case 0:
				return A2($author$project$View$Loading$viewLoading, args, model);
			case 1:
				return A2($author$project$View$Loading$viewLoading, args, model);
			default:
				var val = rd.a;
				return next(val);
		}
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Page$Search$viewResult = function (_v0) {
	var category = _v0.bl;
	var route = _v0.n;
	var label = _v0.dJ;
	return A2(
		$elm$core$List$intersperse,
		$elm$html$Html$text(' / '),
		_Utils_ap(
			A2($elm$core$List$map, $elm$html$Html$text, category),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(route)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				])));
};
var $author$project$Page$Search$view = F3(
	function (lang, dm, m) {
		return A4(
			$author$project$View$Loading$view,
			{dV: false},
			m,
			m.L,
			function (searchIndex) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$ol,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href($author$project$Route$Home)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Home')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$Search(
											$elm$core$Maybe$Just(m.bX)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Search')
									]))
							])),
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit($author$project$Page$Search$SearchSubmit)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-control'),
										$elm$html$Html$Attributes$type_('search'),
										$elm$html$Html$Attributes$placeholder('Search'),
										$elm$html$Html$Attributes$value(m.bX),
										$elm$html$Html$Events$onInput($author$project$Page$Search$SearchInput)
									]),
								_List_Nil)
							])),
						function () {
						var _v0 = A2(
							$elm$core$Result$map,
							A2($author$project$Search$toResults, lang, dm),
							m.bY);
						if (_v0.$ === 1) {
							var err = _v0.a;
							return A2(
								$elm$html$Html$code,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(err)
									]));
						} else {
							if (!_v0.a.b) {
								return A2(
									$elm$html$Html$code,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('No search results')
										]));
							} else {
								var results = _v0.a;
								return A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-group')
										]),
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Page$Search$viewResult,
											$elm$html$Html$li(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('list-group-item')
													]))),
										results));
							}
						}
					}()
					]);
			});
	});
var $author$project$Datamine$Skill$desc = F2(
	function (lang, s) {
		return A2($author$project$Lang$get, lang, s.av + '_desc');
	});
var $author$project$Datamine$Source$children = function (_v0) {
	var ns = _v0;
	return ns;
};
var $author$project$Datamine$Skill$commonSkillEffect = function (node) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var attr = _v0.a;
			var val = _v0.b;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$pair(
					_List_fromArray(
						[node.N, attr])),
				$elm$core$String$toFloat(val));
		},
		node.aR);
};
var $author$project$Datamine$Skill$ignoredEffects = $elm$core$Set$fromList(
	_List_fromArray(
		['HUD', 'Animation', 'SoundTrigger']));
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $author$project$Datamine$Skill$effects = function (s) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$mapFirst(
			$elm$core$String$join('.')),
		A2(
			$elm$core$List$concatMap,
			function (node) {
				var _v0 = node.N;
				switch (_v0) {
					case 'Damage_Conversion':
						return A2(
							$elm$core$List$filterMap,
							function (entry) {
								var attrs = $elm$core$Dict$fromList(entry.aR);
								return A4(
									$elm$core$Maybe$map3,
									F3(
										function (from, to, rate) {
											return _Utils_Tuple2(
												_List_fromArray(
													[node.N, from, to, 'ConversionRate']),
												rate);
										}),
									A2($elm$core$Dict$get, 'From', attrs),
									A2($elm$core$Dict$get, 'To', attrs),
									A2(
										$elm$core$Maybe$andThen,
										$elm$core$String$toFloat,
										A2($elm$core$Dict$get, 'ConversionRate', attrs)));
							},
							A2(
								$elm$core$List$filter,
								function (n) {
									return n.N === 'Entry';
								},
								$author$project$Datamine$Source$children(node.aS)));
					case 'StatusAilment':
						return _Utils_ap(
							$author$project$Datamine$Skill$commonSkillEffect(node),
							A2(
								$elm$core$List$filterMap,
								function (entry) {
									var attrs = $elm$core$Dict$fromList(entry.aR);
									return A3(
										$elm$core$Maybe$map2,
										F2(
											function (chance, mode) {
												return _Utils_Tuple2(
													_List_fromArray(
														[node.N, entry.N, 'Chance', mode]),
													chance);
											}),
										A2(
											$elm$core$Maybe$andThen,
											$elm$core$String$toFloat,
											A2($elm$core$Dict$get, 'Chance', attrs)),
										A2($elm$core$Dict$get, 'ChanceMode', attrs));
								},
								$author$project$Datamine$Source$children(node.aS)));
					default:
						return $author$project$Datamine$Skill$commonSkillEffect(node);
				}
			},
			A2(
				$elm$core$List$filter,
				function (n) {
					return !A2($elm$core$Set$member, n.N, $author$project$Datamine$Skill$ignoredEffects);
				},
				$author$project$Datamine$Source$children(s.cS.dW.aS))));
};
var $author$project$Datamine$Skill$img = function (skill) {
	return $author$project$Datamine$Util$imghost + ('/' + $elm$core$String$toLower(skill.b2));
};
var $author$project$Datamine$Skill$lore = F2(
	function (lang, s) {
		return A2($author$project$Lang$mget, lang, s.cb);
	});
var $author$project$Datamine$Skill$modDesc = F2(
	function (lang, mod) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Datamine$Util$formatEffectStat(
				_Utils_Tuple2(
					0,
					_Utils_Tuple2(
						mod.bA,
						A2($author$project$Datamine$Util$Range, mod.aK, mod.aL)))),
			A2($author$project$Lang$get, lang, mod.cZ));
	});
var $author$project$Datamine$Skill$modTotals = function (ast) {
	var loop = F4(
		function (param1_0, param2_0, accum, items) {
			loop:
			while (true) {
				if (!items.b) {
					return $elm$core$List$reverse(accum);
				} else {
					var head = items.a;
					var tail = items.b;
					var param2 = param2_0 + head.aL;
					var param1 = param1_0 + head.aK;
					var $temp$param1_0 = param1,
						$temp$param2_0 = param2,
						$temp$accum = A2(
						$elm$core$List$cons,
						_Utils_update(
							head,
							{aK: param1, aL: param2}),
						accum),
						$temp$items = tail;
					param1_0 = $temp$param1_0;
					param2_0 = $temp$param2_0;
					accum = $temp$accum;
					items = $temp$items;
					continue loop;
				}
			}
		});
	return A4(loop, 0, 0, _List_Nil, ast.cf);
};
var $author$project$Page$SkillVariant$viewSkillEffects = $elm$core$List$map(
	function (_v0) {
		var name = _v0.a;
		var val = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-8 text-monospace'),
							A2($elm$html$Html$Attributes$style, 'text-align', 'right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('col-4 text-monospace')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Util$formatFloat, 5, val))
						]))
				]));
	});
var $author$project$Page$Skill$view = F3(
	function (lang, dm, uid) {
		return A2(
			$elm$core$Maybe$map,
			function (skill) {
				var label = A2(
					$elm$core$Maybe$withDefault,
					'???',
					A2($author$project$Datamine$Skill$label, lang, skill));
				var ast = A2($elm$core$Dict$get, uid, dm.cO);
				var vas = A2(
					$elm$core$List$filterMap,
					function (va) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$pair(va),
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									function (v) {
										return _Utils_eq(
											$elm$core$String$toLower(va.be),
											$elm$core$String$toLower(v.be));
									},
									skill.c0)));
					},
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						function ($) {
							return $.c0;
						},
						ast));
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$ol,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href($author$project$Route$Home)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Home')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$Skills(
											$author$project$Datamine$Skill$apocForm(skill)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Skills')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$Skill(skill.be))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-header')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(label)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-body')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('media')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('media-body')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$p,
														_List_Nil,
														A2(
															$elm$core$Maybe$withDefault,
															_List_fromArray(
																[
																	$elm$html$Html$text('???')
																]),
															$author$project$View$Desc$mformat(
																A2($author$project$Datamine$Skill$desc, lang, skill)))),
														A2(
														$elm$html$Html$p,
														_List_Nil,
														A2(
															$elm$core$Maybe$withDefault,
															_List_Nil,
															$author$project$View$Desc$mformat(
																A2($author$project$Datamine$Skill$lore, lang, skill)))),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														$author$project$Page$SkillVariant$viewSkillEffects(
															$author$project$Datamine$Skill$effects(skill)))
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('skill'),
																$elm$html$Html$Attributes$src(
																$author$project$Datamine$Skill$img(skill))
															]),
														_List_Nil),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('['),
																A2(
																$elm$html$Html$a,
																_List_fromArray(
																	[
																		$author$project$Route$href(
																		A2($author$project$Route$Source, 'skill', uid))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Source')
																	])),
																$elm$html$Html$text(']')
															]))
													]))
											])),
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('')
																	])),
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('')
																	])),
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('name')
																	])),
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('level')
																	])),
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('cost')
																	])),
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('desc')
																	]))
															]))
													])),
												A2(
												$elm$html$Html$tbody,
												_List_Nil,
												A2(
													$elm$core$List$indexedMap,
													F2(
														function (i, _v0) {
															var va = _v0.a;
															var v = _v0.b;
															return A2(
																$elm$html$Html$tr,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$td,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$elm$core$String$fromInt(i + 1))
																			])),
																		A2(
																		$elm$html$Html$td,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$img,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('skill-variant'),
																						$elm$html$Html$Attributes$src(
																						$author$project$Datamine$Skill$img(v))
																					]),
																				_List_Nil)
																			])),
																		A2(
																		$elm$html$Html$td,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$a,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$title(v.av),
																						$author$project$Route$href(
																						$author$project$Route$SkillVariant(v.be))
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						A2(
																							$elm$core$Maybe$withDefault,
																							'???',
																							A2($author$project$Datamine$Skill$label, lang, v)))
																					]))
																			])),
																		A2(
																		$elm$html$Html$td,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$elm$core$String$fromInt(va.dL))
																			])),
																		A2(
																		$elm$html$Html$td,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$elm$core$String$fromInt(va.dd))
																			])),
																		A2(
																		$elm$html$Html$td,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$title(v.av + '_desc')
																					]),
																				A2(
																					$elm$core$Maybe$withDefault,
																					_List_fromArray(
																						[
																							$elm$html$Html$text('???')
																						]),
																					$author$project$View$Desc$mformat(
																						A2($author$project$Datamine$Skill$desc, lang, v)))),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('card')
																					]),
																				$author$project$Page$SkillVariant$viewSkillEffects(
																					$author$project$Datamine$Skill$effects(v)))
																			]))
																	]));
														}),
													vas))
											])),
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('table')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$tr,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('level')
																	])),
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('effect')
																	])),
																A2(
																$elm$html$Html$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('xp')
																	]))
															]))
													])),
												A2(
												$elm$html$Html$tbody,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (mod) {
														return A2(
															$elm$html$Html$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$elm$core$String$fromInt(mod.dL))
																		])),
																	A2(
																	$elm$html$Html$td,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$title(mod.cZ)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'???',
																				A2($author$project$Datamine$Skill$modDesc, lang, mod)))
																		])),
																	A2(
																	$elm$html$Html$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$elm$core$String$fromInt(mod.eD))
																		]))
																]));
													},
													A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$Datamine$Skill$modTotals, ast)))
											]))
									]))
							]))
					]);
			},
			A2(
				$elm$core$Dict$get,
				$elm$core$String$toLower(uid),
				dm.cR));
	});
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Page$SkillVariant$view = F3(
	function (lang, dm, uid) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var variant = _v0.a;
				var skill = _v0.b;
				var vlabel = A2(
					$elm$core$Maybe$withDefault,
					'???',
					A2($author$project$Datamine$Skill$label, lang, variant));
				var slabel = A2(
					$elm$core$Maybe$withDefault,
					'???',
					A2($author$project$Datamine$Skill$label, lang, skill));
				var index = A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (_v1) {
							var i = _v1.a;
							var v = _v1.b;
							return _Utils_eq(v.be, variant.be);
						},
						A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, skill.c0)));
				var ast = A2($elm$core$Dict$get, skill.be, dm.cO);
				var vast = A2(
					$elm_community$list_extra$List$Extra$find,
					function (va) {
						return _Utils_eq(va.be, variant.be);
					},
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						function ($) {
							return $.c0;
						},
						ast));
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$ol,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href($author$project$Route$Home)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Home')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$Skills(
											$author$project$Datamine$Skill$apocForm(skill)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Skills')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$Skill(skill.be))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(slabel)
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$SkillVariant(variant.be))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(vlabel)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-header')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(slabel),
										$elm$html$Html$text(': '),
										$elm$html$Html$text(vlabel)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('card-body')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('media')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('media-body')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('float-left')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$img,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('skill-variant'),
																		$elm$html$Html$Attributes$src(
																		$author$project$Datamine$Skill$img(variant))
																	]),
																_List_Nil)
															])),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Variant #'),
																$elm$html$Html$text(
																A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '???', $elm$core$String$fromInt, index))
															])),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Level: '),
																$elm$html$Html$text(
																A3(
																	$elm_community$maybe_extra$Maybe$Extra$unwrap,
																	'???',
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.dL;
																		},
																		$elm$core$String$fromInt),
																	vast))
															])),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Cost: '),
																$elm$html$Html$text(
																A3(
																	$elm_community$maybe_extra$Maybe$Extra$unwrap,
																	'???',
																	A2(
																		$elm$core$Basics$composeR,
																		function ($) {
																			return $.dd;
																		},
																		$elm$core$String$fromInt),
																	vast))
															])),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$title(variant.av + '_desc')
															]),
														A2(
															$elm$core$Maybe$withDefault,
															_List_fromArray(
																[
																	$elm$html$Html$text('???')
																]),
															$author$project$View$Desc$mformat(
																A2($author$project$Datamine$Skill$desc, lang, variant)))),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$title(
																A2($elm$core$Maybe$withDefault, '', variant.cb))
															]),
														A2(
															$elm$core$Maybe$withDefault,
															_List_Nil,
															$author$project$View$Desc$mformat(
																A2($author$project$Datamine$Skill$lore, lang, variant)))),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('card')
															]),
														$author$project$Page$SkillVariant$viewSkillEffects(
															$author$project$Datamine$Skill$effects(variant)))
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('skill'),
																$elm$html$Html$Attributes$src(
																$author$project$Datamine$Skill$img(skill))
															]),
														_List_Nil),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('['),
																A2(
																$elm$html$Html$a,
																_List_fromArray(
																	[
																		$author$project$Route$href(
																		A2($author$project$Route$Source, 'skill-variant', uid))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Source')
																	])),
																$elm$html$Html$text(']')
															]))
													]))
											]))
									]))
							]))
					]);
			},
			A2(
				$elm$core$Dict$get,
				$elm$core$String$toLower(uid),
				dm.cP));
	});
var $author$project$Page$Skills$view = F3(
	function (lang, dm, mapoc) {
		var apoc = A2($elm$core$Maybe$withDefault, $author$project$Datamine$Skill$apocFormNone, mapoc);
		var _v0 = A2($elm$core$Dict$get, apoc, dm.cQ);
		if (_v0.$ === 1) {
			return A2($elm$core$List$member, apoc, $author$project$Datamine$Skill$apocForms) ? $elm$core$Maybe$Just(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ol,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href($author$project$Route$Home)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Home')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$Skills(mapoc))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Skills')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$code,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Error: no skills found for this apocalypse form.')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('It looks like this is a valid apocalypse form, though. Are you looking at an old version of Wolcen? We didn\'t datamine apocalypse form skills until after v1.0.9.0; sorry!')
							]))
					])) : $elm$core$Maybe$Nothing;
		} else {
			var skills = _v0.a;
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ol,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href($author$project$Route$Home)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Home')
									])),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href(
										$author$project$Route$Skills(mapoc))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Skills')
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Apocalypse form: '),
								$elm$html$Html$text(
								$author$project$Util$titleCase(apoc))
							])),
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('icon')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('name')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('desc')
													]))
											]))
									])),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (s) {
										return A2(
											$elm$html$Html$tr,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$td,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$author$project$Route$href(
																	$author$project$Route$Skill(s.be))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('skill-icon'),
																			$elm$html$Html$Attributes$src(
																			$author$project$Datamine$Skill$img(s))
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$title(s.av)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$author$project$Route$href(
																	$author$project$Route$Skill(s.be))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$elm$core$Maybe$withDefault,
																		'???',
																		A2($author$project$Datamine$Skill$label, lang, s)))
																]))
														])),
													A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$title(s.av + '_desc')
														]),
													A2(
														$elm$core$Maybe$withDefault,
														_List_fromArray(
															[
																$elm$html$Html$text('???')
															]),
														$author$project$View$Desc$mformat(
															A2($author$project$Datamine$Skill$desc, lang, s))))
												]));
									},
									skills))
							]))
					]));
		}
	});
var $author$project$Datamine$NormalItem$source = function (nitem) {
	switch (nitem.$) {
		case 0:
			var i = nitem.a;
			return i.cS;
		case 1:
			var i = nitem.a;
			return i.cS;
		case 2:
			var i = nitem.a;
			return i.cS;
		default:
			var i = nitem.a;
			return i.cS;
	}
};
var $author$project$Datamine$UniqueItem$source = function (uitem) {
	switch (uitem.$) {
		case 0:
			var i = uitem.a;
			return i.cS;
		case 1:
			var i = uitem.a;
			return i.cS;
		case 2:
			var i = uitem.a;
			return i.cS;
		default:
			var i = uitem.a;
			return i.cS;
	}
};
var $author$project$Page$Source$getSource = F4(
	function (lang, dm, type_, id) {
		switch (type_) {
			case 'skill':
				return A2(
					$elm$core$Maybe$map,
					function (s) {
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$Skill$label, lang, s));
						var ast = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.cS;
							},
							A2($elm$core$Dict$get, s.be, dm.cO));
						return _Utils_Tuple3(
							label,
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(s.cS),
										ast
									])),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											$author$project$Route$Skills(
												$author$project$Datamine$Skill$apocForm(s)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Skills')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											$author$project$Route$Skill(id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.cR));
			case 'skill-variant':
				return A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var v = _v1.a;
						var s = _v1.b;
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$Skill$label, lang, v));
						var ast = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.cS;
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(id),
								dm.cN));
						return _Utils_Tuple3(
							label,
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(v.cS),
										ast
									])),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											$author$project$Route$Skills(
												$author$project$Datamine$Skill$apocForm(s)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Skill Variants')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.cP));
			case 'gem':
				return A2(
					$elm$core$Maybe$map,
					function (gem) {
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$Gem$label, lang, gem));
						return _Utils_Tuple3(
							label,
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$elm$core$Maybe$Just(gem.cS),
										A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.cS;
										},
										A2(
											$elm$core$Dict$get,
											$elm$core$String$toLower(id),
											dm.bS))
									])),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href($author$project$Route$Gems)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Gems')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.bV));
			case 'reagent':
				return A2(
					$elm$core$Maybe$map,
					function (reagent) {
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$Reagent$label, lang, reagent));
						return _Utils_Tuple3(
							label,
							_List_fromArray(
								[reagent.cS]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href($author$project$Route$Reagents)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reagents')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.cv));
			case 'normal-loot':
				return A2(
					$elm$core$Maybe$map,
					function (nitem) {
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$NormalItem$label, lang, nitem));
						return _Utils_Tuple3(
							label,
							A2(
								$elm$core$List$cons,
								$author$project$Datamine$NormalItem$source(nitem),
								A2(
									$elm$core$List$filterMap,
									function (a) {
										return A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.cS;
											},
											A2($elm$core$Dict$get, a, dm.ci));
									},
									$author$project$Datamine$NormalItem$implicitAffixes(nitem))),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A3($author$project$Route$NormalItems, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Normal Loot')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											$author$project$Route$NormalItem(id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.ca));
			case 'unique-loot':
				return A2(
					$elm$core$Maybe$map,
					function (uitem) {
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$UniqueItem$label, lang, uitem));
						return _Utils_Tuple3(
							label,
							A2(
								$elm$core$List$cons,
								$author$project$Datamine$UniqueItem$source(uitem),
								A2(
									$elm$core$List$filterMap,
									function (a) {
										return A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.cS;
											},
											A2($elm$core$Dict$get, a, dm.ci));
									},
									_Utils_ap(
										$author$project$Datamine$UniqueItem$implicitAffixes(uitem),
										$author$project$Datamine$UniqueItem$defaultAffixes(uitem)))),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											$author$project$Route$UniqueItems($elm$core$Maybe$Nothing))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Unique Loot')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											$author$project$Route$UniqueItem(id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.c_));
			case 'magic-affix':
				return A2(
					$elm$core$Maybe$map,
					function (affix) {
						return _Utils_Tuple3(
							'Magic Affix',
							A2(
								$elm$core$List$cons,
								affix.cS,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.cS;
									},
									A2($author$project$Datamine$GemFamily$fromAffix, dm, affix))),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href($author$project$Route$Affixes)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Affixes')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(affix.ax)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.cd));
			case 'nonmagic-affix':
				return A2(
					$elm$core$Maybe$map,
					function (affix) {
						return _Utils_Tuple3(
							'Nonmagic Affix',
							_List_fromArray(
								[affix.cS]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href($author$project$Route$Affixes)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Affixes')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(affix.ax)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.ci));
			case 'passive':
				return A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var entry = _v2.a;
						var passive = _v2.b;
						var tree = _v2.c;
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$Passive$label, lang, passive));
						return _Utils_Tuple3(
							label,
							_List_fromArray(
								[passive.cS, entry.cS]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href($author$project$Route$Passives)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Passives')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.cl));
			case 'city-project':
				return A2(
					$elm$core$Maybe$map,
					function (proj) {
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$City$label, lang, proj));
						return _Utils_Tuple3(
							label,
							A2(
								$elm$core$List$cons,
								proj.cS,
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										function ($) {
											return $.eg;
										},
										function ($) {
											return $.cS;
										}),
									A2($author$project$Datamine$City$projectRewards, dm, proj))),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('City')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Projects')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.br));
			case 'city-reward':
				return A2(
					$elm$core$Maybe$map,
					function (reward) {
						var label = A2(
							$elm$core$Maybe$withDefault,
							'???',
							A2($author$project$Datamine$City$label, lang, reward));
						return _Utils_Tuple3(
							label,
							_List_fromArray(
								[reward.cS]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('City')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Rewards')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.bs));
			case 'ailment':
				return A2(
					$elm$core$Maybe$map,
					function (ail) {
						return _Utils_Tuple3(
							ail.q,
							_List_fromArray(
								[ail.cS]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href($author$project$Route$Ailments)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ailments')
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(ail.q)
										])),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('breadcrumb-item active'),
											$author$project$Route$href(
											A2($author$project$Route$Source, type_, id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Source')
										]))
								]));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.bg));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $author$project$Page$Source$viewSourceNode = F2(
	function (indentN, node) {
		var indent = A2($elm$core$String$repeat, indentN, ' ');
		var openTag = F2(
			function (tag, attrs0) {
				var attrs = A2(
					$elm$core$List$map,
					function (_v2) {
						var k = _v2.a;
						var v = _v2.b;
						return k + ('=\"' + (v + '\"'));
					},
					attrs0);
				var line = A2(
					$elm$core$String$join,
					' ',
					A2($elm$core$List$cons, tag, attrs));
				return ($elm$core$String$length(line) <= 80) ? line : (A2(
					$elm$core$String$join,
					'\n',
					A2(
						$elm$core$List$cons,
						tag,
						A2(
							$elm$core$List$map,
							$elm$core$Basics$append(indent + '    '),
							attrs))) + ('\n' + indent));
			});
		var _v0 = node.aS;
		var childNodes = _v0;
		var _v1 = _Utils_eq(childNodes, _List_Nil) ? _Utils_Tuple3(
			indent + ('<' + (A2(openTag, node.N, node.aR) + ' />')),
			'',
			'') : _Utils_Tuple3(
			indent + ('<' + (A2(openTag, node.N, node.aR) + '>')),
			'\n' + (A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					$author$project$Page$Source$viewSourceNode(indentN + 2),
					childNodes)) + ('\n' + indent)),
			'</' + (node.N + '>'));
		var open = _v1.a;
		var children = _v1.b;
		var close = _v1.c;
		return _Utils_ap(
			open,
			_Utils_ap(children, close));
	});
var $author$project$Page$Source$viewSource = function (source) {
	var file = A3($elm$core$String$replace, '.json', '.xml', source.dq);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$target('_blank'),
							$elm$html$Html$Attributes$href('https://github.com/erosson/wolcendb/blob/master/datamine/' + file)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(file)
						]))
				])),
			A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Page$Source$viewSourceNode, 0, source.dW))
				]))
		]);
};
var $author$project$Page$Source$view = F4(
	function (lang, dm, type_, id) {
		return A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var label = _v0.a;
				var sources = _v0.b;
				var breadcrumb = _v0.c;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$ol,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('breadcrumb-item active'),
										$author$project$Route$href($author$project$Route$Home)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Home')
									])),
							breadcrumb)),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(label),
								$elm$html$Html$text(': '),
								A2(
								$elm$html$Html$code,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(id)
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This is the raw data we\'ve exported from the Wolcen game files. It\'s not very pretty, but it might be useful if Wolcen and other WolcenDB pages don\'t yet have the information you\'re looking for, or if you\'re programming something.')
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('list-group')
							]),
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Page$Source$viewSource,
								$elm$html$Html$li(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list-group-item')
										]))),
							sources))
					]);
			},
			A4($author$project$Page$Source$getSource, lang, dm, type_, id));
	});
var $author$project$Page$Table$DescCell = function (a) {
	return {$: 2, a: a};
};
var $author$project$Page$Table$LinesCell = function (a) {
	return {$: 1, a: a};
};
var $author$project$Page$Table$StringCell = function (a) {
	return {$: 0, a: a};
};
var $author$project$Page$Table$EmptyCell = {$: 9};
var $author$project$Page$Table$maybeCell = $elm_community$maybe_extra$Maybe$Extra$unwrap($author$project$Page$Table$EmptyCell);
var $author$project$Datamine$City$projects = function (dm) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.ct;
		},
		$elm$core$List$filterMap(
			function (name) {
				return A2(
					$elm$core$Dict$get,
					$elm$core$String$toLower(name),
					dm.br);
			}));
};
var $author$project$Page$Table$dataCityBuilding = F2(
	function (lang, dm) {
		return {
			h: _List_fromArray(
				['name', 'uiTitle', 'uiLore', 'project.name', 'rolledProject.name', 'label', 'lore', 'project.label', 'rolledProject.label']),
			k: A2(
				$elm$core$List$map,
				function (building) {
					return _List_fromArray(
						[
							$author$project$Page$Table$StringCell(building.q),
							$author$project$Page$Table$StringCell(building.av),
							$author$project$Page$Table$StringCell(building.aO),
							$author$project$Page$Table$LinesCell(building.ct),
							$author$project$Page$Table$LinesCell(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.cs;
								},
								building.cE)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$City$label, lang, building)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$City$lore, lang, building)),
							$author$project$Page$Table$LinesCell(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Maybe$withDefault('???'),
									$author$project$Datamine$City$label(lang)),
								A2($author$project$Datamine$City$projects, dm, building))),
							$author$project$Page$Table$LinesCell(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$withDefault('???'),
										$author$project$Datamine$City$label(lang)),
									function ($) {
										return $.d5;
									}),
								A2($author$project$Datamine$City$rolledProjects, dm, building)))
						]);
				},
				dm.ad)
		};
	});
var $author$project$Page$Table$IntCell = function (a) {
	return {$: 6, a: a};
};
var $author$project$Page$Table$dataCityCategory = function (dm) {
	return {
		h: _List_fromArray(
			['name', 'uiTitle', 'order']),
		k: A2(
			$elm$core$List$map,
			function (cat) {
				return _List_fromArray(
					[
						$author$project$Page$Table$StringCell(cat.q),
						$author$project$Page$Table$StringCell(cat.av),
						$author$project$Page$Table$IntCell(cat.d0)
					]);
			},
			dm.ae)
	};
};
var $author$project$Page$Table$dataCityLevel = function (dm) {
	return {
		h: _List_fromArray(
			['level', 'productionThreshold']),
		k: A2(
			$elm$core$List$map,
			function (level) {
				return _List_fromArray(
					[
						$author$project$Page$Table$IntCell(level.dL),
						$author$project$Page$Table$IntCell(level.d4)
					]);
			},
			dm.aA)
	};
};
var $author$project$Page$Table$SourceCell = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Page$Table$dataCityProject = F2(
	function (lang, dm) {
		return {
			h: _List_fromArray(
				['name', 'source', 'uiName', 'label', 'uiLore', 'lore', 'outcomes']),
			k: A2(
				$elm$core$List$map,
				function (proj) {
					return _List_fromArray(
						[
							$author$project$Page$Table$StringCell(proj.q),
							A2($author$project$Page$Table$SourceCell, 'city-project', proj.q),
							$author$project$Page$Table$StringCell(proj.av),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$StringCell,
							A2($author$project$Datamine$City$label, lang, proj)),
							$author$project$Page$Table$StringCell(proj.aO),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$City$lore, lang, proj)),
							$author$project$Page$Table$LinesCell(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$String$fromInt,
									function ($) {
										return $._;
									}),
								proj.cD)),
							$author$project$Page$Table$LinesCell(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.cC;
								},
								proj.cD)),
							$author$project$Page$Table$LinesCell(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Maybe$withDefault('???'),
										$author$project$Datamine$City$label(lang)),
									function ($) {
										return $.eg;
									}),
								A2($author$project$Datamine$City$projectRewards, dm, proj))),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$StringCell,
							A2($author$project$Datamine$City$projectOutcomes, lang, proj))
						]);
				},
				dm.ag)
		};
	});
var $author$project$Page$Table$dataCityProjectScaling = function (dm) {
	return {
		h: _List_fromArray(
			['name', 'factor']),
		k: A2(
			$elm$core$List$map,
			function (scale) {
				return _List_fromArray(
					[
						$author$project$Page$Table$StringCell(scale.q),
						$author$project$Page$Table$LinesCell(
						A2(
							$elm$core$List$map,
							$elm$core$String$fromInt,
							$elm$core$Array$toList(scale.$7)))
					]);
			},
			dm.af)
	};
};
var $author$project$Page$Table$dataCityReward = F2(
	function (lang, dm) {
		return {
			h: _List_fromArray(
				['name', 'uiTitle', 'uiLore', 'label', 'lore']),
			k: A2(
				$elm$core$List$map,
				function (reward) {
					return _List_fromArray(
						[
							$author$project$Page$Table$StringCell(reward.q),
							A2($author$project$Page$Table$SourceCell, 'city-reward', reward.q),
							$author$project$Page$Table$StringCell(reward.av),
							$author$project$Page$Table$StringCell(reward.aO),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$City$label, lang, reward)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$City$lore, lang, reward)),
							$author$project$Page$Table$LinesCell(
							$author$project$Datamine$City$rewardToString(reward))
						]);
				},
				dm.ah)
		};
	});
var $author$project$Page$Table$ImgCell = function (a) {
	return {$: 3, a: a};
};
var $author$project$Page$Table$dataGemFamily = F2(
	function (lang, dm) {
		return {
			h: _List_fromArray(
				['gemFamilyId', 'relatedGems', 'craftRelatedAffixes', 'label', 'img']),
			k: A2(
				$elm$core$List$map,
				function (fam) {
					return _List_fromArray(
						[
							$author$project$Page$Table$StringCell(fam.bU),
							$author$project$Page$Table$LinesCell(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.du;
								},
								fam.ec)),
							$author$project$Page$Table$LinesCell(fam.df),
							$author$project$Page$Table$StringCell(
							A3($author$project$Datamine$GemFamily$label, lang, dm, fam)),
							$author$project$Page$Table$ImgCell(
							A2($author$project$Datamine$GemFamily$img, dm, fam))
						]);
				},
				dm.J)
		};
	});
var $author$project$Page$Table$dataNormalItem = F2(
	function (lang, dm) {
		return {
			h: _List_fromArray(
				['name', 'label', 'baseEffects', 'implicitEffects']),
			k: A2(
				$elm$core$List$map,
				function (nitem) {
					return _List_fromArray(
						[
							$author$project$Page$Table$StringCell(
							$author$project$Datamine$NormalItem$name(nitem)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$StringCell,
							A2($author$project$Datamine$NormalItem$label, lang, nitem)),
							$author$project$Page$Table$LinesCell(
							A2($author$project$Datamine$NormalItem$baseEffects, dm, nitem)),
							$author$project$Page$Table$LinesCell(
							A3($author$project$Datamine$NormalItem$implicitEffects, lang, dm, nitem))
						]);
				},
				dm.al)
		};
	});
var $author$project$Datamine$Passive$desc = F2(
	function (lang, s) {
		return A2($author$project$Lang$mget, lang, s.bP);
	});
var $author$project$Datamine$Passive$lore = F2(
	function (lang, s) {
		return A2($author$project$Lang$mget, lang, s.b1);
	});
var $author$project$Page$Table$dataPassive = F2(
	function (lang, dm) {
		return {
			h: _List_fromArray(
				['name', 'uiName', 'hudLoreDesc', 'gameplayDesc', 'rarity', 'category', 'label', 'desc', 'lore', 'effects']),
			k: A2(
				$elm$core$List$map,
				function (_v0) {
					var entry = _v0.a;
					var passive = _v0.b;
					var tree = _v0.c;
					return _List_fromArray(
						[
							$author$project$Page$Table$StringCell(passive.q),
							$author$project$Page$Table$StringCell(passive.av),
							A2($author$project$Page$Table$maybeCell, $author$project$Page$Table$StringCell, passive.b1),
							A2($author$project$Page$Table$maybeCell, $author$project$Page$Table$StringCell, passive.bP),
							$author$project$Page$Table$IntCell(entry.d8),
							$author$project$Page$Table$StringCell(entry.bl),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$StringCell,
							A2($author$project$Datamine$Passive$label, lang, passive)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$Passive$desc, lang, passive)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$Passive$lore, lang, passive)),
							$author$project$Page$Table$LinesCell(
							A2($author$project$Datamine$Passive$effects, lang, passive))
						]);
				},
				dm.ck)
		};
	});
var $author$project$Page$Table$dataReagent = F2(
	function (lang, dm) {
		return {
			h: _List_fromArray(
				['name', 'uiName', 'gameplayDesc', 'hudLoreDesc', 'hudPicture', 'reagentType', 'label', 'desc', 'lore', 'img']),
			k: A2(
				$elm$core$List$map,
				function (reagent) {
					return _List_fromArray(
						[
							$author$project$Page$Table$StringCell(reagent.q),
							$author$project$Page$Table$StringCell(reagent.av),
							$author$project$Page$Table$StringCell(reagent.bP),
							$author$project$Page$Table$StringCell(reagent.cb),
							$author$project$Page$Table$StringCell(reagent.b2),
							$author$project$Page$Table$StringCell(reagent.d9),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$StringCell,
							A2($author$project$Datamine$Reagent$label, lang, reagent)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$Reagent$desc, lang, reagent)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$Reagent$lore, lang, reagent)),
							$author$project$Page$Table$ImgCell(
							$author$project$Datamine$Reagent$img(reagent))
						]);
				},
				dm.ar)
		};
	});
var $elm_community$dict_extra$Dict$Extra$frequencies = function (list) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (el, counter) {
				return function (count) {
					return A3($elm$core$Dict$insert, el, count, counter);
				}(
					function (count) {
						return count + 1;
					}(
						A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Dict$get, el, counter))));
			}),
		$elm$core$Dict$empty,
		list);
};
var $author$project$Datamine$Skill$popularEffects = function (dm) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortBy,
			$elm$core$Tuple$second,
			$elm$core$Dict$toList(
				$elm_community$dict_extra$Dict$Extra$frequencies(
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						_Utils_ap(
							A2($elm$core$List$concatMap, $author$project$Datamine$Skill$effects, dm.M),
							A2(
								$elm$core$List$concatMap,
								$author$project$Datamine$Skill$effects,
								A2(
									$elm$core$List$concatMap,
									function ($) {
										return $.c0;
									},
									dm.M))))))));
};
var $author$project$Page$Table$dataSkillEffectPopularity = function (dm) {
	return {
		h: _List_fromArray(
			['effect', 'count']),
		k: A2(
			$elm$core$List$map,
			function (_v0) {
				var effect = _v0.a;
				var count = _v0.b;
				return _List_fromArray(
					[
						$author$project$Page$Table$StringCell(effect),
						$author$project$Page$Table$IntCell(count)
					]);
			},
			$author$project$Datamine$Skill$popularEffects(dm))
	};
};
var $author$project$Datamine$UniqueItem$formatStat = function (r) {
	return _Utils_eq(r.dS, r.dQ) ? ((!r.dS) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$elm$core$String$fromInt(r.dS))) : $elm$core$Maybe$Just(
		$elm$core$String$fromInt(r.dS) + ('-' + $elm$core$String$fromInt(r.dQ)));
};
var $author$project$Datamine$UniqueItem$baseEffects = F2(
	function (dm, uitem) {
		switch (uitem.$) {
			case 0:
				var w = uitem.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return 'Damage: ' + s;
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$UniqueItem$formatStat, w.bw)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return 'Resource: ' + s;
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$UniqueItem$formatStat, w.cB))
						]));
			case 1:
				var w = uitem.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + ' All Resistance';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$UniqueItem$formatStat, w.cM)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + '% Block Chance';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$UniqueItem$formatStat, w.cK)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + '% Block Efficiency';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$UniqueItem$formatStat, w.cL))
						]));
			case 2:
				var a = uitem.a;
				return A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + ' Health';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$UniqueItem$formatStat, a.b_)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + ' Force Shield';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$UniqueItem$formatStat, a.bO)),
							A2(
							$elm$core$Maybe$map,
							function (s) {
								return s + ' All Resistance';
							},
							A2($elm$core$Maybe$andThen, $author$project$Datamine$UniqueItem$formatStat, a.bh))
						]));
			default:
				return _List_Nil;
		}
	});
var $author$project$Datamine$UniqueItem$defaultEffects = F2(
	function (lang, dm) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Datamine$UniqueItem$defaultAffixes,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Datamine$Affix$getNonmagicIds(dm),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$concatMap(
						function ($) {
							return $.aW;
						}),
					$elm$core$List$map(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Datamine$Affix$formatEffect(lang),
							$elm$core$Maybe$withDefault('???'))))));
	});
var $author$project$Datamine$UniqueItem$implicitEffects = F2(
	function (lang, dm) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Datamine$UniqueItem$implicitAffixes,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Datamine$Affix$getNonmagicIds(dm),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$concatMap(
						function ($) {
							return $.aW;
						}),
					$elm$core$List$map(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Datamine$Affix$formatEffect(lang),
							$elm$core$Maybe$withDefault('???'))))));
	});
var $author$project$Datamine$UniqueItem$lore = F2(
	function (lang, n) {
		return A2(
			$author$project$Lang$mget,
			lang,
			function () {
				switch (n.$) {
					case 0:
						var i = n.a;
						return i.cb;
					case 1:
						var i = n.a;
						return i.cb;
					case 2:
						var i = n.a;
						return i.cb;
					default:
						var i = n.a;
						return i.cb;
				}
			}());
	});
var $author$project$Page$Table$dataUniqueItem = F2(
	function (lang, dm) {
		return {
			h: _List_fromArray(
				['name', 'label', 'lore', 'baseEffects', 'implicitEffects', 'defaultEffects']),
			k: A2(
				$elm$core$List$map,
				function (uitem) {
					return _List_fromArray(
						[
							$author$project$Page$Table$StringCell(
							$author$project$Datamine$UniqueItem$name(uitem)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$StringCell,
							A2($author$project$Datamine$UniqueItem$label, lang, uitem)),
							A2(
							$author$project$Page$Table$maybeCell,
							$author$project$Page$Table$DescCell,
							A2($author$project$Datamine$UniqueItem$lore, lang, uitem)),
							$author$project$Page$Table$LinesCell(
							A2($author$project$Datamine$UniqueItem$baseEffects, dm, uitem)),
							$author$project$Page$Table$LinesCell(
							A3($author$project$Datamine$UniqueItem$implicitEffects, lang, dm, uitem)),
							$author$project$Page$Table$LinesCell(
							A3($author$project$Datamine$UniqueItem$defaultEffects, lang, dm, uitem))
						]);
				},
				dm.Y)
		};
	});
var $author$project$Page$Table$datas = _List_fromArray(
	[
		_Utils_Tuple2('normal-loot', $author$project$Page$Table$dataNormalItem),
		_Utils_Tuple2('unique-loot', $author$project$Page$Table$dataUniqueItem),
		_Utils_Tuple2('passive', $author$project$Page$Table$dataPassive),
		_Utils_Tuple2('reagent', $author$project$Page$Table$dataReagent),
		_Utils_Tuple2('gem-family', $author$project$Page$Table$dataGemFamily),
		_Utils_Tuple2('city-project', $author$project$Page$Table$dataCityProject),
		_Utils_Tuple2(
		'city-project-scaling',
		$elm$core$Basics$always($author$project$Page$Table$dataCityProjectScaling)),
		_Utils_Tuple2('city-reward', $author$project$Page$Table$dataCityReward),
		_Utils_Tuple2('city-building', $author$project$Page$Table$dataCityBuilding),
		_Utils_Tuple2(
		'city-category',
		$elm$core$Basics$always($author$project$Page$Table$dataCityCategory)),
		_Utils_Tuple2(
		'city-level',
		$elm$core$Basics$always($author$project$Page$Table$dataCityLevel)),
		_Utils_Tuple2(
		'skill-effect-popularity',
		$elm$core$Basics$always($author$project$Page$Table$dataSkillEffectPopularity))
	]);
var $author$project$Page$Table$dataByKey = $elm$core$Dict$fromList($author$project$Page$Table$datas);
var $author$project$Page$Table$dataFromString = F3(
	function (lang, dm, s) {
		return A2(
			$elm$core$Maybe$map,
			function (fn) {
				return A2(fn, lang, dm);
			},
			A2(
				$elm$core$Dict$get,
				$elm$core$String$toLower(s),
				$author$project$Page$Table$dataByKey));
	});
var $author$project$Page$Table$viewBreadcrumb = function (tableId) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('breadcrumb')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb-item active'),
						$author$project$Route$href($author$project$Route$Home)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Home')
					])),
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb-item active'),
						$author$project$Route$href(
						$author$project$Route$Table(tableId))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$toLower(tableId))
					]))
			]));
};
var $author$project$Page$Table$formatCsvString = function (raw) {
	return (A2($elm$core$String$contains, ',', raw) || A2($elm$core$String$contains, '\"', raw)) ? ('\"' + (A3($elm$core$String$replace, '\"', '\"\"', raw) + '\"')) : raw;
};
var $author$project$Page$Table$toStringCell = function (cell) {
	switch (cell.$) {
		case 0:
			var s = cell.a;
			return s;
		case 1:
			var ls = cell.a;
			return A2($elm$core$String$join, '\n', ls);
		case 2:
			var s = cell.a;
			return s;
		case 3:
			var s = cell.a;
			return s;
		case 4:
			var r = cell.a;
			var s = cell.b;
			return s;
		case 5:
			var type_ = cell.a;
			var id = cell.b;
			return '';
		case 6:
			var i = cell.a;
			return $elm$core$String$fromInt(i);
		case 7:
			var f = cell.a;
			return $elm$core$String$fromFloat(f);
		case 8:
			var b = cell.a;
			return b ? 'TRUE' : 'FALSE';
		default:
			return '';
	}
};
var $author$project$Route$toUrl = function (route) {
	return {
		ds: $elm$core$Maybe$Nothing,
		dz: 'wolcendb.erosson.org',
		a5: $author$project$Route$toPath(route),
		d3: $elm$core$Maybe$Nothing,
		d6: 1,
		cu: function () {
			var _v0 = $author$project$Route$toQuery(route);
			if (!_v0.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var qs = _v0;
				return $elm$core$Maybe$Just(
					$elm$url$Url$Builder$toQuery(qs));
			}
		}()
	};
};
var $author$project$Page$Table$toStringCells = F2(
	function (route, data) {
		return A2(
			$elm$core$List$cons,
			_Utils_ap(
				data.h,
				_List_fromArray(
					[
						$elm$url$Url$toString(
						$author$project$Route$toUrl(route))
					])),
			A2(
				$elm$core$List$map,
				$elm$core$List$map($author$project$Page$Table$toStringCell),
				data.k));
	});
var $author$project$Page$Table$formatCsv = function (route) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Table$toStringCells(route),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map($author$project$Page$Table$formatCsvString),
					$elm$core$String$join(','))),
			$elm$core$String$join('\n')));
};
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $author$project$Page$Table$viewTextarea = function (s) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$textarea,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control'),
					$elm$html$Html$Attributes$rows(20),
					$elm$html$Html$Attributes$cols(100),
					$elm$html$Html$Attributes$readonly(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(s)
				]))
		]);
};
var $author$project$Page$Table$viewCsv = function (route) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Table$formatCsv(route),
		$author$project$Page$Table$viewTextarea);
};
var $author$project$Page$Table$viewHtml = function (d) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (col) {
									return A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('sticky')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(col)
											]));
								},
								d.h))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function (cell) {
									switch (cell.$) {
										case 0:
											var s = cell.a;
											return _List_fromArray(
												[
													$elm$html$Html$text(s)
												]);
										case 1:
											var ls = cell.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'min-width', '15em')
														]),
													A2(
														$elm$core$List$map,
														function (l) {
															return A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(l)
																	]));
														},
														ls))
												]);
										case 2:
											var s = cell.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'min-width', '20em')
														]),
													$author$project$View$Desc$format(s))
												]);
										case 3:
											var s = cell.a;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src(s)
														]),
													_List_Nil)
												]);
										case 4:
											var r = cell.a;
											var s = cell.b;
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(r)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(s)
														]))
												]);
										case 5:
											var type_ = cell.a;
											var id = cell.b;
											return _List_fromArray(
												[
													$elm$html$Html$text('['),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															A2($author$project$Route$Source, type_, id))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Source')
														])),
													$elm$html$Html$text(']')
												]);
										case 6:
											var i = cell.a;
											return _List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(i))
												]);
										case 7:
											var f = cell.a;
											return _List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromFloat(f))
												]);
										case 8:
											var b = cell.a;
											return b ? _List_fromArray(
												[
													$elm$html$Html$text('TRUE')
												]) : _List_Nil;
										default:
											return _List_Nil;
									}
								}),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									$elm$html$Html$td(_List_Nil)),
								$elm$html$Html$tr(_List_Nil))),
						d.k))
				]))
		]);
};
var $author$project$Page$Table$toJsonCell = function (cell) {
	switch (cell.$) {
		case 0:
			var s = cell.a;
			return $elm$json$Json$Encode$string(s);
		case 1:
			var ls = cell.a;
			return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, ls);
		case 2:
			var s = cell.a;
			return $elm$json$Json$Encode$string(s);
		case 3:
			var s = cell.a;
			return $elm$json$Json$Encode$string(s);
		case 4:
			var r = cell.a;
			var s = cell.b;
			return $elm$json$Json$Encode$string(s);
		case 5:
			var type_ = cell.a;
			var id = cell.b;
			return $elm$json$Json$Encode$null;
		case 6:
			var i = cell.a;
			return $elm$json$Json$Encode$int(i);
		case 7:
			var f = cell.a;
			return $elm$json$Json$Encode$float(f);
		case 8:
			var b = cell.a;
			return $elm$json$Json$Encode$bool(b);
		default:
			return $elm$json$Json$Encode$null;
	}
};
var $author$project$Page$Table$formatJsonObjects = F3(
	function (indent, route, data) {
		return A2(
			$elm$json$Json$Encode$encode,
			indent,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(
							$elm$url$Url$toString(
								$author$project$Route$toUrl(route)))),
						_Utils_Tuple2(
						'data',
						A2(
							$elm$json$Json$Encode$list,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map($author$project$Page$Table$toJsonCell),
								A2(
									$elm$core$Basics$composeR,
									A2($elm$core$List$map2, $elm$core$Tuple$pair, data.h),
									$elm$json$Json$Encode$object)),
							data.k))
					])));
	});
var $author$project$Page$Table$viewJsonObjects = F2(
	function (indent, route) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Page$Table$formatJsonObjects, indent, route),
			$author$project$Page$Table$viewTextarea);
	});
var $author$project$Page$Table$formatJsonTable = F3(
	function (indent, route, data) {
		return A2(
			$elm$json$Json$Encode$encode,
			indent,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'source',
						$elm$json$Json$Encode$string(
							$elm$url$Url$toString(
								$author$project$Route$toUrl(route)))),
						_Utils_Tuple2(
						'cols',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, data.h)),
						_Utils_Tuple2(
						'rows',
						A2(
							$elm$json$Json$Encode$list,
							$elm$json$Json$Encode$list($author$project$Page$Table$toJsonCell),
							data.k))
					])));
	});
var $author$project$Page$Table$viewJsonTable = F2(
	function (indent, route) {
		return A2(
			$elm$core$Basics$composeR,
			A2($author$project$Page$Table$formatJsonTable, indent, route),
			$author$project$Page$Table$viewTextarea);
	});
var $author$project$Page$Table$formatTsvString = A2(
	$elm$core$Basics$composeR,
	A2($elm$core$String$replace, '\\', '\\\\'),
	A2(
		$elm$core$Basics$composeR,
		A2($elm$core$String$replace, '\t', '\\t'),
		A2(
			$elm$core$Basics$composeR,
			A2($elm$core$String$replace, '\n', '\\n'),
			A2($elm$core$String$replace, '\u000D', '\\r'))));
var $author$project$Page$Table$formatTsv = function (route) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Table$toStringCells(route),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map($author$project$Page$Table$formatTsvString),
					$elm$core$String$join('\t'))),
			$elm$core$String$join('\n')));
};
var $author$project$Page$Table$viewTsv = function (route) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Page$Table$formatTsv(route),
		$author$project$Page$Table$viewTextarea);
};
var $author$project$Page$Table$views = _List_fromArray(
	[
		_Utils_Tuple2(
		'html',
		$elm$core$Basics$always($author$project$Page$Table$viewHtml)),
		_Utils_Tuple2('tsv', $author$project$Page$Table$viewTsv),
		_Utils_Tuple2('csv', $author$project$Page$Table$viewCsv),
		_Utils_Tuple2(
		'json',
		$author$project$Page$Table$viewJsonObjects(2)),
		_Utils_Tuple2(
		'min.json',
		$author$project$Page$Table$viewJsonObjects(0)),
		_Utils_Tuple2(
		'table.json',
		$author$project$Page$Table$viewJsonTable(2)),
		_Utils_Tuple2(
		'table.min.json',
		$author$project$Page$Table$viewJsonTable(0))
	]);
var $author$project$Page$Table$viewByKey = $elm$core$Dict$fromList($author$project$Page$Table$views);
var $author$project$Page$Table$viewFromString = function (s) {
	return A2(
		$elm$core$Dict$get,
		$elm$core$String$toLower(s),
		$author$project$Page$Table$viewByKey);
};
var $author$project$Page$Table$viewPageNav = function (_v0) {
	var dataId = _v0.a;
	var viewId = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('btn btn-outline-dark dropdown-toggle'),
								A2($elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dataset: ' + dataId)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown-menu')
							]),
						A2(
							$elm$core$List$map,
							function (nextId) {
								var id = nextId + ('.' + viewId);
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dropdown-item'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'active',
													_Utils_eq(nextId, dataId))
												])),
											$author$project$Route$href(
											$author$project$Route$Table(id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(nextId)
										]));
							},
							A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Page$Table$datas)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('btn btn-outline-dark dropdown-toggle'),
								A2($elm$html$Html$Attributes$attribute, 'data-toggle', 'dropdown')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Format: ' + viewId)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown-menu')
							]),
						A2(
							$elm$core$List$map,
							function (nextId) {
								var id = dataId + ('.' + nextId);
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('dropdown-item'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'active',
													_Utils_eq(nextId, viewId))
												])),
											$author$project$Route$href(
											$author$project$Route$Table(id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(nextId)
										]));
							},
							A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Page$Table$views)))
					]))
			]));
};
var $author$project$Page$Table$view = F3(
	function (lang, dm, tableId) {
		var _v0 = A2(
			$elm$core$String$split,
			'.',
			$elm$core$String$toLower(tableId));
		if (_v0.b) {
			var dataId = _v0.a;
			var viewIds = _v0.b;
			var viewId = A2($elm$core$String$join, '.', viewIds);
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (viewer, data) {
						return A2(
							$elm$core$List$cons,
							$author$project$Page$Table$viewBreadcrumb(tableId),
							A2(
								$elm$core$List$cons,
								$author$project$Page$Table$viewPageNav(
									_Utils_Tuple2(dataId, viewId)),
								A2(
									viewer,
									$author$project$Route$Table(tableId),
									data)));
					}),
				$author$project$Page$Table$viewFromString(viewId),
				A3($author$project$Page$Table$dataFromString, lang, dm, dataId));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Datamine$UniqueItem$img = F2(
	function (dm, uitem) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$String$toLower,
			function () {
				switch (uitem.$) {
					case 3:
						var item = uitem.a;
						return $elm$core$Maybe$Just($author$project$Datamine$Util$imghost + ('/armors/' + item.b2));
					case 2:
						var item = uitem.a;
						return A2(
							$elm$core$Maybe$map,
							function (t) {
								return $author$project$Datamine$Util$imghost + ('/armors/' + t.b2);
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(
									A2($elm$core$Maybe$withDefault, '', item.bi)),
								dm.aB));
					default:
						return A2(
							$elm$core$Maybe$map,
							function (t) {
								return $author$project$Datamine$Util$imghost + ('/weapons/' + t.b2);
							},
							A2(
								$elm$core$Dict$get,
								$elm$core$String$toLower(
									$author$project$Datamine$UniqueItem$name(uitem)),
								dm.aC));
				}
			}());
	});
var $author$project$Datamine$UniqueItem$keywords = function (uitem) {
	switch (uitem.$) {
		case 0:
			var i = uitem.a;
			return i.dI;
		case 1:
			var i = uitem.a;
			return i.dI;
		case 2:
			var i = uitem.a;
			return i.dI;
		default:
			var i = uitem.a;
			return i.dI;
	}
};
var $author$project$View$Affix$viewNonmagicIds = F2(
	function (lang, dm) {
		return A2(
			$elm$core$Basics$composeR,
			$author$project$Datamine$Affix$getNonmagicIds(dm),
			$author$project$View$Affix$viewAffixes(lang));
	});
var $author$project$Page$UniqueItem$viewMain = F3(
	function (lang, dm, uitem) {
		var label = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'???',
				A2($author$project$Datamine$UniqueItem$label, lang, uitem)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href(
								$author$project$Route$UniqueItems($elm$core$Maybe$Nothing))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Unique Loot')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href(
								$author$project$Route$UniqueItem(
									$author$project$Datamine$UniqueItem$name(uitem)))
							]),
						_List_fromArray(
							[label]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-header')
							]),
						_List_fromArray(
							[label])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('item float-right')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($author$project$Datamine$UniqueItem$img, dm, uitem)))
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('['),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$author$project$Route$href(
														A2(
															$author$project$Route$Source,
															'unique-loot',
															$author$project$Datamine$UniqueItem$name(uitem)))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Source')
													])),
												$elm$html$Html$text(']')
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('['),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$author$project$Route$href(
														A2(
															$author$project$Route$Offline,
															'unique-loot',
															$author$project$Datamine$UniqueItem$name(uitem)))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Offline')
													])),
												$elm$html$Html$text(']')
											]))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Level: '),
										$elm$html$Html$text(
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											'-',
											$elm$core$String$fromInt,
											$author$project$Datamine$UniqueItem$levelPrereq(uitem)))
									])),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-group affixes')
									]),
								A2(
									$elm$core$List$map,
									function (s) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('list-group-item')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(s)
												]));
									},
									A2($author$project$Datamine$UniqueItem$baseEffects, dm, uitem))),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-group affixes')
									]),
								A3(
									$author$project$View$Affix$viewNonmagicIds,
									lang,
									dm,
									$author$project$Datamine$UniqueItem$implicitAffixes(uitem))),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-group affixes')
									]),
								A3(
									$author$project$View$Affix$viewNonmagicIds,
									lang,
									dm,
									$author$project$Datamine$UniqueItem$defaultAffixes(uitem))),
								A2(
								$elm$html$Html$small,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-muted')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Keywords: '),
										$elm$html$Html$text(
										A2(
											$elm$core$String$join,
											', ',
											$author$project$Datamine$UniqueItem$keywords(uitem)))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									$author$project$View$Desc$mformat(
										A2($author$project$Datamine$UniqueItem$lore, lang, uitem))))
							]))
					]))
			]);
	});
var $author$project$Page$UniqueItem$view = F3(
	function (lang, dm, name) {
		return A2(
			$elm$core$Maybe$map,
			A2($author$project$Page$UniqueItem$viewMain, lang, dm),
			A2(
				$elm$core$Dict$get,
				$elm$core$String$toLower(name),
				dm.c_));
	});
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $elm$core$Set$diff = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$diff, dict1, dict2);
	});
var $author$project$Page$UniqueItems$armorKeywordGroups = _List_fromArray(
	[
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', 'armor', 'heavy']),
			'Heavy Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'heavy', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'heavy', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'heavy', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'heavy', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'heavy', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'heavy', 'hand']),
				'Hand')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', 'armor', 'warrior']),
			'Brawler Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'warrior', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'warrior', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'warrior', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'warrior', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'warrior', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'warrior', 'hand']),
				'Hand')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', 'armor', 'rogue']),
			'Rogue Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'rogue', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'rogue', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'rogue', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'rogue', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'rogue', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'rogue', 'hand']),
				'Hand')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', 'armor', 'mage']),
			'Mage Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'mage', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'mage', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'mage', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'mage', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'mage', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'mage', 'hand']),
				'Hand')
			]))
	]);
var $author$project$Page$UniqueItems$otherKeywordGroups = _List_fromArray(
	[
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', 'armor']),
			'All Armor'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'chest']),
				'Chest'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'head']),
				'Head'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'legs']),
				'Legs'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'feet']),
				'Feet'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'shoulder']),
				'Shoulder'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'hand']),
				'Hand'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'armor', 'shield']),
				'Shield'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'trinket']),
				'Catalyst')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', 'accessory']),
			'Accessories'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'accessory', 'ring']),
				'Ring'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'accessory', 'amulet']),
				'Amulet'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'accessory', 'belt']),
				'Belt')
			]))
	]);
var $author$project$Page$UniqueItems$viewKeywordGroups = function (activeKw) {
	return $elm$core$List$map(
		function (_v0) {
			var _v1 = _v0.a;
			var mainkw = _v1.a;
			var mainlabel = _v1.b;
			var entries = _v0.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card d-inline-flex'),
						A2($elm$html$Html$Attributes$style, 'max-width', '15em')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-header p-2')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href(
										$author$project$Route$UniqueItems(
											$elm$core$Maybe$Just(
												A2($elm$core$String$join, ',', mainkw)))),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'btn btn-link btn-outline-primary m-0',
												_Utils_eq(mainkw, activeKw))
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(mainlabel)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-body p-0')
							]),
						A2(
							$elm$core$List$map,
							function (_v2) {
								var kw = _v2.a;
								var label = _v2.b;
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('btn btn-link'),
											$author$project$Route$href(
											$author$project$Route$UniqueItems(
												$elm$core$Maybe$Just(
													A2($elm$core$String$join, ',', kw)))),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'btn-outline-primary',
													_Utils_eq(kw, activeKw))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							},
							entries))
					]));
		});
};
var $author$project$Page$UniqueItems$weaponKeywordGroups = _List_fromArray(
	[
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', '1h', 'melee']),
			'One-handed melee'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '1h', 'melee', 'axe']),
				'Axe'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '1h', 'melee', 'mace']),
				'Mace'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '1h', 'melee', 'sword']),
				'Sword'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '1h', 'melee', 'dagger']),
				'Dagger'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', 'shield']),
				'Shield')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', '2h', 'melee']),
			'Two-handed melee'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '2h', 'melee', 'axe']),
				'Axe'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '2h', 'melee', 'mace']),
				'Mace'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '2h', 'melee', 'sword']),
				'Sword')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['unique', 'magic']),
			'Magic weapons'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '1h', 'magic']),
				'Catalyst'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '2h', 'magic']),
				'Staff')
			])),
		_Utils_Tuple2(
		_Utils_Tuple2(
			_List_fromArray(
				['ranged']),
			'Ranged weapons'),
		_List_fromArray(
			[
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '1h', 'ranged']),
				'Pistol'),
				_Utils_Tuple2(
				_List_fromArray(
					['unique', '2h', 'ranged']),
				'Bow')
			]))
	]);
var $author$project$Page$UniqueItems$viewMain = F4(
	function (lang, dm, keywords, items) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$ol,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('breadcrumb')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href($author$project$Route$Home)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Home')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('breadcrumb-item active'),
								$author$project$Route$href(
								$author$project$Route$UniqueItems(
									$elm$core$Maybe$Just(
										A2($elm$core$String$join, ',', keywords))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Unique Loot')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($author$project$Page$UniqueItems$viewKeywordGroups, keywords, $author$project$Page$UniqueItems$weaponKeywordGroups)),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($author$project$Page$UniqueItems$viewKeywordGroups, keywords, $author$project$Page$UniqueItems$armorKeywordGroups)),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($author$project$Page$UniqueItems$viewKeywordGroups, keywords, $author$project$Page$UniqueItems$otherKeywordGroups)),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-group')
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var mainitem = _v0.a;
						var group = _v0.b;
						var colCls = function () {
							var _v1 = $elm$core$List$length(group);
							switch (_v1) {
								case 1:
									return 'col-sm-12';
								case 2:
									return 'col-sm-6';
								case 3:
									return 'col-sm-4';
								case 4:
									return 'col-sm-3';
								default:
									return 'col-sm-3';
							}
						}();
						return A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-group-item')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('col-sm-3')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Route$href(
															$author$project$Route$UniqueItem(
																$author$project$Datamine$UniqueItem$name(mainitem)))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('unique-list-img'),
																	$elm$html$Html$Attributes$src(
																	A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A2($author$project$Datamine$UniqueItem$img, dm, mainitem)))
																]),
															_List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('col-sm-9')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('row')
														]),
													A2(
														$elm$core$List$map,
														function (uitem) {
															return A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class(colCls)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$a,
																		_List_fromArray(
																			[
																				$author$project$Route$href(
																				$author$project$Route$UniqueItem(
																					$author$project$Datamine$UniqueItem$name(uitem)))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				A2(
																					$elm$core$Maybe$withDefault,
																					'???',
																					A2($author$project$Datamine$UniqueItem$label, lang, uitem)))
																			])),
																		A3(
																		$elm_community$maybe_extra$Maybe$Extra$unwrap,
																		A2($elm$html$Html$p, _List_Nil, _List_Nil),
																		function (lvl) {
																			return A2(
																				$elm$html$Html$p,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						'Level: ' + $elm$core$String$fromInt(lvl))
																					]));
																		},
																		$author$project$Datamine$UniqueItem$levelPrereq(uitem)),
																		A2(
																		$elm$html$Html$ul,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('list-group affixes')
																			]),
																		A2(
																			$elm$core$List$map,
																			function (s) {
																				return A2(
																					$elm$html$Html$li,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('list-group-item')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(s)
																						]));
																			},
																			A2($author$project$Datamine$UniqueItem$baseEffects, dm, uitem))),
																		A2(
																		$elm$html$Html$ul,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('list-group affixes')
																			]),
																		A2(
																			$elm$core$List$map,
																			function (s) {
																				return A2(
																					$elm$html$Html$li,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('list-group-item')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(s)
																						]));
																			},
																			A3($author$project$Datamine$UniqueItem$implicitEffects, lang, dm, uitem))),
																		A2(
																		$elm$html$Html$ul,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('list-group affixes')
																			]),
																		A2(
																			$elm$core$List$map,
																			function (s) {
																				return A2(
																					$elm$html$Html$li,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$class('list-group-item')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(s)
																						]));
																			},
																			A3($author$project$Datamine$UniqueItem$defaultEffects, lang, dm, uitem))),
																		A2(
																		$elm$html$Html$small,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('text-muted')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Keywords: '),
																				$elm$html$Html$text(
																				A2(
																					$elm$core$String$join,
																					', ',
																					$author$project$Datamine$UniqueItem$keywords(uitem)))
																			]))
																	]));
														},
														group))
												]))
										]))
								]));
					},
					items))
			]);
	});
var $author$project$Page$UniqueItems$view = F3(
	function (lang, dm, tagStr) {
		var tagList = A2(
			$elm$core$String$split,
			',',
			$elm$core$String$toLower(
				A2($elm$core$Maybe$withDefault, '', tagStr)));
		var tagSet = $elm$core$Set$fromList(tagList);
		var loot = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Datamine$UniqueItem$keywords,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map($elm$core$String$toLower),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Set$fromList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Set$diff(tagSet),
								$elm$core$Set$isEmpty))))),
			$elm$core$Dict$values(dm.c$));
		return A4($author$project$Page$UniqueItems$viewMain, lang, dm, tagList, loot);
	});
var $author$project$View$Nav$SearchInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$View$Nav$SearchSubmit = {$: 1};
var $author$project$View$Nav$viewSearchbar = function (m) {
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-inline'),
				$elm$html$Html$Events$onSubmit($author$project$View$Nav$SearchSubmit)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input-group')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control'),
								$elm$html$Html$Attributes$type_('search'),
								$elm$html$Html$Attributes$placeholder('Search'),
								$elm$html$Html$Attributes$value(m.bX),
								$elm$html$Html$Events$onInput($author$project$View$Nav$SearchInput)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-group-append')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn btn-outline-primary'),
										$elm$html$Html$Attributes$type_('submit')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('fas fa-search')
											]),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$View$Nav$view = function (m) {
	return $author$project$View$Nav$viewMain(
		$author$project$View$Nav$viewSearchbar(m));
};
var $author$project$Main$viewNotFound = _List_fromArray(
	[
		A2(
		$elm$html$Html$code,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('404 not found')
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href($author$project$Route$Home)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Back to safety')
					]))
			]))
	]);
var $author$project$Main$viewBody = F3(
	function (_v0, model, mroute) {
		var ssr = _v0.a8;
		return A4(
			$author$project$View$Loading$view,
			{dV: true},
			model,
			A3($krisajenkins$remotedata$RemoteData$map2, $elm$core$Tuple$pair, model.i, model.o),
			function (_v1) {
				var lang = _v1.a;
				var dm = _v1.b;
				var content = function () {
					if (mroute.$ === 1) {
						return $author$project$Main$viewNotFound;
					} else {
						var route = mroute.a;
						switch (route.$) {
							case 22:
								return $author$project$Main$viewNotFound;
							case 23:
								var next = route.b;
								return A3(
									$author$project$Main$viewBody,
									{a8: true},
									model,
									$elm$core$Maybe$Just(next));
							case 0:
								return $author$project$Page$Home$view(dm);
							case 1:
								var tier = route.a;
								var kws = route.b;
								var okws = route.c;
								return A5($author$project$Page$NormalItems$view, lang, dm, tier, kws, okws);
							case 2:
								var name = route.a;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Main$viewNotFound,
									A2(
										$elm$core$Maybe$map,
										$elm$core$List$map(
											$elm$html$Html$map($author$project$Main$NormalItemMsg)),
										A4($author$project$Page$NormalItem$view, lang, dm, model, name)));
							case 3:
								var tags = route.a;
								return A3($author$project$Page$UniqueItems$view, lang, dm, tags);
							case 4:
								var name = route.a;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Main$viewNotFound,
									A3($author$project$Page$UniqueItem$view, lang, dm, name));
							case 5:
								var form = route.a;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Main$viewNotFound,
									A3($author$project$Page$Skills$view, lang, dm, form));
							case 6:
								var s = route.a;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Main$viewNotFound,
									A3($author$project$Page$Skill$view, lang, dm, s));
							case 7:
								var v = route.a;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Main$viewNotFound,
									A3($author$project$Page$SkillVariant$view, lang, dm, v));
							case 8:
								return A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Main$PageAffixesMsg),
									A3($author$project$Page$Affixes$view, lang, dm, model));
							case 9:
								return A2($author$project$Page$Gems$view, lang, dm);
							case 10:
								return A2($author$project$Page$Passives$view, lang, dm);
							case 11:
								return A2($author$project$Page$Reagents$view, lang, dm);
							case 12:
								var name = route.a;
								return A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Main$CityMsg),
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Main$viewNotFound,
										A4($author$project$Page$City$view, lang, dm, model, name)));
							case 13:
								return A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Main$AilmentsMsg),
									A2($author$project$Page$Ailments$view, dm, model));
							case 14:
								var type_ = route.a;
								var id = route.b;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Main$viewNotFound,
									A4($author$project$Page$Source$view, lang, dm, type_, id));
							case 15:
								var type_ = route.a;
								var id = route.b;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Main$viewNotFound,
									A4($author$project$Page$Offline$view, lang, dm, type_, id));
							case 16:
								var query = route.a;
								return A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Main$SearchMsg),
									A3($author$project$Page$Search$view, lang, dm, model));
							case 17:
								var t = route.a;
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Main$viewNotFound,
									A3($author$project$Page$Table$view, lang, dm, t));
							case 18:
								return A2($author$project$Page$BuildRevisions$view, dm, model);
							case 19:
								return $author$project$Page$Langs$view(model);
							case 20:
								return $author$project$Page$Changelog$view(model);
							default:
								return $author$project$Page$Privacy$view;
						}
					}
				}();
				return ssr ? content : _List_fromArray(
					[
						$author$project$Route$base(
						$author$project$Route$toMOptions(model.n)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('container')
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$author$project$Main$NavMsg,
								$author$project$View$Nav$view(model)),
							content))
					]);
			});
	});
var $author$project$Page$NormalItem$viewTitle = F3(
	function (lang, dm, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Datamine$NormalItem$label(lang),
				A2(
					$elm$core$Dict$get,
					$elm$core$String$toLower(name),
					dm.ca)));
	});
var $author$project$Page$Skill$viewTitle = F3(
	function (lang, dm, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Datamine$Skill$label(lang),
				A2(
					$elm$core$Dict$get,
					$elm$core$String$toLower(name),
					dm.cR)));
	});
var $author$project$Page$SkillVariant$viewTitle = F3(
	function (lang, dm, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var v = _v1.a;
					var s = _v1.b;
					return s + (': ' + v);
				},
				A2(
					$elm$core$Maybe$andThen,
					function (_v0) {
						var v = _v0.a;
						var s = _v0.b;
						return A3(
							$elm$core$Maybe$map2,
							$elm$core$Tuple$pair,
							A2($author$project$Datamine$Skill$label, lang, v),
							A2($author$project$Datamine$Skill$label, lang, s));
					},
					A2(
						$elm$core$Dict$get,
						$elm$core$String$toLower(id),
						dm.cP))));
	});
var $author$project$Page$UniqueItem$viewTitle = F3(
	function (lang, dm, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Datamine$UniqueItem$label(lang),
				A2(
					$elm$core$Dict$get,
					$elm$core$String$toLower(name),
					dm.c_)));
	});
var $author$project$Main$viewTitle = function (model) {
	viewTitle:
	while (true) {
		var _v0 = model.n;
		if (_v0.$ === 1) {
			return 'WolcenDB';
		} else {
			var route = _v0.a;
			var _v1 = _Utils_Tuple3(route, model.i, model.o);
			switch (_v1.a.$) {
				case 22:
					return 'WolcenDB';
				case 23:
					var _v2 = _v1.a;
					var next = _v2.b;
					var $temp$model = _Utils_update(
						model,
						{
							n: $elm$core$Maybe$Just(next)
						});
					model = $temp$model;
					continue viewTitle;
				case 0:
					var _v3 = _v1.a;
					return 'WolcenDB: a Wolcen item, skill, and magic affix database';
				case 1:
					var _v4 = _v1.a;
					var tier = _v4.a;
					var kws = _v4.b;
					var okws = _v4.c;
					return 'WolcenDB: normal item list' + (A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$fromInt,
							$elm$core$Basics$append(': Tier ')),
						tier) + A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$elm$core$Basics$append(': '),
						kws));
				case 2:
					if ((_v1.b.$ === 3) && (_v1.c.$ === 3)) {
						var name = _v1.a.a;
						var lang = _v1.b.a;
						var dm = _v1.c.a;
						return 'WolcenDB: normal item: ' + A3($author$project$Page$NormalItem$viewTitle, lang, dm, name);
					} else {
						var name = _v1.a.a;
						return 'WolcenDB: normal item';
					}
				case 3:
					var kws = _v1.a.a;
					return 'WolcenDB: unique item list' + A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						$elm$core$Basics$append(': '),
						kws);
				case 4:
					if ((_v1.b.$ === 3) && (_v1.c.$ === 3)) {
						var name = _v1.a.a;
						var lang = _v1.b.a;
						var dm = _v1.c.a;
						return 'WolcenDB: unique item: ' + A3($author$project$Page$UniqueItem$viewTitle, lang, dm, name);
					} else {
						var name = _v1.a.a;
						return 'WolcenDB: unique item';
					}
				case 5:
					return 'WolcenDB: skill list';
				case 6:
					if ((_v1.b.$ === 3) && (_v1.c.$ === 3)) {
						var name = _v1.a.a;
						var lang = _v1.b.a;
						var dm = _v1.c.a;
						return 'WolcenDB: skill: ' + A3($author$project$Page$Skill$viewTitle, lang, dm, name);
					} else {
						var name = _v1.a.a;
						return 'WolcenDB: skill';
					}
				case 7:
					if ((_v1.b.$ === 3) && (_v1.c.$ === 3)) {
						var id = _v1.a.a;
						var lang = _v1.b.a;
						var dm = _v1.c.a;
						return 'WolcenDB: skill-variant: ' + A3($author$project$Page$SkillVariant$viewTitle, lang, dm, id);
					} else {
						return 'WolcenDB: skill-variant';
					}
				case 8:
					var _v5 = _v1.a;
					return 'WolcenDB: magic affixes and modifiers';
				case 9:
					var _v6 = _v1.a;
					return 'WolcenDB: gems';
				case 10:
					var _v7 = _v1.a;
					return 'WolcenDB: passive skill tree nodes';
				case 11:
					var _v8 = _v1.a;
					return 'WolcenDB: crafting reagents';
				case 12:
					return 'WolcenDB: endgame city rewards';
				case 13:
					var _v9 = _v1.a;
					return 'WolcenDB: ailments';
				case 14:
					var _v10 = _v1.a;
					return 'WolcenDB: view xml source file';
				case 15:
					var _v11 = _v1.a;
					return 'WolcenDB: view offline save file code (you dirty cheater, you)';
				case 16:
					return 'WolcenDB: search';
				case 17:
					return 'WolcenDB: raw tabular data';
				case 18:
					var _v12 = _v1.a;
					return 'WolcenDB: build revisions';
				case 19:
					var _v13 = _v1.a;
					return 'WolcenDB: languages';
				case 20:
					var _v14 = _v1.a;
					return 'WolcenDB: changelog';
				default:
					var _v15 = _v1.a;
					return 'WolcenDB: privacy';
			}
		}
	}
};
var $author$project$Main$view = function (model) {
	return {
		c7: A3(
			$author$project$Main$viewBody,
			{a8: false},
			model,
			model.n),
		ev: $author$project$Main$viewTitle(model)
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{dE: $author$project$Main$init, dY: $author$project$Main$OnUrlChange, dZ: $author$project$Main$OnUrlRequest, er: $author$project$Main$subscriptions, ey: $author$project$Main$update, eB: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (searchIndex) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (langs) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (datamine) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (changelog) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (buildRevisions) {
											return $elm$json$Json$Decode$succeed(
												{ay: buildRevisions, az: changelog, o: datamine, aG: langs, L: searchIndex});
										},
										A2(
											$elm$json$Json$Decode$field,
											'buildRevisions',
											$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
								},
								A2($elm$json$Json$Decode$field, 'changelog', $elm$json$Json$Decode$string));
						},
						A2(
							$elm$json$Json$Decode$field,
							'datamine',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value)
									]))));
				},
				A2(
					$elm$json$Json$Decode$field,
					'langs',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
		},
		A2(
			$elm$json$Json$Decode$field,
			'searchIndex',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value)
					])))))(0)}});}(this));